import { fetchGetProductionNcSetting } from '@/apis/materialList'
import { asyncPaiban, fetchAsyncPaiban } from '@/apis/paiban'
import { getPrelayoutSetting } from '@/apis/preLayoutSetting'
import { checkUserPermissions } from '@/auth/user_function'
import { USER_PERMISSION_KEY } from '@/data/auth'
import { CODE_PAUSE } from '@/data/constant'
import router from '@/router'
import store from '@/store'
import {
  dealProcessInEn,
  dealUnionPathSlots,
  deepCopy,
  generatorSideHoleSlot,
  getSawKnife,
  isSawPaiban,
} from '@/util/LayoutFuncs.js'
import { getBrandIdentity, isBrandRecord } from '@/util/brandPlankIdentity'
import EventBus from '@/util/bus'
import {
  calculateSlantedRectanglePath,
  genColorRes,
  judgeSourceData,
} from '@/util/commonFun'
import {
  fourTrimEdge,
  isOtherSideMachineHole,
  isOtherSideMachineSlot,
  isSideMachineMillInfo,
  judgeSurplusCutSmartSpeedUp,
} from '@/util/commonFuncs'
import { isBoundBoxOutsideCounter } from '@/util/counterLimit'
import { applyLastCutPoint } from '@/util/drawPlankFuncs.js'
import {
  compareNumbers,
  detectPotentialCollisionsScanline,
  isPathInside,
  isRectangleContained,
  judgeRectIntersect,
  rectToPath,
} from '@/util/graphCalc'
import {
  decompositePaibanResult,
  isTextureAlignmentPlank,
  isVirtualCompositePlank,
} from '@/util/plankAlignTexture'
import { dealPreLayoutSetting } from '@/views/materialsList/util/preLayoutDeal'
import { Message, Notification } from 'element-ui'
import _ from 'lodash'
import Vue from 'vue'

// import { allNoSaw, allSaw, mixedSaw } from './LayoutFuncs'
import {
  afterProcess,
  checkIsOnlyProcessHoleSlotByPaibanData,
  dealExpandPathForPart,
  matchOriginalPlankknife,
} from './LayoutTool.js'
import { rotate180Part } from './LayoutTool.js'
import { viewDataToNCData } from './NCGenerator.js'
import { EventBusKey } from './bus'
import { getPathBySplitXWithClipper } from './canvas/drawBigPlank'
import { translate } from './commonFun.js'
import { compareTowNum, dealNumber, toDecimal } from './commonFuncs.js'
import { clipperDifference, expandPath } from './dealPlankDataFuncs'
import {
  NESTING_TAG,
  expandParamsForDualNesting,
  findDualNestingFailure,
  isDualNestingEnabled,
  mergeDualNestingResults,
} from './paibanStrategy/dualNesting'
import {
  checkPathIsClosed,
  checkPlankOutlineKey,
  dealPathToBasePoint,
  flipPath,
  getEdgeLengthsFromLShape,
  getPathMinMaxPoint,
  getWHByPath,
  isLShapeSurplusBigPlank,
  isSpecialShapeSurplusBigPlank,
  judgePart1ContainPart2,
  judgeSlotIsRotate,
  rolloverPath,
  rotatePath,
  toUpperPointPath,
} from './plankCommonFuncs'
import {
  holeIsIntersect,
  polyContain,
  polyIntersect,
} from './polygonRelation.js'
import { recordTransform } from './recordTransform'
import {
  toLowerCasePoint,
  toUpperCasePoint,
  transformPathByDirection,
} from './transform/graph'

let NOTROTATELGAP = false
let sawKnivesDiameter = 0

export function checkArrayValueEqual(arr1, arr2) {
  return arr1.every((value, index) => value === arr2[index])
}

//通过颜色来判断当前坐标是否被绘制
export function isCanvasPixelDrawn(ctx, x, y) {
  const pixelData = ctx.getImageData(x, y, 1, 1).data
  const pixelDataColor = [
    pixelData[0],
    pixelData[1],
    pixelData[2],
    pixelData[3],
  ]
  const color1 = [238, 238, 238, 255]
  const color2 = [0, 0, 0, 0]
  const color3 = [230, 152, 163, 255]
  if (
    checkArrayValueEqual(pixelDataColor, color1) ||
    checkArrayValueEqual(pixelDataColor, color2) ||
    checkArrayValueEqual(pixelDataColor, color3)
  ) {
    return false // 浅灰色或白色 大板空白处或大板外颜色
  } else {
    // return pixelData[3] > 0 // 判断像素数据的透明度是否大于 0
    return true // 判断像素数据的透明度是否大于 0
  }
}
/**
 * 计算最大矩形
 * @param { Object } e 鼠标事件源
 * @param { Object } bigpart 大版信息
 * @param { Object } ctx canvas上下文
 * @returns
 */
export function computeMostRect(
  e,
  bigpart,
  ctx,
  topInfoHeight,
  deviation,
  gap,
  scalePercent,
  defaultScale
) {
  const scaleDeviation = (deviation / defaultScale) * scalePercent
  const scaleGap = (gap / defaultScale) * scalePercent
  let copyParams = {
    x: e.offsetX,
    y: e.offsetY,
  }
  const minX =
    (Math.min(...bigpart.bigPlank[0].map((item) => item.X)) / defaultScale) *
    scalePercent
  const minY =
    (Math.min(...bigpart.bigPlank[0].map((item) => item.Y)) / defaultScale) *
    scalePercent
  let data = {
    canvasData: {
      height:
        bigpart.subtleHeight + bigpart.subtleStartY + topInfoHeight + deviation,
      width: bigpart.subtleWidth + bigpart.subtleStartX + deviation,
      left: bigpart.subtleStartX,
      top: bigpart.subtleStartY,
    },
    limit: {
      up: bigpart.subtleStartY + topInfoHeight + deviation - 1,
      down:
        bigpart.subtleHeight +
        bigpart.subtleStartY +
        topInfoHeight +
        deviation +
        -1,
      left: bigpart.subtleStartX + deviation - 1,
      right: bigpart.subtleWidth + bigpart.subtleStartX + deviation - 1,
    },
    surplusmaterial: {
      startX: '',
      startY: '',
      width: '',
      height: '',
    },
  }
  //以y为轴向=================================================
  let rightDownXList = [] //右下所有的x坐标
  let leftDownXList = [] //左下所有的x坐标
  let rightUpXList = [] //右上所有的x坐标
  let leftUpXList = [] //右上所有的x坐标
  let starty = ''
  let startx = ''
  let widthY = ''
  let heightY
  let heightUp = ''
  let heightdwon = ''
  //右下
  for (let i = copyParams.y; i < data.canvasData.height; i++) {
    for (let k = copyParams.x; k < data.canvasData.width; k += 1) {
      let isIn1 = isCanvasPixelDrawn(ctx, k, i)
      if (k == data.limit.right) {
        rightDownXList.push(k + scaleDeviation + (minX > 0 ? -minX : minX))
        break
      } else if (isIn1) {
        rightDownXList.push(k - scaleGap)
        break
      }
    }
    let isIn = isCanvasPixelDrawn(ctx, copyParams.x, i)
    if (i == data.limit.down) {
      heightdwon = i + scaleDeviation + (minY > 0 ? -minY : minY)
      break
    } else if (isIn) {
      heightdwon = i - scaleGap
      break
    }
  }
  //左下
  for (let i = copyParams.y; i < data.canvasData.height; i++) {
    for (let k = copyParams.x; k > data.canvasData.left; k -= 1) {
      let isIn1 = isCanvasPixelDrawn(ctx, k, i)
      if (isIn1 && k == data.limit.left) {
        leftDownXList.push(k + scaleDeviation + minX)
        break
      } else if (isIn1) {
        leftDownXList.push(k + scaleGap)
        break
      }
    }
    let isIn = isCanvasPixelDrawn(ctx, copyParams.x, i)
    if (isIn || i == data.limit.down) break
  }
  //右上
  for (let i = copyParams.y; i > data.canvasData.top + 1; i--) {
    for (let k = copyParams.x; k <= data.canvasData.width + 1; k += 1) {
      let isIn1 = isCanvasPixelDrawn(ctx, k, i)
      if (k == data.limit.right) {
        rightUpXList.push(k + scaleDeviation + (minX > 0 ? -minX : minX))
        break
      } else if (isIn1) {
        rightUpXList.push(k - scaleGap)
        break
      }
    }
    let isIn = isCanvasPixelDrawn(ctx, copyParams.x, i)
    if (isIn && i == data.limit.up) {
      heightUp = i + scaleDeviation + minY
      break
    } else if (isIn) {
      heightUp = i + scaleGap
      break
    }
  }

  //左上
  for (let i = copyParams.y; i > data.canvasData.top; i--) {
    for (let k = copyParams.x; k > data.canvasData.left; k -= 1) {
      let isIn1 = isCanvasPixelDrawn(ctx, k, i)
      if (isIn1 && k == data.limit.left) {
        leftUpXList.push(k + scaleDeviation + minX)
        break
      } else if (isIn1) {
        leftUpXList.push(k + scaleGap)
        break
      }
    }
    let isIn = isCanvasPixelDrawn(ctx, copyParams.x, i)
    if (isIn && i == data.limit.up) {
      starty = i + scaleDeviation + minY
      break
    } else if (isIn) {
      starty = i + scaleGap
      break
    }
  }
  rightDownXList.pop()
  leftDownXList.pop()
  rightUpXList.pop()
  leftUpXList.pop()

  let leftDownListXSort = leftDownXList.sort((a, b) => b - a)[0]
  let leftUpListXSort = leftUpXList.sort((a, b) => b - a)[0]
  let cc =
    leftDownListXSort > leftUpListXSort ? leftDownListXSort : leftUpListXSort

  let rightDownListXSort = rightDownXList.sort((a, b) => a - b)[0]
  let rightUpListXSort = rightUpXList.sort((a, b) => a - b)[0]
  let dd =
    rightDownListXSort > rightUpListXSort
      ? rightUpListXSort
      : rightDownListXSort

  startx =
    leftDownListXSort > leftUpListXSort ? leftDownListXSort : leftUpListXSort //起始x点
  // starty =  //起始y点
  widthY = dd - cc //以y轴计算出来的矩形宽度
  heightY = heightdwon - heightUp //以y轴计算出来的矩形高度

  //以x为轴向=================================================
  let rightDownYList = [] //右下所有的y坐标
  let leftDownYList = [] //左下所有的y坐标
  let rightUpYList = [] //右上所有的y坐标
  let leftUpYList = [] //右上所有的y坐标

  let endX = '' //y的结束点
  let startX = '' //起始x点
  let startY = '' //起始x点
  let widthX = '' //以x轴计算出来的矩形宽度
  let heightX = '' //以x轴计算出来的矩形高度
  //右下
  for (let i = copyParams.x; i < data.canvasData.width; i++) {
    for (let k = copyParams.y; k < data.canvasData.height; k += 1) {
      let isIn1 = isCanvasPixelDrawn(ctx, i, k)
      if (k == data.limit.down) {
        rightDownYList.push(k + scaleDeviation + (minY > 0 ? -minY : minY))
        break
      } else if (isIn1) {
        rightDownYList.push(k - scaleGap)
        break
      }
    }
    let isIn = isCanvasPixelDrawn(ctx, i, copyParams.y)
    if (i == data.limit.right) {
      endX = i + scaleDeviation + (minX > 0 ? -minX : minX)
      break
    } else if (isIn) {
      endX = i - scaleGap
      break
    }
  }

  //左下
  for (let i = copyParams.x; i > data.canvasData.left; i--) {
    for (let k = copyParams.y; k < data.canvasData.height; k += 1) {
      let isIn1 = isCanvasPixelDrawn(ctx, i, k)
      if (k == data.limit.down) {
        leftDownYList.push(k + scaleDeviation + (minY > 0 ? -minY : minY))
        break
      } else if (isIn1) {
        leftDownYList.push(k + scaleGap)
        break
      }
    }
    let isIn = isCanvasPixelDrawn(ctx, i, copyParams.y)
    if (i == data.limit.left) {
      startX = i + scaleDeviation + minX
      break
    } else if (isIn) {
      startX = i + scaleGap
      break
    }
  }

  //右上
  for (let i = copyParams.x; i < data.canvasData.width; i++) {
    for (let k = copyParams.y; k > data.canvasData.top; k -= 1) {
      let isIn1 = isCanvasPixelDrawn(ctx, i, k)
      if (k == data.limit.up) {
        rightUpYList.push(k + scaleDeviation + minY)
        break
      } else if (isIn1) {
        rightUpYList.push(k - scaleGap)
        break
      }
    }
    let isIn = isCanvasPixelDrawn(ctx, i, copyParams.y)
    if (isIn || i == data.limit.right) break
  }

  //左上
  for (let i = copyParams.x; i > data.canvasData.left; i--) {
    for (let k = copyParams.y; k > data.canvasData.top; k -= 1) {
      let isIn1 = isCanvasPixelDrawn(ctx, i, k)
      if (k == data.limit.up) {
        leftUpYList.push(k + scaleDeviation + minY)
        break
      } else if (isIn1) {
        leftUpYList.push(k + scaleGap)
        break
      }
    }
    let isIn = isCanvasPixelDrawn(ctx, i, copyParams.y)
    if (isIn || i == data.limit.left) break
  }
  rightDownYList.pop()
  leftDownYList.pop()
  rightUpYList.pop()
  leftUpYList.pop()

  let leftUpListYSort = leftUpYList.sort((a, b) => b - a)[0]
  let rightUpListYSort = rightUpYList.sort((a, b) => b - a)[0]
  let aa =
    leftUpListYSort > rightUpListYSort ? leftUpListYSort : rightUpListYSort

  let leftDownListYSort = leftDownYList.sort((a, b) => a - b)[0]
  let rightDownListYSort = rightDownYList.sort((a, b) => a - b)[0]
  let bb =
    leftDownListYSort > rightDownListYSort
      ? rightDownListYSort
      : leftDownListYSort

  // startX = startX
  startY = aa
  widthX = endX - startX
  heightX = bb - aa

  let state =
    startX === startx && startY === starty
      ? widthY * heightY < widthX * heightX
      : widthY * heightY > widthX * heightX //y轴矩形是否大于x轴
  data.surplusmaterial.startX = state ? startx : startX
  data.surplusmaterial.startY = state ? starty : startY
  data.surplusmaterial.width = state ? widthY : widthX
  data.surplusmaterial.height = state ? heightY : heightX

  return data.surplusmaterial
}

/**
 * 以线段方式计算出最大矩形
 * @param {*} bigpart 大板
 * @param {*} mousePoint 鼠标点
 * @returns 裁剪出的余料坐标
 */
export function computeMostRectByLine(bigpart, mousePoint) {
  // 门套切割 排版间隙固定为0
  const ncSetting = store.state.ncSetting
  const isSawEnable = ncSetting.sawSetting.mentaoji_enable
  const isDoorFrame =
    isSawEnable &&
    ncSetting.sawSetting.processType === 'doorFrame' &&
    isSawPaiban(store)
  let sawGap = isDoorFrame ? 0 : ncSetting.sawSetting.sawBoardGap
  let layoutGap = bigpart.isUseSaw ? sawGap : ncSetting.panelSize.layoutGap

  if (judgeSurplusCutSmartSpeedUp(ncSetting)) {
    layoutGap = 0
    sawGap = 0
  }
  bigpart.parts = bigpart.parts.filter((item) => !item.blueAreaSurplus)
  // 大板点位
  const bigpartXPoint = bigpart.bigPlank[0].map((item) => item.X)
  const bigpartYPoint = bigpart.bigPlank[0].map((item) => item.Y)
  // 鼠标点到大板边横线（默认为矩形板，L形大板下方单独计算处理）
  let hLine = [
    { x: Math.min(...bigpartXPoint), y: mousePoint.y },
    { x: Math.max(...bigpartXPoint), y: mousePoint.y },
  ]
  // 鼠标点到大板边竖线
  let vLine = [
    { x: mousePoint.x, y: Math.min(...bigpartYPoint) },
    {
      x: mousePoint.x,
      y: Math.max(...bigpartYPoint),
    },
  ]
  let surplus = bigpart.surplusInfo
  // L形余料大板
  if (['lshape', 'specialShape'].includes(surplus?.shape)) {
    bigpart.hLine = []
    bigpart.vLine = []
    // 各个方向的交点列表
    const bigpartVTopInterPointList = []
    const bigpartVBottomInterPointList = []
    const bigpartHLeftInterPointList = []
    const bigpartHRightInterPointList = []
    for (let i = 0; i < bigpart.bigPlank[0].length; i++) {
      const outerPoint = bigpart.bigPlank[0][i]
      for (let j = i + 1; j < bigpart.bigPlank[0].length; j++) {
        const innerPoint = bigpart.bigPlank[0][j]
        // L形大板横线
        if (compareNumbers(outerPoint.Y, innerPoint.Y, '=')) {
          let bigpartHLine = [
            { x: outerPoint.X, y: outerPoint.Y },
            { x: innerPoint.X, y: innerPoint.Y },
          ]
          bigpart.hLine.push(bigpartHLine)
          const intersectedPointArr = bigpart.hLine.map((line) => {
            return getIntersectionPoint(
              getLineEquationFromPoints(vLine),
              getLineEquationFromPoints(line)
            )
          })
          /** 鼠标点上方交点 */
          const upPointArr = intersectedPointArr
            .filter((point) => point && point.y < mousePoint.y)
            .sort((a, b) => b.y - a.y) // 从大到小排列上方交点
          /** 鼠标点下方交点 */
          const downPointArr = intersectedPointArr
            .filter((point) => point && point.y > mousePoint.y)
            .sort((a, b) => a.y - b.y) // 从小到大排列下方交点
          if (upPointArr.length) {
            for (let i = 0; i < upPointArr.length; i++) {
              const point = upPointArr[i]
              // 找到交点所在横线
              const hoLine = bigpart.hLine.find((line) => line[0].y === point.y)
              if (
                hoLine &&
                vLine[0].x >= Math.min(...hoLine.map((item) => item.x)) &&
                vLine[0].x <= Math.max(...hoLine.map((item) => item.x))
              ) {
                bigpartVTopInterPointList.push(point)
                break
              }
            }
          }
          if (downPointArr.length) {
            for (let i = 0; i < downPointArr.length; i++) {
              const point = downPointArr[i]
              // 找到交点所在横线
              const hoLine = bigpart.hLine.find((line) => line[0].y === point.y)
              if (
                hoLine &&
                vLine[0].x >= Math.min(...hoLine.map((item) => item.x)) &&
                vLine[0].x <= Math.max(...hoLine.map((item) => item.x))
              ) {
                bigpartVBottomInterPointList.push(point)
                break
              }
            }
          }
        }
        // L形大板竖线
        if (compareNumbers(outerPoint.X, innerPoint.X, '=')) {
          let bigpartVLine = [
            { x: outerPoint.X, y: outerPoint.Y },
            { x: outerPoint.X, y: innerPoint.Y },
          ]
          bigpart.vLine.push(bigpartVLine)

          const bigpartHInterPointList = bigpart.vLine.map((line) => {
            return getIntersectionPoint(
              getLineEquationFromPoints(hLine),
              getLineEquationFromPoints(line)
            )
          })
          /** 鼠标点左侧交点 */
          const leftPointArr = bigpartHInterPointList
            .filter((point) => point && point.x < mousePoint.x)
            .sort((a, b) => b.x - a.x) // 从大到小排列左侧交点
          /** 鼠标点右侧交点 */
          const rightPointArr = bigpartHInterPointList
            .filter((point) => point && point.x > mousePoint.x)
            .sort((a, b) => a.x - b.x) // 从小到大排列右侧交点
          if (leftPointArr.length) {
            // 找到真正相交的点，且在横线范围内
            for (let i = 0; i < leftPointArr.length; i++) {
              const point = leftPointArr[i]
              const voLine = bigpart.vLine.find((line) => line[0].x === point.x)
              if (
                voLine &&
                hLine[0].y >= Math.min(...voLine.map((item) => item.y)) &&
                hLine[0].y <= Math.max(...voLine.map((item) => item.y))
              ) {
                bigpartHLeftInterPointList.push(point)
                break
              }
            }
          }
          if (rightPointArr.length) {
            // 找到真正相交的点，且在横线范围内
            for (let i = 0; i < rightPointArr.length; i++) {
              const point = rightPointArr[i]
              const voLine = bigpart.vLine.find((line) => line[0].x === point.x)
              if (
                voLine &&
                hLine[0].y >= Math.min(...voLine.map((item) => item.y)) &&
                hLine[0].y <= Math.max(...voLine.map((item) => item.y))
              ) {
                bigpartHRightInterPointList.push(point)
                break
              }
            }
          }
        }
      }
    }
    // 根据与大板各方向的交点 计算出不超出大板范围的横线、竖线
    if (bigpartVTopInterPointList.length) {
      let yArr = bigpartVTopInterPointList.map((item) => item.y)
      vLine[0].y = Math.max(...yArr)
    }
    if (bigpartVBottomInterPointList.length) {
      let yArr = bigpartVBottomInterPointList.map((item) => item.y)
      vLine[1].y = Math.min(...yArr)
    }
    if (bigpartHLeftInterPointList.length) {
      let xArr = bigpartHLeftInterPointList.map((item) => item.x)
      hLine[0].x = Math.max(...xArr)
    }
    if (bigpartHRightInterPointList.length) {
      let xArr = bigpartHRightInterPointList.map((item) => item.x)
      hLine[1].x = Math.min(...xArr)
    }
  }
  // 各个方向的交点列表
  const hTopInterPointList = []
  const hBottomInterPointList = []
  const hLeftInterPointList = []
  const hRightInterPointList = []
  for (let i = 0; i < bigpart.parts.length; i++) {
    const part = bigpart.parts[i]
    // 鼠标点上方或小板长度范围内横线
    if (
      part.startY + part.rect.height <= mousePoint.y ||
      (mousePoint.y > part.startY &&
        mousePoint.y < part.startY + part.rect.height)
    ) {
      if (part.startY + part.rect.height <= mousePoint.y) {
        part.hLine = [
          { x: part.startX, y: part.startY + part.rect.height },
          {
            x: part.startX + part.rect.width,
            y: part.startY + part.rect.height,
          },
        ]
      } else {
        part.hLine = [
          { x: part.startX, y: mousePoint.y },
          { x: part.startX + part.rect.width, y: mousePoint.y },
        ]
      }
      const hTopInterPoint = getIntersectionPoint(
        getLineEquationFromPoints(vLine),
        getLineEquationFromPoints(part.hLine)
      )
      if (
        hTopInterPoint &&
        vLine[0].x >= part.hLine[0].x &&
        vLine[0].x <= part.hLine[1].x
      ) {
        hTopInterPointList.push(hTopInterPoint)
      }
    }

    // 鼠标点下方横线
    if (mousePoint.y <= part.startY) {
      part.hLine = [
        { x: part.startX, y: part.startY },
        { x: part.startX + part.rect.width, y: part.startY },
      ]
      const hBottomInterPoint = getIntersectionPoint(
        getLineEquationFromPoints(vLine),
        getLineEquationFromPoints(part.hLine)
      )
      if (
        hBottomInterPoint &&
        vLine[0].x >= part.hLine[0].x &&
        vLine[0].x <= part.hLine[1].x
      ) {
        hBottomInterPointList.push(hBottomInterPoint)
      }
    }

    // 鼠标点左侧或小板宽度范围内竖线
    if (
      part.startX + part.rect.width <= mousePoint.x ||
      (mousePoint.x > part.startX &&
        mousePoint.x < part.startX + part.rect.width)
    ) {
      if (part.startX + part.rect.width <= mousePoint.x) {
        part.vLine = [
          { x: part.startX + part.rect.width, y: part.startY },
          {
            x: part.startX + part.rect.width,
            y: part.startY + part.rect.height,
          },
        ]
      } else {
        part.vLine = [
          { x: mousePoint.x, y: part.startY },
          { x: mousePoint.x, y: part.startY + part.rect.height },
        ]
      }

      const hLeftInterPoint = getIntersectionPoint(
        getLineEquationFromPoints(hLine),
        getLineEquationFromPoints(part.vLine)
      )
      if (
        hLeftInterPoint &&
        hLine[0].y >= part.vLine[0].y &&
        hLine[0].y <= part.vLine[1].y
      ) {
        hLeftInterPointList.push(hLeftInterPoint)
      }
    }

    // 鼠标点右侧竖线
    if (part.startX >= mousePoint.x) {
      part.vLine = [
        { x: part.startX, y: part.startY },
        { x: part.startX, y: part.startY + part.rect.height },
      ]
      const hRightInterPoint = getIntersectionPoint(
        getLineEquationFromPoints(hLine),
        getLineEquationFromPoints(part.vLine)
      )
      if (
        hRightInterPoint &&
        hLine[0].y >= part.vLine[0].y &&
        hLine[0].y <= part.vLine[1].y
      ) {
        hRightInterPointList.push(hRightInterPoint)
      }
    }

    // 鼠标点在异形部分
    if (
      part.startX <= mousePoint.x &&
      mousePoint.x <= part.startX + part.rect.width &&
      part.startY <= mousePoint.y &&
      mousePoint.y <= part.startY + part.rect.height
    ) {
      // 异形部分不能裁剪矩形
      Vue.prototype.$message.warning(
        translate('arrangedPage.subtlePage.noCutPath')
      )
      return
    }
  }
  if (hTopInterPointList.length) {
    let yArr = hTopInterPointList.map((item) => item.y)
    const maxY = Math.max(...yArr)
    if (vLine[0].y < maxY) {
      vLine[0].y = maxY + layoutGap
    }
  }
  if (hBottomInterPointList.length) {
    let yArr = hBottomInterPointList.map((item) => item.y)
    const minY = Math.min(...yArr)
    if (vLine[1].y > minY) {
      vLine[1].y = minY - layoutGap
    }
  }
  if (hLeftInterPointList.length) {
    let xArr = hLeftInterPointList.map((item) => item.x)
    const maxX = Math.max(...xArr)
    if (hLine[0].x < maxX) {
      hLine[0].x = maxX + layoutGap
    }
  }
  if (hRightInterPointList.length) {
    let xArr = hRightInterPointList.map((item) => item.x)
    const minX = Math.min(...xArr)
    if (hLine[1].x > minX) {
      hLine[1].x = minX - layoutGap
    }
  }

  // 竖线范围内与小板横线有重合的横线
  const hLineYLimit = bigpart.parts
    .filter(
      (item) =>
        item.hLine[0].y >= vLine[0].y &&
        item.hLine[0].y <= vLine[1].y &&
        (item.hLine[1].x > hLine[0].x ||
          item.hLine[0].x < hLine[1].x ||
          (item.hLine[0].x >= hLine[0].x && item.hLine[1].x <= hLine[1].x))
    )
    .map((part) => part.hLine)
  // 竖线范围内与大板横线有重合的横线（主要是L形）
  const bigpartHLineYLimit = bigpart.hLine?.filter((item) => {
    const minY = Math.min(...item.map((point) => point.y))
    const minX = Math.min(...item.map((point) => point.x))
    const maxX = Math.max(...item.map((point) => point.x))
    return (
      minY >= vLine[0].y &&
      minY <= vLine[1].y &&
      (maxX > hLine[0].x ||
        minX < hLine[1].x ||
        (minX >= hLine[0].x && maxX <= hLine[1].x))
    )
  })
  if (bigpartHLineYLimit && bigpartHLineYLimit.length) {
    hLineYLimit.push(...bigpartHLineYLimit)
  }
  const hLineLeftYLimit = hLineYLimit.filter(
    (item) => Math.max(...item.map((point) => point.x)) <= mousePoint.x
  )
  const hLineRightYLimit = hLineYLimit.filter(
    (item) => Math.min(...item.map((point) => point.x)) > mousePoint.x
  )

  // 最小横线
  const hLineMin = JSON.parse(JSON.stringify(hLine))
  if (hLineLeftYLimit.length) {
    const xArr = hLineLeftYLimit.flat(1).map((item) => item.x)
    // 大板边缘不加间隙
    if (Math.max(...xArr) < Math.max(...bigpartXPoint)) {
      hLineMin[0].x = Math.max(...xArr) + layoutGap
    }
  }
  if (hLineRightYLimit.length) {
    const xArr = hLineRightYLimit.flat(1).map((item) => item.x)
    // 大板边缘不加间隙
    if (Math.min(...xArr) > Math.min(...bigpartXPoint)) {
      hLineMin[1].x = Math.min(...xArr) - layoutGap
    }
  }
  // 最小横线扫描矩形面积
  const minHLineAre =
    (hLineMin[1].x - hLineMin[0].x) * (vLine[1].y - vLine[0].y)

  const vLineXLimit = bigpart.parts
    .filter(
      (item) =>
        item.vLine[0].x >= hLine[0].x &&
        item.vLine[0].x <= hLine[1].x &&
        (item.vLine[1].y >= vLine[0].y ||
          item.vLine[0].y <= vLine[1].y ||
          (item.vLine[0].y >= vLine[0].y && item.vLine[1].y <= vLine[1].y))
    )
    .map((part) => part.vLine)
  const bigpartVLineYLimit = bigpart.vLine?.filter((item) => {
    const minX = Math.min(...item.map((point) => point.x))
    const minY = Math.min(...item.map((point) => point.y))
    const maxY = Math.max(...item.map((point) => point.y))
    return (
      minX >= hLine[0].x - layoutGap &&
      minX <= hLine[1].x + layoutGap &&
      (maxY >= vLine[0].y - layoutGap ||
        minY <= vLine[1].y + layoutGap ||
        (minY >= vLine[0].y && maxY <= vLine[1].y))
    )
  })
  if (bigpartVLineYLimit && bigpartVLineYLimit.length) {
    vLineXLimit.push(...bigpartVLineYLimit)
  }
  const vLineTopYLimit = vLineXLimit.filter(
    (item) => Math.max(...item.map((point) => point.y)) <= mousePoint.y
  )
  const vLineBottomYLimit = vLineXLimit.filter(
    (item) => Math.min(...item.map((point) => point.y)) > mousePoint.y
  )
  // 最小竖线
  const vLineMin = JSON.parse(JSON.stringify(vLine))
  if (vLineTopYLimit.length) {
    const yArr = vLineTopYLimit.flat(1).map((item) => item.y)
    // 大板边缘不加间隙
    if (Math.max(...yArr) < Math.max(...bigpartYPoint)) {
      vLineMin[0].y = Math.max(...yArr) + layoutGap
    }
  }
  if (vLineBottomYLimit.length) {
    const yArr = vLineBottomYLimit.flat(1).map((item) => item.y)
    // 大板边缘不加间隙
    if (Math.min(...yArr) > Math.min(...bigpartYPoint)) {
      vLineMin[1].y = Math.min(...yArr) - layoutGap
    }
  }
  // 最小横线扫描矩形面积
  const minVLineAre =
    (hLine[1].x - hLine[0].x) * (vLineMin[1].y - vLineMin[0].y)

  // 取最大面积
  if (minHLineAre >= minVLineAre) {
    hLine = hLineMin
  } else {
    vLine = vLineMin
  }

  const surplusPoint = [
    // 左上
    { x: hLine[0].x, y: vLine[0].y },
    // 左下
    { x: hLine[0].x, y: vLine[1].y },
    // 右下
    { x: hLine[1].x, y: vLine[1].y },
    // 右上
    { x: hLine[1].x, y: vLine[0].y },
  ]
  return surplusPoint
}

/**
 * 获取直线方程式
 * @param {*} line 直线 两点坐标
 */
function getLineEquationFromPoints(line) {
  const { x: x1, y: y1 } = line[0]
  const { x: x2, y: y2 } = line[1]

  // 计算斜率
  const slope = (y2 - y1) / (x2 - x1)

  // 处理垂直直线的情况
  if (x2 == x1) {
    return { A: 1, B: 0, C: -x1 }
  } else {
    // 使用斜率来计算A，B，C
    const A = -slope
    const B = 1
    const C = -(A * x1 + B * y1)
    return { A, B, C }
  }
}

/**
 * 获取交点坐标
 * 这个方法把线段进行了延伸 所以最终使用时 要判断是否在线段范围内
 * @param {*} line1
 * @param {*} line2
 */
function getIntersectionPoint(line1, line2) {
  const { A: A1, B: B1, C: C1 } = line1
  const { A: A2, B: B2, C: C2 } = line2

  // 计算行列式
  const determinant = A1 * B2 - A2 * B1

  // 如果行列式为0，则直线平行或重合，没有交点
  if (determinant === 0) {
    return null
  }

  // 计算交点坐标
  const x = (B2 * C1 - B1 * C2) / determinant
  const y = (A1 * C2 - A2 * C1) / determinant
  return { x: Math.abs(x), y: Math.abs(y) }
}

/**
 *
 * @param { Object -> Array } param 请求接口的参数 -> 现所有参数改为数组方式
 * @param { Array } preData 预处理数据
 * @param { String } type 选择的排版方式(最高优化率, 紧凑排版, 少翻板)
 * @param { Boolean } needSave 是否需要重新保存数据
 * @param { Boolean } isHistory 是否需要切换历史记录的状态
 * @param { Boolean } needMorePlan 是否需要多方案排版
 * @param { Boolean } isReLayout 是否为重新排版
 * @param { Boolean } scattered_layout 是否为分散排版
 * @param { Object } layoutConfig 对排版结果有影响的数据排版大板长宽/以及其他数据
 * @returns
 */
export function dealPaibanData(
  paramArr,
  preData,
  type = 'paiban_v2',
  needSave = true,
  isHistory = false,
  needMorePlan = false,
  isReLayout = false,
  scattered_layout = false,
  safe_length = [0, 0],
  layoutConfig = {}
) {
  return new Promise(async (resolve) => {
    // 重新排版时剔除余料板件
    preData = preData.filter((part) => !part.specialType)
    if (needSave) {
      store.commit('setPrePaibanData', JSON.parse(JSON.stringify(preData)))
    }
    const ncSettings = store.state.ncSetting
    let isThinkerxMaterial = false
    const customPlankOrder = store.state.customPlankOrder
    const isPreLayout = store.state.ncSetting.isPreLayout
    const knives = isPreLayout
      ? store.state.preLayoutSetting.setting_value.knife.diameter
      : store.state.ncSetting.knife.diameter
    const { scattered_layout = false, safe_length } = isPreLayout
      ? store.state.preLayoutSetting.setting_value.movePlankSetting
      : store.state.ncSetting.movePlankSetting
    let minWidth, minHeight
    ;[minWidth, minHeight] = safe_length
    const isJinxiPaiban = router.currentRoute.query?.is_jinxi_paiban === '1'
    const sawCutOnlyWeld =
      store.state.ncSetting.sawSetting.sawCutOnlyWeld &&
      store.state.ncSetting.sawSetting.mentaoji_enable &&
      store.state.ncSetting.sawSetting.sawToLayout &&
      store.state.ncSetting.sawSetting.processType === 'weldingPlank'
    const sawToLayout =
      store.state.ncSetting.sawSetting.mentaoji_enable &&
      store.state.ncSetting.sawSetting.sawToLayout &&
      store.state.ncSetting.sawSetting.processType === 'weldingPlank'
    paramArr.forEach((param) => {
      if (sessionStorage.getItem('thinkerx_material')) {
        param.data['from'] = '门窗erp'
        isThinkerxMaterial && (isThinkerxMaterial = true)
      }
      // 都可以拥有多种方案
      if (!customPlankOrder) {
        param.data.is_plural = true
      }
    })
    const types = ['paiban_v2', 'paiban_roll_v2']
    // 离线排版完成次数
    let finishCount = 0
    // 离线排版结果
    let offlineRes = []
    // 在线排版结果
    let onlineRes = []
    // 是否离线排版
    let isOfflinePaiban = false
    // 获取接口请求
    const isWebQT =
      window.webToQt && types.includes(type) && window.webToQt.layout

    // 如果是排版任务点击打开排版页面，则直接返回结果
    if (layoutConfig.isPaibanTask) {
      callBack(
        layoutConfig.resultData.map((res) => ({ data: res, status: 200 }))
      )
      return
    }
    // 内嵌离线排版生效条件  尊享版
    const ggver = sessionStorage.getItem('guigui_version') ?? ''

    const GGV = Number(
      (window.webToQt?.ggVersion ?? ggver).split('-')[0].split('.').join('')
    )
    const hasDeepSearchPermission = Boolean(window.webToQt?.expressVip)
    // (window.webToQt && GGV >= 5005) || Boolean(window.webToQt?.expressVip)
    if (isWebQT && hasDeepSearchPermission) {
      isOfflinePaiban = true
      const offlineResArr = []

      if (!paramArr.length) {
        callBack([])
      } else {
        // 只 connect 一次；forEach 全部发起 layout；轮询收齐后 disconnect
        const finishedCallback = (res) => {
          try {
            offlineResArr.push(typeof res === 'string' ? JSON.parse(res) : res)
          } catch (e) {
            console.error('parse offline layout result failed', e)
            offlineResArr.push(res)
          }
        }

        window.webToQt.layoutFinished.connect(finishedCallback)

        paramArr.forEach((param) => {
          window.webToQt.layout({
            data: param.data,
            type,
          })
        })

        const timer = setInterval(() => {
          if (offlineResArr.length !== paramArr.length) {
            return
          }
          clearInterval(timer)
          if (window.webToQt?.layoutFinished) {
            window.webToQt.layoutFinished.disconnect(finishedCallback)
          }
          callBack(offlineResArr)
        }, 100)
      }
    } else {
      const newParamArr = splitPlanksByWeldingType(
        paramArr,
        sawCutOnlyWeld,
        knives
      )
      isOfflinePaiban = false
      let promise
      const taskDataArr = []

      const isDualNesting =
        isDualNestingEnabled(newParamArr) &&
        !(layoutConfig && layoutConfig.isCreateTask)
      // 高级嵌套开启时同时发起 高级/普通/未开启异形嵌套 三份请求，结果回来后按材质取用量更少的方案
      const expandedParams = isDualNesting
        ? expandParamsForDualNesting(newParamArr, type)
        : newParamArr.map((p) => ({ ...p, _tag: NESTING_TAG.SENIOR }))

      const taskIdToTag = new Map()

      promise = expandedParams.map(({ data, _tag }) => {
        let actualType = type
        if (sawCutOnlyWeld) {
          // 开启了 锯片只排焊接板 后, 不管选择的什么排版方式，普通版 =>直切  焊接板 => 锯切
          const hasRoll = type.includes('_roll')
          const suffix = data.isWeldingPlank ? '' : '_v2'
          actualType = `paiban${hasRoll ? '_roll' : ''}${suffix}`
        }
        taskDataArr.push({ data, type: actualType })
        if (layoutConfig && layoutConfig.isCreateTask) {
          return
        }
        return asyncPaiban({ data, type: actualType }).then((res) => {
          const taskId = res.data?.task_id || res.task_id
          if (taskId) taskIdToTag.set(taskId, _tag)
          return res
        })
      })
      if (layoutConfig && layoutConfig.isCreateTask) {
        resolve(taskDataArr)
        return
      }
      // const promise = paramArr.map(({ data }) => getPaiban({ data, type }))
      // 发起所有材质的请求
      // Promise.all(promise).then((res) => {
      //   callBack(res)
      // })
      /** 全部任务 */
      let resArr = await Promise.all(promise)
      // callBack(resArr)

      /** 正在 padding 中的task_id */
      let paddingTaskIdList = []

      /** 记录超时的请求接口 */
      let timeOutTaskIdMap = {}

      function checkIsFinishTask(res) {
        const isFinishTask = ![3, 4, 6].includes(Number(res.code))
        /**  超时不超过3次的task */
        const isTimeOutEnd =
          res.code == 6
            ? timeOutTaskIdMap[res.data.task_id] &&
              timeOutTaskIdMap[res.data.task_id] > 3
            : [3, 4].includes(Number(res.code))
            ? false
            : true

        return isFinishTask || isTimeOutEnd
      }

      const awaitPromise = new Promise(async (resolve) => {
        /** 已完成的 task */
        const resultArr = resArr.filter((res) => {
          return checkIsFinishTask(res)
        })
        // 记录超时次数
        function staticTimeOutTask(resList) {
          resList
            .filter((res) => Number(res.code) == 6)
            .forEach((res) => {
              const taskId = res.data.task_id
              if (timeOutTaskIdMap[taskId]) {
                timeOutTaskIdMap[taskId] += 1
              } else {
                timeOutTaskIdMap[taskId] = 1
              }
            })
        }
        staticTimeOutTask(resArr)

        let interval = setInterval(async () => {
          /** 已完成的 task_id 列表 */
          const resultTaskIDArr = resultArr.map(
            (res) => res.data?.task_id || res.task_id
          )
          /** 排队中的 Task */
          const waittingTaskArr = resArr.filter(
            (res) => !resultTaskIDArr.includes(res.data?.task_id || res.task_id)
          )
          /** 是否有排队中任务 */
          let hasWaittingTask = Boolean(waittingTaskArr.length)
          if (hasWaittingTask) {
            /** 不在 Padding 中的 task */
            const notPaddingTaskList = waittingTaskArr.filter(
              (re) =>
                !paddingTaskIdList.includes(re.data?.task_id || re.task_id)
            )
            /** 不在 Padding 中的任务 */
            const promiseArr = notPaddingTaskList.map((res) =>
              fetchAsyncPaiban({
                task_id: res.data?.task_id || res.task_id,
                otherPlateSize: res.otherPlateSize,
              })
            )
            /** 加入 padding 列表记录 task_id  */
            paddingTaskIdList = paddingTaskIdList.concat(
              notPaddingTaskList.map(
                (task) => task.data?.task_id || task.task_id
              )
            )

            /** 本次完成的 task 结果 */
            const newResArr = await Promise.all(promiseArr)
            /** 已完成 task_id */
            const finishTaskIdList = newResArr.map(
              (res) => res.task_id ?? res.data?.task_id
            )
            paddingTaskIdList = paddingTaskIdList.filter(
              (id) => !finishTaskIdList.includes(id)
            )
            /** 再次统计超时次数 */
            staticTimeOutTask(newResArr)
            /** 将成功的结果 push 进最终的结果列表 */
            newResArr.forEach((res) => {
              if (checkIsFinishTask(res)) resultArr.push(res)
            })
            if (resultArr.length == resArr.length) {
              clearInterval(interval)
              resolve(resultArr)
            }
          } else {
            clearInterval(interval)
            resolve(resultArr)
          }
        }, 2000)
      })

      const result = await awaitPromise

      if (isDualNesting) {
        // 多方案对比中只要有任意一个方案失败（传输层失败 / 轮询超时耗尽），整体按失败处理，
        // 不再静默降级为「取其余方案中较优的」；复用下方 code == 2 的错误分支提示并 resolve(false)
        const failure = findDualNestingFailure(result)
        if (failure) {
          console.error('[多方案排版] 排版请求失败：', failure.result)
          callBack([
            {
              data: {
                code: 2,
                msg: translate('arrangedPage.paibanRequestFailed'),
              },
              status: 200,
            },
          ])
        } else {
          const merged = mergeDualNestingResults(result, taskIdToTag)
          callBack(merged.map((r) => ({ data: r, status: 200 })))
        }
      } else {
        callBack(result.map((r) => ({ data: r, status: 200 })))
      }
    }

    function callBack(result) {
      if (isOfflinePaiban) {
        offlineRes = result.map((res) => ({ ...res }))
      } else {
        onlineRes = result.map((res) => res.data)
      }
      const resArr = isOfflinePaiban ? offlineRes : onlineRes
      // 获取code
      const code = Math.max(...resArr.map((it) => it.code))
      // 获取板件数据
      let resultData = (isOfflinePaiban ? offlineRes : onlineRes).reduce(
        (pre, cut) => ({ ...pre, ...cut.result_data }),
        {}
      )

      if (code == 1) {
        // 尊享版：分材质激活；非尊享：组合方案整套展示/切换
        const isExpressVip = Boolean(window.webToQt?.expressVip)

        let resultPlans = dealAlignedPlan(resultData)
        resultPlans.forEach((plan) => {
          checkPlanks(plan, minWidth, minHeight, knives)
        })
        if (resultPlans && resultPlans.length) {
          sortPlans(resultPlans, type, scattered_layout)
        }

        let resultPlansObj = null
        let matKeys = []
        let currentUsingSpecialIdMap = {}
        let primarySpecialId

        if (isExpressVip) {
          resultPlansObj = dealPlanksForMatCode(resultData, {
            minWidth,
            minHeight,
            knives,
            type,
            scattered_layout,
          })
          store.commit('paibanStore/setResultPlansObj', resultPlansObj)
          // 非 QT：第 0 个；QT 有权限：深度方案；QT 无权限：最靠前的非深度方案
          const hasDeepSearchPermission =
            checkUserPermissions([USER_PERMISSION_KEY.DEEP_SEARCH]) == true
          const isPlanDeepSearch = (plan) =>
            !!(plan?.isDeepSearch || plan?.data?.isDeepSearch)
          const getDefaultUsePlan = (plans) => {
            if (!plans?.length) {
              return undefined
            }
            if (!isWebQT) {
              return plans[0]
            }
            if (hasDeepSearchPermission) {
              return plans.find((plan) => isPlanDeepSearch(plan)) || plans[0]
            }
            return plans.find((plan) => !isPlanDeepSearch(plan)) || plans[0]
          }
          matKeys = Object.keys(resultPlansObj)
          matKeys.forEach((matKey) => {
            const plans = resultPlansObj[matKey] || []
            const usePlan = getDefaultUsePlan(plans)
            if (usePlan?.specialId) {
              currentUsingSpecialIdMap[matKey] = usePlan.specialId
            }
          })
          primarySpecialId = currentUsingSpecialIdMap[matKeys[0]]
          // 按各材质默认激活方案组装首屏，与更多结果应用同源
          const combinedFromMatPlans = {}
          let combinedIsGreatPlan = true
          let combinedIsDeepSearch = false
          matKeys.forEach((matKey) => {
            const plans = resultPlansObj[matKey] || []
            const activeId = currentUsingSpecialIdMap[matKey]
            const plan =
              plans.find(
                (item) => String(item.specialId) === String(activeId)
              ) || getDefaultUsePlan(plans)
            if (!plan) {
              return
            }
            const planData = plan.data || plan
            if (planData[matKey]) {
              combinedFromMatPlans[matKey] = _.cloneDeep(planData[matKey])
            }
            if (!plan.isGreatPlan) {
              combinedIsGreatPlan = false
            }
            if (plan.isDeepSearch) {
              combinedIsDeepSearch = true
            }
          })
          Object.defineProperty(combinedFromMatPlans, 'isGreatPlan', {
            value: combinedIsGreatPlan,
            enumerable: false,
            configurable: true,
          })
          Object.defineProperty(combinedFromMatPlans, 'isDeepSearch', {
            value: combinedIsDeepSearch,
            enumerable: false,
            configurable: true,
          })
          if (Object.keys(combinedFromMatPlans).length) {
            resultData = combinedFromMatPlans
          } else if (Array.isArray(resultPlans) && resultPlans.length) {
            resultData = resultPlans[0]
          }
        } else {
          // 非尊享：清空分材质数据，首屏用组合方案第 1 套
          store.commit('paibanStore/setResultPlansObj', null)
          store.commit('paibanStore/setCurrentUsingSpecialIdMap', {})
          if (Array.isArray(resultPlans) && resultPlans.length) {
            resultData = resultPlans[0]
          }
        }

        // 玻璃切割机 / 组合方案列表需要将数据保存，用作方案切换
        let glassResult, allResult
        // 固化首次组合原始方案（paibanDataToView 会原地改 rect）
        const rawPlanDataSnapshot = _.cloneDeep(resultData)
        if (!(customPlankOrder && scattered_layout)) {
          glassResult = allResult = _.cloneDeep(resultPlans).map((it, idx) => {
            checkPlanks(it, minWidth, minHeight, knives)
            const obj = {
              specialId: new Date().getTime() + (idx + 1),
              data: it,
              isGreatPlan: it.isGreatPlan,
              isDeepSearch: it.isDeepSearch,
            }
            return obj
          })
          // 非尊享：更多结果用组合方案列表；尊享：分材质 tabs，清空组合列表
          if (!isJinxiPaiban) {
            store.commit(
              'paibanStore/setPaibanDataCollect',
              isExpressVip ? [] : glassResult
            )
          }
          store.commit('paibanStore/setSubPaibanDataCollect', allResult)
          // 排版后将预处理数据保存，精细排版的重新排版不需要保存预处理数据
          store.commit(
            'paibanStore/setPrePaibanData',
            JSON.parse(JSON.stringify(preData))
          )
        }
        // 处理排版数据
        paibanDataToView(
          preData,
          resultData,
          needSave,
          isHistory,
          needMorePlan,
          layoutConfig
        ).then((paibanData) => {
          resolve(paibanData)
          // 玻璃切割机保存第一个排版后处理的数据
          let specialId
          if (!(customPlankOrder && scattered_layout)) {
            specialId = glassResult[0].specialId
            if (!isJinxiPaiban) {
              store.commit(
                'paibanStore/setCurrentRawPlanData',
                rawPlanDataSnapshot
              )
              if (isExpressVip) {
                // 按各材质默认激活方案组合缓存，与更多结果整体应用的 cacheKey 对齐
                const combinedCacheKey = matKeys
                  .slice()
                  .sort()
                  .map((matKey) => currentUsingSpecialIdMap[matKey])
                  .filter(Boolean)
                  .join('||')
                if (combinedCacheKey) {
                  store.commit('paibanStore/setAlreadyDealDrawData', {
                    specialId: combinedCacheKey,
                    value: JSON.parse(
                      JSON.stringify({
                        paibanData,
                        rawPlanData: rawPlanDataSnapshot,
                      })
                    ),
                  })
                }
                store.commit(
                  'paibanStore/setCurrentUsingSpecialId',
                  primarySpecialId || specialId
                )
                store.commit(
                  'paibanStore/setCurrentUsingSpecialIdMap',
                  currentUsingSpecialIdMap
                )
              } else {
                // 组合方案：缓存 key 即 specialId
                store.commit('paibanStore/setAlreadyDealDrawData', {
                  specialId,
                  value: JSON.parse(
                    JSON.stringify({
                      paibanData,
                      rawPlanData: rawPlanDataSnapshot,
                    })
                  ),
                })
                store.commit(
                  'paibanStore/setCurrentUsingSpecialId',
                  specialId
                )
                store.commit('paibanStore/setCurrentUsingSpecialIdMap', {})
              }
            }
            store.commit('paibanStore/setSubAlreadyDealDrawData', {
              specialId,
              value: JSON.parse(JSON.stringify({ paibanData })),
            })
            store.commit('paibanStore/setSubCurrentUsingSpecialId', specialId)
            const isOnlyProcessHoleSlot =
              checkIsOnlyProcessHoleSlotByPaibanData(paibanData)
            // 精细排板不进行分散排板检测
            if (
              scattered_layout &&
              !resultData?.isGreatPlan &&
              !isJinxiPaiban &&
              !isOnlyProcessHoleSlot
            ) {
              store.commit('setIsShowDisPaiabnConfirm', true)
            }
          }
        })
      } else if (code == 2) {
        const res = resArr.find((it) => it.code == 2)

        const errText = res.msg
          ? res.msg
          : res.message
          ? res.message
          : res.data.err_info
        // Vue.prototype.$message.error(errText)
        if (typeof errText == 'string' && errText.includes('排版错误')) {
          let notSawRFlag = false
          const sawKnife = getSawKnife(store.state.ncSetting)
          const hasKnife = sawKnife && sawKnife !== Infinity
          if (sawToLayout && !hasKnife) notSawRFlag = true
          resolve({ isPaibanErr: true, notSawRFlag })
        } else if (typeof errText == 'object') {
          const allMessage = {}
          const allErrInfo = resArr
            .filter((it) => it.code == 2)
            .map((it) => it.message)
          allErrInfo.forEach((it) => {
            Object.assign(allMessage, it)
          })
          resolve({
            message: allMessage,
            text: translate('arrangedPage.overSizeTip'),
            isErr: true,
          })
        } else if (errText.includes('存在过大板件')) {
          resolve({
            text: (isReLayout ? '重新排版未生效，' : '') + errText,
            isOverSize: true,
          })
        } else {
          Vue.prototype.$message.error(errText)
        }
        resolve(false)
      } else {
        let content
        if (preData.length === 0) {
          content = translate('arrangedPage.uselessPart')
        } else {
          content = translate('arrangedPage.splitArranged')
        }
        Vue.prototype.$antdConfirm({
          title: translate('common.tip'),
          content: content,
          okText: translate('common.confirm'),
          cancelText: translate('common.cancel'),
          centered: true,
        })
        resolve(false)
      }
    }
  })
}

/**
 *
 * @param {any} data 排版参数
 * @param {string} type 排版方式
 */
export function dealSurplusShapeForType(data, type) {
  const surplusObj = JSON.parse(data.surplus)
  for (const key in surplusObj) {
    surplusObj[key].forEach((surplus) => {
      if (surplus.path && [6, 7].includes(surplus.path.length)) {
        if (type.includes('v2')) {
          surplus.shape = 'specialShape'
        } else {
          surplus.shape = 'lshape'
        }
      }
    })
  }

  return JSON.stringify(surplusObj)
}

// 处理 锯切 和 其他材质，用于调用多次排版, 不支持不同材质下料刀，用了直接 G
function splitPlanksByWeldingType(paramArr, sawCutOnlyWeld, knives) {
  if (!sawCutOnlyWeld) return paramArr

  if (!paramArr || paramArr.length === 0) return []

  const result = []

  // 获取原始对象
  const originalObj = paramArr[0]

  try {
    // 解析 layout_data JSON 字符串
    const layoutData = JSON.parse(originalObj.data.layout_data)
    const layoutRectMap = layoutData.layoutRectMap

    // 准备存储分类后的板件
    const weldingPlanks = {}
    const nonWeldingPlanks = {}
    Object.keys(layoutRectMap).forEach((plankType) => {
      layoutRectMap[plankType].forEach((plank) => {
        if (plank.isWeldingPlank) {
          // 添加到焊接板
          if (!weldingPlanks[plankType]) {
            weldingPlanks[plankType] = []
          }
          weldingPlanks[plankType].push(plank)
        } else {
          // 添加到非焊接板
          if (!nonWeldingPlanks[plankType]) {
            nonWeldingPlanks[plankType] = []
          }
          nonWeldingPlanks[plankType].push(plank)
        }
      })
    })
    // 创建非焊接板对象
    if (Reflect.ownKeys(nonWeldingPlanks).length) {
      const isDoorFrame =
        store.state.ncSetting.sawSetting.mentaoji_enable &&
        store.state.ncSetting.sawSetting.processType === 'doorFrame' &&
        isSawPaiban(store)
      const nonWeldingObj = JSON.parse(JSON.stringify(originalObj))
      nonWeldingObj.data.isWeldingPlank = false
      nonWeldingObj.data.layout_data = JSON.stringify({
        ...layoutData,
        layoutRectMap: nonWeldingPlanks,
        layoutConfig: {
          ...layoutData.layoutConfig,
          sawCutOnlyWeld: false,
          knifeR: knives / 2,
          gap: isDoorFrame ? 0 : store.state.ncSetting.panelSize.layoutGap,
        },
      })

      result.push(nonWeldingObj)
    }
    // 创建焊接板对象
    if (Reflect.ownKeys(weldingPlanks).length) {
      const weldingObj = JSON.parse(JSON.stringify(originalObj))
      weldingObj.data.isWeldingPlank = true
      if (layoutData.layoutConfig.customPlankOrder) {
        layoutData.layoutConfig.amount = 0
      }
      layoutData.layoutConfig.gap =
        store.state.ncSetting.sawSetting.sawBoardGap ?? 0
      weldingObj.data.layout_data = JSON.stringify({
        ...layoutData,
        layoutRectMap: weldingPlanks,
      })
      result.push(weldingObj)
    }
    return result
  } catch (error) {
    console.error('数据处理失败:', error)
    return paramArr
  }
}

// 判断一个方案是否是稳妥的
function checkPlanks(plan, minWidth, minHeight, knives) {
  const minSize = Math.min(minWidth, minHeight)
  const maxSize = Math.max(minWidth, minHeight)
  let group = {}
  Object.entries(plan).forEach(([material, item]) => {
    const parts = item.data[0]
    const groupTemp = parts.reduce((acc, part) => {
      const {
        stockNum,
        rect: { x1, x2, y1, y2 },
      } = part
      const width = Math.abs(x2 - x1) - knives
      const height = Math.abs(y2 - y1) - knives
      const max = Math.max(width, height)
      const min = Math.min(width, height)
      if (!acc[`${material}-${stockNum}`]) {
        acc[`${material}-${stockNum}`] = {
          stockNum,
          isGreatPlank: false,
        }
      }
      if (max >= maxSize && min >= minSize) {
        acc[`${material}-${stockNum}`].isGreatPlank = true
      }
      return acc
    }, {})
    group = { ...group, ...groupTemp }
  })
  plan.isGreatPlan = Object.values(group).every((item) => {
    return item.isGreatPlank
  })
  plan.isDeepSearch = Object.values(plan).some((item) => {
    return item.isDeepSearch
  })
  plan.greatPlankNum = Object.values(group).filter(
    (item) => item.isGreatPlank
  ).length
  Object.defineProperty(plan, 'isGreatPlan', {
    enumerable: false,
  })
  Object.defineProperty(plan, 'greatPlankNum', {
    enumerable: false,
  })
  Object.defineProperty(plan, 'isDeepSearch', {
    enumerable: false,
  })
}

/**
 *
 * @param {*} resultPlans 排版方案
 * @param {*} type 排版类别，主要判断是不是少翻板
 * @param {*} scattered_layout 分散排版4
 */
// 对排版方案进行排序
function sortPlans(resultPlans, type, scattered_layout) {
  // 提取计算平均使用率的函数
  const calculateAverageRate = (plan) => {
    const rates = Object.values(plan).map((m) => {
      const avgRate =
        m.used_rate.reduce((sum, r) => sum + r.rate, 0) / m.used_rate.length
      return avgRate
    })
    return (
      (rates.reduce((sum, rate) => sum + rate, 0) / rates.length) *
      100
    ).toFixed(2)
  }

  // 获取最大板号的使用率
  const getMaxStockNumRate = (plan) => {
    const usedRates = Object.values(plan)[0].used_rate
    const maxStockNum = Math.max(...usedRates.map((item) => item.stock_num))
    return usedRates.find((item) => item.stock_num === maxStockNum).rate
  }

  // 获取第一块板的数量
  const getRollCount = (plan) => Object.values(plan)[0].rollCount[0]

  // 获取大板数量
  const getBigPlankNum = (plan) => Object.values(plan)[0].stockCount[0]

  // 多材质方案的 layoutRank 综合分（均值），越小越优；无 rank 视为最大
  const getCombinedLayoutRank = (plan) => {
    const ranks = Object.values(plan)
      .map((m) => m.layoutRank)
      .filter((r) => r !== undefined && r !== null)
    if (!ranks.length) return Infinity
    return ranks.reduce((sum, r) => sum + r, 0) / ranks.length
  }

  resultPlans.sort((a, b) => {
    // 分散排版时优先考虑isGreatPlan
    if (scattered_layout && a.isGreatPlan !== b.isGreatPlan) {
      return b.isGreatPlan - a.isGreatPlan
    }

    // 少翻版模式
    if (type === 'paiban_roll') {
      return getRollCount(a) - getRollCount(b)
    }

    const rateA = calculateAverageRate(a)
    const rateB = calculateAverageRate(b)

    if (rateA !== rateB) {
      return rateB - rateA
    }
    const stockCountA = getBigPlankNum(a)
    const stockCountB = getBigPlankNum(b)
    if (stockCountA === stockCountB) {
      // 第一块板数量相同时，按最大板号的使用率升序
      const maxRateDiff = getMaxStockNumRate(a) - getMaxStockNumRate(b)
      if (maxRateDiff !== 0) return maxRateDiff
      // 使用率、大板数量均相同时，按 layoutRank 综合排序（越小越靠前）
      return getCombinedLayoutRank(a) - getCombinedLayoutRank(b)
    }
    return b.greatPlankNum - a.greatPlankNum
  })
}
// 判断孔槽是否冲突
function checkAllPlankHoleSlot(paibanArr) {
  for (let i = 0; i < paibanArr.length; ++i) {
    for (let k = 0; k < paibanArr[i].parts.length; ++k) {
      // 记录是否板件孔槽冲突
      paibanArr[i].parts[k].holeSlotMerge = false
      checkPlankDepth(paibanArr[i].parts[k])
      checkPlankHoleSlot(paibanArr[i].parts[k])
    }
  }
}
//  孔槽深度判断
function checkPlankDepth(part) {
  const holes = part.holes ? part.holes : []
  const slots = part.slots ? part.slots : []
  const handleSlopes = part.handleSlopes ? part.handleSlopes : []
  const thick = part.thick
  let holeDepthError, slotDepthError, slopeDepthError
  const { cutZ } = store.state.ncSetting
  const _deep = Number(thick) + Number(cutZ)
  // const _deep = 1 //测试值
  // 孔槽深度 > 板件厚度 + 切透值 即为异常 deep > thick + cutZ
  // 为每个孔槽添加深度异常信息
  holes.forEach((hole) => {
    hole.depthError = hole.deep > _deep
  })
  slots.forEach((slot) => {
    slot.depthError = slot.deep > _deep
  })
  handleSlopes.forEach((slope) => {
    slope.depthError = slope.deep > _deep
  })
  holeDepthError = holes.some((hole) => hole.depthError)
  slotDepthError = slots.some((slot) => slot.depthError)
  slopeDepthError = handleSlopes.some((slope) => slope.depthError)
  // 判断整个小板是否有孔槽深度异常
  part.depthError = holeDepthError || slotDepthError || slopeDepthError
}
function holeSlotsFocus(paibanData, ncSetting) {
  let holeFocus = ncSetting.holeConcentrated
    ? ncSetting.holeConcentrated
    : 'front'
  let slotFocus = ncSetting.apertureSlotConcentrated
    ? ncSetting.apertureSlotConcentrated
    : 'front'
  // 测试，深拷贝，不影响正常数据
  // paibanData = JSON.parse(JSON.stringify(paibanData))
  for (let i = 0; i < paibanData.length; i++) {
    let parts = paibanData[i].parts
    for (let j = 0; j < parts.length; j++) {
      reversalPart(parts[j], holeFocus, slotFocus)
    }
  }
}
function reversalPart(part, holeFocus, slotFocus) {
  holeFocus = holeFocus == 'front' ? true : false
  slotFocus = slotFocus == 'front' ? true : false
  let slots = part.slots ? part.slots : []
  let holes = part.holes ? part.holes : []
  let zSlots = slots.filter((item) => item.side == 1).length
  let fSlots = slots.filter((item) => item.side == -1).length
  let zHoles = holes.filter((item) => item.side == 1).length
  let fHoles = holes.filter((item) => item.side == -1).length
  // 是否翻面
  let flag = false
  // 有槽的时候只根据槽判断是否翻面
  if (slots.length && fSlots != zSlots) {
    if (slotFocus) {
      if (fSlots > zSlots) {
        flag = true
      }
    } else {
      if (zSlots > fSlots) {
        flag = true
      }
    }
  } else {
    // 没有槽根据空做判断
    if (holeFocus) {
      if (fHoles > zHoles) {
        flag = true
      }
    } else {
      if (zHoles > fHoles) {
        flag = true
      }
    }
  }
  if (flag) {
    recordTransform(part, 'flipX', 0, 'dealPaibanData-reversalPart')
    let plank = part
    let rect = plank['rect']
    let holes = plank['holes']
    let sholes = plank['sholes']
    let slots = plank['slots']
    let handleSlopes = plank['handleSlopes'] ?? []
    let sslots = plank['sslots']
    let edgeInfo = plank['edgeInfo']
    let edgeTextureMap = plank['edge_texture_map']
    let lightEdgeInfo = plank['lightEdgeInfo']
    let thick = plank['thick']
    let oRect = plank['oRect']
    let oheight = oRect['height']
    let owidth = oRect['width']
    let lineSlots = plank['lineSlots'] ?? []
    let edgeArrowMap = plank['edgeArrowMap']
    holes.forEach((it) => {
      it.side = -it.side
      it.center = { x: it.center.x, y: rect.height - it.center.y }
      it.ocenter = { x: it.ocenter.x, y: oheight - it.ocenter.y }
      /** 处理孔槽分流的加工设备值 */
      dealProcessInEn(it)
    })

    lineSlots.forEach((it) => {
      it.side = -it.side
      it.path = it.path.map((v) => {
        v.y = rect.height - v.y
        dealLineSlotPointB(v)
        return v
      })
      it.oPath = it.oPath.map((v) => {
        v.y = oheight - v.y
        dealLineSlotPointB(v)
        return v
      })
    })
    sholes.forEach((item) => {
      let side = item.side
      let center = item.center
      let ocenter = item.ocenter
      switch (String(side)) {
        case '2':
          side = '4'
          break
        case '4':
          side = '2'
          break
      }
      center = {
        x: (center.z ? center.z : 0) - center.x,
        y: thick - center.y,
        z: center.z ? center.z : 0,
      }
      ocenter = { x: ocenter.x, y: oheight - ocenter.y }
      item.side = side
      item.center = center
      item.ocenter = ocenter
    })
    // slots
    slots.forEach((it) => {
      it.pt1 = { x: it.pt1.x, y: rect.height - it.pt1.y }
      it.opt1 = { x: it.opt1.x, y: oheight - it.opt1.y }
      it.pt2 = { x: it.pt2.x, y: rect.height - it.pt2.y }
      it.opt2 = { x: it.opt2.x, y: oheight - it.opt2.y }
      it.side = -it.side
    })
    // handleSlopes
    handleSlopes.forEach((it) => {
      it.pt1 = { x: it.pt1.x, y: rect.height - it.pt1.y }
      it.opt1 = { x: it.opt1.x, y: oheight - it.opt1.y }
      it.pt2 = { x: it.pt2.x, y: rect.height - it.pt2.y }
      it.opt2 = { x: it.opt2.x, y: oheight - it.opt2.y }
      it.side = -it.side
    })
    // sslots
    sslots.forEach((sslot) => {
      let side = sslot['side']
      let pt1 = sslot['pt1']
      let opt1 = sslot['opt1']
      let pt2 = sslot['pt2']
      let opt2 = sslot['opt2']
      switch (String(side)) {
        case '2':
          side = '4'
          break
        case '4':
          side = '2'
          break
      }
      pt1 = { x: pt1.z - pt1.x, y: pt1.y, z: pt1.z }
      opt1 = { x: opt1.x, y: oheight - opt1.y }
      pt2 = { x: pt2.z - pt2.x, y: pt2.y, z: pt2.z }
      opt2 = { x: opt2.x, y: oheight - opt2.y }
      sslot['side'] = side
      sslot['pt1'] = pt1
      sslot['opt1'] = opt1
      sslot['pt2'] = pt2
      sslot['opt2'] = opt2
    })

    // edgeInfo
    let left = edgeInfo.substring(
      edgeInfo.indexOf('←') + 1,
      edgeInfo.indexOf('↓')
    )
    let bottom = edgeInfo.substring(
      edgeInfo.indexOf('↓') + 1,
      edgeInfo.indexOf('→')
    )
    let right = edgeInfo.substring(
      edgeInfo.indexOf('→') + 1,
      edgeInfo.indexOf('↑')
    )
    let top = edgeInfo.substring(edgeInfo.indexOf('↑') + 1)
    edgeInfo = '←' + left + '↓' + top + '→' + right + '↑' + bottom

    // 处理edgeTextureMap与edgeInfo相同的逻辑
    if (edgeTextureMap) {
      var leftTexture = edgeTextureMap[1] || ''
      var bottomTexture = edgeTextureMap[2] || ''
      var rightTexture = edgeTextureMap[3] || ''
      var topTexture = edgeTextureMap[4] || ''
      edgeTextureMap[1] = leftTexture // 新的左 = 原来的左
      edgeTextureMap[2] = topTexture // 新的下 = 原来的上
      edgeTextureMap[3] = rightTexture // 新的右 = 原来的右
      edgeTextureMap[4] = bottomTexture // 新的上 = 原来的下
    }
    // edgeArrowMap - 按照与 edgeInfo 相同的上下翻板逻辑
    // edgeInfo: ←left ↓top →right ↑bottom
    if (edgeArrowMap) {
      // 左、下、右、上
      let leftName = edgeArrowMap[0]
      let bottomName = edgeArrowMap[1]
      let rightName = edgeArrowMap[2]
      let topName = edgeArrowMap[3]

      edgeArrowMap[0] = leftName // 新的左 = 原来的左
      edgeArrowMap[1] = topName // 新的下 = 原来的上
      edgeArrowMap[2] = rightName // 新的右 = 原来的右
      edgeArrowMap[3] = bottomName // 新的上 = 原来的下
    }

    if (!lightEdgeInfo) {
      lightEdgeInfo = '←0↓0→0↑0'
    }
    left = lightEdgeInfo.substring(
      lightEdgeInfo.indexOf('←') + 1,
      lightEdgeInfo.indexOf('↓')
    )
    bottom = lightEdgeInfo.substring(
      lightEdgeInfo.indexOf('↓') + 1,
      lightEdgeInfo.indexOf('→')
    )
    right = lightEdgeInfo.substring(
      lightEdgeInfo.indexOf('→') + 1,
      lightEdgeInfo.indexOf('↑')
    )
    top = lightEdgeInfo.substring(lightEdgeInfo.indexOf('↑') + 1)
    lightEdgeInfo = '←' + left + '↓' + top + '→' + right + '↑' + bottom
    const sh = holes.filter((hole) => isOtherSideMachineHole(hole))
    const sl = slots.filter((slot) => isOtherSideMachineSlot(slot))
    let sholeInfo = generatorSideHoleSlot([
      ...sholes,
      ...sh.filter((h) => h.side == '1'),
    ])
    let sholeInfoF = generatorSideHoleSlot(
      sh.filter((h) => h.side == '-1'),
      'upDownFlip'
    )
    // 开启 侧孔机加工牛角拉手 需将牛角拉手放到侧槽信息里面
    let sideMillInfo = part?.millInfo?.filter((mill) =>
      isSideMachineMillInfo(mill)
    )
    let sslotInfo = generatorSideHoleSlot(
      [
        ...sslots,
        ...sl.filter((l) => l.side == '1'),
        ...(sideMillInfo
          ? sideMillInfo?.filter((mill) => mill.side == '1')
          : []),
      ],
      '',
      part
    )
    let sslotInfoF = generatorSideHoleSlot(
      sl.filter((l) => l.side == '-1'),
      'upDownFlip',
      part
    )
    plank['holes'] = holes
    plank['slots'] = slots
    plank['sholes'] = sholes
    plank['sslots'] = sslots
    plank['edgeInfo'] = edgeInfo
    plank['edge_texture_map'] = edgeTextureMap
    plank['lightEdgeInfo'] = lightEdgeInfo
    plank['sholeInfo'] = sholeInfo
    plank['sholeInfoF'] = sholeInfoF
    plank['sslotInfo'] = sslotInfo
    plank['sslotInfoF'] = sslotInfoF
    plank['edgeArrowMap'] = edgeArrowMap
    if (plank.hasOwnProperty('path')) {
      let o = { x: rect.width / 2, y: rect.height / 2 }
      let paths = plank['path']
      for (let i in paths) {
        let path = paths[i]
        for (let j in path) {
          let p = path[j]
          let x = p['x'] - o.x
          let y = p['y'] - o.y
          p['x'] = x + o.x
          p['y'] = -y + o.y
        }
      }
      plank['path'] = paths
    }
    // oPath

    if (plank.hasOwnProperty('oPath')) {
      let o = { x: owidth / 2, y: oheight / 2 }
      let paths = plank['oPath']
      for (let i in paths) {
        let path = paths[i]
        for (let j in path) {
          let p = path[j]
          let x = p['x'] - o.x
          let y = p['y'] - o.y
          p['x'] = x * 1 + o.x
          p['y'] = -y + o.y
        }
      }
      plank['oPath'] = paths
    }
    // cutCurve
    if (plank.hasOwnProperty('cutCurve') && plank['cutCurve']) {
      let o = { x: rect.width / 2, y: rect.height / 2 }
      let lastB = -1000
      let cutCurve = plank['cutCurve']
      cutCurve.reverse()
      for (let j in cutCurve) {
        let p = cutCurve[j]
        let x = p['x'] - o.x
        let y = p['y'] - o.y
        p['x'] = x + o.x
        p['y'] = -y + o.y
        let tmpB = lastB
        if (p.hasOwnProperty('b')) {
          lastB = p['b']
        } else {
          lastB = -1000
        }
        if (tmpB !== -1000) {
          p['b'] = tmpB
        } else {
          delete p['b']
        }
      }
      if (lastB !== -1000) {
        cutCurve[0]['b'] = lastB
      }
      let cutCurveEx = plank['cutCurveEx']
      for (let i in cutCurveEx) {
        let curveEx = cutCurveEx[i]
        lastB = -1000
        curveEx.reverse()
        for (let j in curveEx) {
          p = curveEx[j]
          x = p['x'] - o.x
          y = p['y'] - o.y
          p['x'] = x + o.x
          p['y'] = -y + o.y
          tmpB = lastB
          if (p.hasOwnProperty('b')) {
            lastB = p['b']
          } else {
            lastB = -1000
          }
          if (tmpB !== -1000) {
            p['b'] = tmpB
          } else {
            delete p['b']
          }
        }
        if (lastB !== -1000) {
          curveEx[0]['b'] = lastB
        }
      }
    }
    // realCurve
    if (plank.hasOwnProperty('realCurve') && plank['realCurve']) {
      let o = { x: owidth / 2, y: oheight / 2 }
      let lastB = -1000
      let path = plank['realCurve']
      path.reverse()
      for (let i in path) {
        let p = path[i]
        let x = p['x'] - o.x
        let y = p['y'] - o.y
        p['x'] = x * 1 + o.x
        p['y'] = -y + o.y
        let tmpB = lastB
        if (p.hasOwnProperty('b')) {
          lastB = p['b']
        } else {
          lastB = -1000
        }
        if (tmpB !== -1000) {
          p['b'] = tmpB
        } else {
          delete p['b']
        }
      }
      if (lastB !== -1000) {
        path[0]['b'] = lastB
      }
      plank['realCurve'] = path
      let realCurveEx = plank['realCurveEx']
      for (let i in realCurveEx) {
        let curveEx = realCurveEx[i]
        lastB = -1000
        curveEx.reverse()
        for (let j in curveEx) {
          p = curveEx[j]
          x = p['x'] - o.x
          y = p['y'] - o.y
          p['x'] = x + o.x
          p['y'] = -y + o.y
          tmpB = lastB
          if (p.hasOwnProperty('b')) {
            lastB = p['b']
          } else {
            lastB = -1000
          }
          if (tmpB !== -1000) {
            p['b'] = tmpB
          } else {
            delete p['b']
          }
          if (p.hasOwnProperty('side')) {
            if (p.depth * 1 + 0.001 < plank['thick']) {
              p.side = -p.side
            }
          }
        }
        if (lastB !== -1000) {
          curveEx[0]['b'] = lastB
        }
      }
    }
  }
  // if(flag){
  //   for(let j = 0; j < part.holes.length; ++j){
  //     let hole = part.holes[j]
  //     hole.center.x = part.rect.width - hole.center.x
  //     hole.ocenter.x = part.oRect.width - hole.ocenter.x
  //     hole.side = -hole.side
  //   }
  //   // 处理拉槽
  //   for(let j = 0; j < part.slots.length; ++j){
  //     let slot = part.slots[j]
  //     slot.pt1.x = part.rect.width - slot.pt1.x
  //     slot.pt2.x = part.rect.width - slot.pt2.x
  //     slot.opt1.x = part.oRect.width - slot.opt1.x
  //     slot.opt2.x = part.oRect.width - slot.opt2.x
  //     slot.side = -slot.side
  //   }
  //   // 处理异形路径
  //   if(part.path){
  //     for(let j = 0; j < part.path.length; j++){
  //       for(let k = 0; k < part.path[j].length; k++){
  //         let point = part.path[j][k]
  //         point.x = part.rect.width - point.x
  //       }
  //     }
  //     for(let j = 0; j < part.oPath.length; j++){
  //       for(let k = 0; k < part.oPath[j].length; k++){
  //         let point = part.oPath[j][k]
  //         point.x = part.oRect.width - point.x
  //       }
  //     }
  //   }
  // }
}
// function genSHoleInfo(sholes, isFront = true) {
//   var holeHash = {}
//   for (let i in sholes) {
//     let shole = sholes[i]
//     let side = shole['cSide'] ? shole['cSide'] : shole['side']
//     if (!holeHash.hasOwnProperty(side)) {
//       holeHash[side] = []
//     }
//     holeHash[side].push(shole)
//   }
//   let sholeInfo = isFront ? '' : '翻面'

//   if (isFront) {
//     Object.keys(holeHash).forEach(function (side, i) {
//       switch (side) {
//         case '1':
//           sholeInfo += i + 1 + '←'
//           break
//         case '2':
//           sholeInfo += i + 1 + '↓'
//           break
//         case '3':
//           sholeInfo += i + 1 + '→'
//           break
//         case '4':
//           sholeInfo += i + 1 + '↑'
//           break
//         default:
//           break
//       }
//     })
//   } else {
//     Object.keys(holeHash).forEach(function (side, i) {
//       switch (side) {
//         case '1':
//           sholeInfo += i + 1 + '←'
//           break
//         case '4':
//           sholeInfo += i + 1 + '↓'
//           break
//         case '3':
//           sholeInfo += i + 1 + '→'
//           break
//         case '2':
//           sholeInfo += i + 1 + '↑'
//           break
//         default:
//           break
//       }
//     })
//   }
//   return sholeInfo
// }

// // 构造侧槽顺序
// function genSSlotInfo(sslots, isFront = true) {
//   let slotHash = {}
//   for (let i in sslots) {
//     let sslot = sslots[i]
//     let side = sslot['cSide'] ? sslot['cSide'] : sslot['side']
//     if (!slotHash.hasOwnProperty(side)) {
//       slotHash[side] = []
//     }
//     slotHash[side].push(sslot)
//   }
//   let sslotInfo = isFront ? '' : '翻面'

//   if (isFront) {
//     Object.keys(slotHash).forEach(function (side, i) {
//       switch (side) {
//         case '1':
//           sslotInfo += i + 1 + '←'
//           break
//         case '2':
//           sslotInfo += i + 1 + '↓'
//           break
//         case '3':
//           sslotInfo += i + 1 + '→'
//           break
//         case '4':
//           sslotInfo += i + 1 + '↑'
//           break
//         default:
//           break
//       }
//     })
//   } else {
//     Object.keys(slotHash).forEach(function (side, i) {
//       switch (side) {
//         case '1':
//           sslotInfo += i + 1 + '←'
//           break
//         case '4':
//           sslotInfo += i + 1 + '↓'
//           break
//         case '3':
//           sslotInfo += i + 1 + '→'
//           break
//         case '2':
//           sslotInfo += i + 1 + '↑'
//           break
//         default:
//           break
//       }
//     })
//   }
//   return sslotInfo
// }
// 判断单个板件是否存在孔槽冲突
// 成功判断出冲突依旧需要继续判断，收集其他冲突孔槽
export function checkPlankHoleSlot(plank) {
  let holeLen = plank.holes.length
  // 记录板件厚度
  let thick = plank.thick
  // 记录起始点
  let { startX, startY } = plank
  // 处理板件边框点位
  let flag = true
  dealPlankPoly(plank)
  const slotArr = [...(plank.slots ?? []), ...(plank.lineSlots ?? [])]
  let slotLen = slotArr.length
  // 先判断槽是否在大板外侧, 同时处理槽的轮廓数据
  if (slotLen > 0) {
    for (let i = 0; i < slotLen; ++i) {
      let slot = slotArr[i]
      dealSlotPoly(slot, startX, startY)
      flag = isPathInside(slot.polyArr[0], plank.polyArr[0])
      // 斜槽绘制超出板件外不检测
      if (!flag && slot.symbol !== 'CCompSlot') {
        plank.holeSlotMerge = true
        genHoleSlotConflictInfo(slot, 'beyond', null, 'slot')
      }
    }
  }
  // 判断孔是否冲突
  if (holeLen > 0) {
    // 判断孔是否在大板外面
    for (let i = 0; i < holeLen; ++i) {
      // 孔以圆心为中心点, 描绘出一个长度为直径的正方形点位
      let hole = plank.holes[i]
      let point = hole.center
      let radius = hole.diameter / 2
      let holeUniqueId = hole._conflict_uniqueId
      let holeGroupId = hole.groupId
      let holePoly = [
        [
          {
            X: toDecimal(point.x - radius + startX, 2),
            Y: toDecimal(point.y - radius + startY, 2),
          },
          {
            X: toDecimal(point.x + radius + startX, 2),
            Y: toDecimal(point.y - radius + startY, 2),
          },
          {
            X: toDecimal(point.x + radius + startX, 2),
            Y: toDecimal(point.y + radius + startY, 2),
          },
          {
            X: toDecimal(point.x - radius + startX, 2),
            Y: toDecimal(point.y + radius + startY, 2),
          },
        ],
      ]
      // 判断孔是否超出板件
      // 判断孔的中心点是否超出板件
      const pt = { X: point.x + startX, Y: point.y + startY }
      flag = checkPointInPart(pt, plank.polyArr)
      if (!flag) {
        plank.holeSlotMerge = true
        genHoleSlotConflictInfo(hole, 'beyond', null, 'slot')
      }

      // 判断孔是否和孔冲突
      for (let k = 0; k < holeLen; ++k) {
        if (i == k) continue
        let _hole = plank.holes[k]
        // 如果两个孔是否除方向以外其余属性完全一致, 则判断为对穿孔, 忽略这种情况下的孔冲突
        let a = +hole.deep == +_hole.deep
        let b =
          compareTowNum(
            toDecimal(hole.ocenter.x, 2),
            toDecimal(_hole.ocenter.x, 2),
            '='
          ) &&
          compareTowNum(
            toDecimal(hole.ocenter.y, 2),
            toDecimal(_hole.ocenter.y, 2),
            '='
          )
        let c =
          compareTowNum(
            toDecimal(hole.center.x, 2),
            toDecimal(_hole.center.x, 2),
            '='
          ) &&
          compareTowNum(
            toDecimal(hole.center.y, 2),
            toDecimal(_hole.center.y, 2),
            '='
          )
        let d = hole.diameter == _hole.diameter
        let e = hole.symbol == _hole.symbol
        if (a && b && c && d && e) continue
        // 处理其他点位的孔点位
        let _point = _hole.center
        let _radius = _hole.diameter / 2
        let _holePoly = [
          [
            {
              X: toDecimal(_point.x - _radius + startX, 2),
              Y: toDecimal(_point.y - _radius + startY, 2),
            },
            {
              X: toDecimal(_point.x + _radius + startX, 2),
              Y: toDecimal(_point.y - _radius + startY, 2),
            },
            {
              X: toDecimal(_point.x + _radius + startX, 2),
              Y: toDecimal(_point.y + _radius + startY, 2),
            },
            {
              X: toDecimal(_point.x - _radius + startX, 2),
              Y: toDecimal(_point.y + _radius + startY, 2),
            },
          ],
        ]
        // 如果两个孔一个在正面, 一个在反面则需要先判断厚度, 再判断是否相交
        if (_hole.side != hole.side) {
          let holeThick = Number(hole.deep) + Number(_hole.deep)
          // 如果两个孔的深度加起来大于了板件厚度, 则需要判断是否重叠了
          if (holeThick > thick) {
            // flag = polyIntersect(holePoly, _holePoly)
            const h1 = { ...point, diameter: hole.diameter }
            const h2 = { ..._point, diameter: _hole.diameter }
            flag = holeIsIntersect(h1, h2)
            if (!flag) {
              plank.holeSlotMerge = true
              genHoleSlotConflictInfo(hole, 'differentIntersect', _hole, 'hole')
              genHoleSlotConflictInfo(_hole, 'differentIntersect', hole, 'hole')
              return
            }
          }
          continue
        }
        // 如果两个孔方向一致, 则直接判断是否相交
        if (hole.side == _hole.side) {
          // flag = polyIntersect(holePoly, _holePoly)
          const h1 = { ...point, diameter: hole.diameter }
          const h2 = { ..._point, diameter: _hole.diameter }
          flag = holeIsIntersect(h1, h2)
          if (!flag) {
            plank.holeSlotMerge = true
            genHoleSlotConflictInfo(hole, 'identicalIntersect', _hole, 'hole')
            genHoleSlotConflictInfo(_hole, 'identicalIntersect', hole, 'hole')
            // return
          }
        }
      }
      // 判断孔和槽之间是否冲突
      if (slotLen > 0) {
        for (let k = 0; k < slotLen; ++k) {
          let slot = slotArr[k]
          let slotUniqueId = slot._conflict_uniqueId
          const slotGroupId = slot.groupId
          // 葫芦孔的孔槽忽略
          if (
            hole.symbol === 'CCGourdHole' &&
            slot.symbol === 'CCGourdHole' &&
            holeGroupId == slotGroupId
          )
            continue
          // 隐形件忽略冲突，目前售后提的是华扣隐形件，其他的我也不太了解，先判断华扣
          if (hole.symbol == 'HKYXJ' && slot.symbol == 'HKYXJ') continue
          // 如果孔和槽都为拉直器, 则忽略此情况的孔槽冲突
          if (hole.symbol == 'STRENTCH' && slot.symbol == 'STRENTCH') continue
          // 乐扣槽忽略冲突
          if (
            hole.symbol &&
            hole.symbol.indexOf('WS') > -1 &&
            slot.symbol &&
            slot.symbol.indexOf('WS') > -1 &&
            holeUniqueId == slotUniqueId
          ) {
            continue
          }
          // 如果孔和槽不在同一面, 则先判断厚度是否超出板件厚度, 再进行相交判断
          if (hole.side != slot.side) {
            let holeSlotThick = Number(hole.deep) + Number(slot.deep)
            if (holeSlotThick > thick) {
              flag = polyIntersect(holePoly, slot.polyArr)
              if (!flag) {
                plank.holeSlotMerge = true
                genHoleSlotConflictInfo(
                  hole,
                  'differentIntersect',
                  slot,
                  'slot'
                )
                genHoleSlotConflictInfo(
                  slot,
                  'differentIntersect',
                  hole,
                  'hole'
                )
              }
            }
            continue
          } else {
            flag = polyIntersect(holePoly, slot.polyArr)
            if (!flag) {
              plank.holeSlotMerge = true
              genHoleSlotConflictInfo(hole, 'identicalIntersect', slot, 'slot')
              genHoleSlotConflictInfo(slot, 'identicalIntersect', hole, 'hole')
            }
          }
        }
      }
    }
  }
  // 判断完成后需要删除所有的polyArr避免内存泄露
  slotArr.forEach((v) => {
    Reflect.deleteProperty(v, 'polyArr')
  })
}
// 生成孔槽的冲突信息，只用于详细的展示
function genHoleSlotConflictInfo(
  holeSlot,
  conflictType,
  conflictObj,
  conflictObjType
) {
  const newConflictObj = { ...conflictObj }
  // 需要删除原对象上存储的冲突信息，由于页面显示是不需要这个参数的，但是此处拷贝会拷贝到所有的信息那么冲突套冲突的话内存会崩溃
  Reflect.deleteProperty(newConflictObj, 'conflict')
  Reflect.deleteProperty(newConflictObj, 'polyArr')
  const obj = JSON.parse(
    JSON.stringify({
      isConflict: true,
      conflictType: conflictType,
      conflictObj: newConflictObj,
      conflictObjType: conflictObjType,
    })
  )
  if (holeSlot.conflict) {
    if (
      !holeSlot.conflict.find(
        (it) =>
          it.conflictObj?._conflict_uniqueId === conflictObj?._conflict_uniqueId
      )
    ) {
      holeSlot.conflict.push(obj)
    }
  } else {
    holeSlot.conflict = [obj]
  }
}
// 处理拉槽轮廓数据
export function dealSlotPoly(
  slot,
  startX,
  startY,
  isSave = true,
  isShow = false
) {
  let { pt1, pt2 } = slot
  const precision = 0.0001
  let slotPointArr = []
  if (slot.symbol == 'lineSlot') {
    // 因为显示和判断冲突的逻辑不相同所以分开
    const polyArr = window.$copy((isShow ? slot.polygonArr : [slot.path]) ?? [])
    slotPointArr = polyArr.map((arr) =>
      arr.map((p) => ({
        X: toDecimal(startX + p.x, 2),
        Y: toDecimal(startY + p.y, 2),
      }))
    )
  } else if (slot.symbol === 'CCompSlot') {
    const obliqueSlot = calculateSlantedRectanglePath(
      slot.pt1,
      slot.pt2,
      slot.width
    )
    slotPointArr = [
      obliqueSlot.path.map((point) => ({
        X: startX + point.x,
        Y: startY + point.y,
      })),
    ]
  } else {
    let arr = []
    // 判断是
    if (Math.abs(pt1.x - pt2.x) <= precision) {
      if (pt1.y < pt2.y) {
        arr = [
          {
            X: toDecimal(startX + pt1.x - slot.width / 2, 2),
            Y: toDecimal(startY + pt1.y, 2),
          },
          {
            X: toDecimal(startX + pt1.x + slot.width / 2, 2),
            Y: toDecimal(startY + pt1.y, 2),
          },
          {
            X: toDecimal(startX + pt1.x + slot.width / 2, 2),
            Y: toDecimal(startY + pt1.y + Math.abs(pt1.y - pt2.y), 2),
          },
          {
            X: toDecimal(startX + pt1.x - slot.width / 2, 2),
            Y: toDecimal(startY + pt1.y + Math.abs(pt1.y - pt2.y), 2),
          },
        ]
      } else {
        arr = [
          {
            X: toDecimal(startX + pt2.x - slot.width / 2, 2),
            Y: toDecimal(startY + pt2.y, 2),
          },
          {
            X: toDecimal(startX + pt2.x + slot.width / 2, 2),
            Y: toDecimal(startY + pt2.y, 2),
          },
          {
            X: toDecimal(startX + pt2.x + slot.width / 2, 2),
            Y: toDecimal(startY + pt2.y + Math.abs(pt1.y - pt2.y), 2),
          },
          {
            X: toDecimal(startX + pt2.x - slot.width / 2, 2),
            Y: toDecimal(startY + pt2.y + Math.abs(pt1.y - pt2.y), 2),
          },
        ]
      }
    }
    if (Math.abs(pt1.y - pt2.y) <= precision) {
      if (pt1.x < pt2.x) {
        arr = [
          {
            X: toDecimal(startX + pt1.x, 2),
            Y: toDecimal(startY + pt1.y - slot.width / 2, 2),
          },
          {
            X: toDecimal(startX + pt1.x + Math.abs(pt1.x - pt2.x), 2),
            Y: toDecimal(startY + pt1.y - slot.width / 2, 2),
          },
          {
            X: toDecimal(startX + pt1.x + Math.abs(pt1.x - pt2.x), 2),

            Y: toDecimal(startY + pt1.y + slot.width / 2, 2),
          },
          {
            X: toDecimal(startX + pt1.x, 2),

            Y: toDecimal(startY + pt1.y + slot.width / 2, 2),
          },
        ]
      } else {
        arr = [
          {
            X: toDecimal(startX + pt2.x, 2),

            Y: toDecimal(startY + pt2.y - slot.width / 2, 2),
          },
          {
            X: toDecimal(startX + pt2.x + Math.abs(pt2.x - pt1.x), 2),

            Y: toDecimal(startY + pt2.y - slot.width / 2, 2),
          },
          {
            X: toDecimal(startX + pt2.x + Math.abs(pt2.x - pt1.x), 2),

            Y: toDecimal(startY + pt2.y + slot.width / 2, 2),
          },
          {
            X: toDecimal(startX + pt2.x, 2),

            Y: toDecimal(startY + pt2.y + slot.width / 2, 2),
          },
        ]
      }
    }
    slotPointArr = [arr]
  }
  if (isSave) {
    slot.polyArr = slotPointArr
  }
  return slotPointArr
}

// 判断板件冲突
function checkPlank(paibanData) {
  // 计算大板轮廓的点位
  for (let i = 0; i < paibanData.length; ++i) {
    dealBigPlank(paibanData[i])
    // 判断每一个大板的冲突情况, 单独写一个方法是为了后续拖动板件后判断单个大板的情况
    checkOneBigpart(paibanData[i])
  }
}

/** 冲突检测统一按 ncSetting.decimal 保留小数 */
function getConflictCheckDecimal() {
  const decimal = Number(store.state.ncSetting?.decimal)
  return Number.isFinite(decimal) && decimal >= 0 ? decimal : 2
}

function roundConflictNum(num) {
  return toDecimal(Number(num) || 0, getConflictCheckDecimal())
}

/** 按 ncSetting.decimal 取路径外接宽高 */
function getPathWHByNcDecimal(path) {
  if (!path?.length) return null
  const xs = path.map((p) => Number(p.x ?? p.X))
  const ys = path.map((p) => Number(p.y ?? p.Y))
  return {
    width: roundConflictNum(Math.max(...xs) - Math.min(...xs)),
    height: roundConflictNum(Math.max(...ys) - Math.min(...ys)),
  }
}

/**
 * @description 根据板件 startX、startY 和 rect 计算其在大板坐标系下的矩形区域
 * @param {object} plank
 * @returns {{ x1: number, y1: number, x2: number, y2: number }}
 */
function getPlankRectOnBigpart(plank) {
  const { startX, startY, rect } = plank
  const offsetX = rect.x || 0
  const offsetY = rect.y || 0
  // 锯切异形 startX/startY 已是绿框左上角，宽高需取绿路径，避免「绿框原点+排版尺寸」错位
  const pathRect =
    plank.isUseSaw && plank.path?.[0]?.length
      ? getPathWHByNcDecimal(plank.path[0])
      : null
  const width = pathRect ? pathRect.width : roundConflictNum(rect.width)
  const height = pathRect ? pathRect.height : roundConflictNum(rect.height)
  return {
    x1: roundConflictNum(startX + offsetX),
    y1: roundConflictNum(startY + offsetY),
    x2: roundConflictNum(startX + offsetX + width),
    y2: roundConflictNum(startY + offsetY + height),
  }
}

/**
 * @description 获取 range 范围内上下左右各方向最近的小板
 * @param {object} plank 目标板件
 * @param {object} bigpart 大板数据
 * @param {number} range 搜索范围
 * @returns {{ top: object|null, bottom: object|null, left: object|null, right: object|null }}
 */
export function getNearestPartsInRange(plank, bigpart, range) {
  const targetRect = getPlankRectOnBigpart(plank)
  const filteredParts = bigpart.parts.filter(
    (part) =>
      !part.hasOwnProperty('blueAreaSurplus') &&
      part.partUniqueId !== plank.partUniqueId
  )
  const shapes = filteredParts.map((part) => ({
    id: part.partUniqueId,
    part,
    shape: getPlankRectOnBigpart(part),
  }))
  const directionList = ['top', 'bottom', 'left', 'right']
  return directionList.reduce((result, direction) => {
    const nearestList = detectPotentialCollisionsScanline(
      targetRect,
      shapes,
      direction
    ).filter((item) => item.distance <= range)
    result[direction] = nearestList.length ? nearestList[0].part : null
    return result
  }, {})
}

/** 计算小板 realRect 在大板坐标系下的位置 */
function getRealRectOnBigpart(plank) {
  const { realRect, startX, startY, rect } = plank
  if (!realRect) return null
  const offsetX = (rect.width - realRect.width) / 2
  const offsetY = (rect.height - realRect.height) / 2
  return {
    x: roundConflictNum(realRect.x + startX + offsetX),
    y: roundConflictNum(realRect.y + startY + offsetY),
    width: roundConflictNum(realRect.width),
    height: roundConflictNum(realRect.height),
  }
}

const ADJACENT_EDGE_MAP = {
  left: { current: 'left', neighbor: 'right' },
  right: { current: 'right', neighbor: 'left' },
  top: { current: 'top', neighbor: 'bottom' },
  bottom: { current: 'bottom', neighbor: 'top' },
}

/** 朝对边的下料刀扩版误差（红路径扩张 − 下料刀半径），即 finalExtendDisMap */
function getFinalExtendEdge(item, edge) {
  return roundConflictNum(
    Math.max(Number(item?.finalExtendDisMap?.[edge]) || 0, 0)
  )
}

/** 计算两板在指定方向上相邻边的间隙，无有效对向重叠时返回 Infinity */
function getGapBetweenDirectionRects(
  plank,
  neighbor,
  direction,
  diameter,
  sawDiameter
) {
  /** 当前板件的 path 矩形区域 */
  const currentPathRect =
    plank.isUseSaw && plank.path ? getPathWHByNcDecimal(plank.path[0]) : null
  /** 相邻板件的 path 矩形区域 */
  const neighborPathRect =
    neighbor.isUseSaw && neighbor.path
      ? getPathWHByNcDecimal(neighbor.path[0])
      : null

  const currentW = currentPathRect
    ? currentPathRect.width
    : roundConflictNum(plank.rect.width)
  const currentH = currentPathRect
    ? currentPathRect.height
    : roundConflictNum(plank.rect.height)
  const neighborW = neighborPathRect
    ? neighborPathRect.width
    : roundConflictNum(neighbor.rect.width)
  const neighborH = neighborPathRect
    ? neighborPathRect.height
    : roundConflictNum(neighbor.rect.height)

  const currentRight = roundConflictNum(plank.startX + currentW)
  const currentBottom = roundConflictNum(plank.startY + currentH)
  const neighborRight = roundConflictNum(neighbor.startX + neighborW)
  const neighborBottom = roundConflictNum(neighbor.startY + neighborH)

  const currentExtendDisMap = plank.isUseSaw
    ? dealExpandPathForPart(plank, sawDiameter)
    : plank.finalExtendDisMap
  const neighborExtendDisMap = neighbor.isUseSaw
    ? dealExpandPathForPart(neighbor, sawDiameter)
    : neighbor.finalExtendDisMap

  if (direction === 'left' || direction === 'right') {
    const overlapY =
      Math.min(currentBottom, neighborBottom) -
      Math.max(plank.startY, neighbor.startY)
    if (overlapY <= 0) return Infinity
  } else {
    const overlapX =
      Math.min(currentRight, neighborRight) -
      Math.max(plank.startX, neighbor.startX)
    if (overlapX <= 0) return Infinity
  }

  let gap = 0
  switch (direction) {
    case 'left':
      gap =
        plank.startX - neighborRight + (plank.isUseSaw ? sawDiameter : diameter)
      if (plank.isUseSaw) {
        gap +=
          (currentExtendDisMap?.left ?? 0) + (neighborExtendDisMap?.right ?? 0)
      }

      break
    case 'right':
      gap =
        neighbor.startX -
        currentRight +
        (plank.isUseSaw ? sawDiameter : diameter)

      if (plank.isUseSaw) {
        gap +=
          (neighborExtendDisMap?.left ?? 0) + (currentExtendDisMap?.right ?? 0)
      }
      break
    case 'top':
      gap =
        plank.startY -
        neighborBottom +
        (plank.isUseSaw ? sawDiameter : diameter)

      if (plank.isUseSaw) {
        gap +=
          (currentExtendDisMap?.top ?? 0) + (neighborExtendDisMap?.bottom ?? 0)
      }
      break
    case 'bottom':
      gap =
        neighbor.startY -
        currentBottom +
        (plank.isUseSaw ? sawDiameter : diameter)

      if (plank.isUseSaw) {
        gap +=
          (neighborExtendDisMap?.top ?? 0) + (currentExtendDisMap?.bottom ?? 0)
      }
      break
    default:
      gap = Infinity
      break
  }
  if (!Number.isFinite(gap)) return gap
  return roundConflictNum(gap)
}

/** 相邻边存在异形时取较大刀径，否则取锯片刀径作为间隙阈值 */
export function getAdjacentEdgeRequiredGap(
  plank,
  neighbor,
  direction,
  diameter,
  sawDiameter
) {
  // 获取相邻边方向
  const { current, neighbor: neighborEdge } = ADJACENT_EDGE_MAP[direction]
  /** 获取板间距 */
  const layoutGap = roundConflictNum(
    store.state.ncSetting.panelSize.layoutGap ?? 0
  )
  const sawGap = roundConflictNum(
    store.state.ncSetting.sawSetting.sawBoardGap ?? 0
  )
  let gap =
    plank.isUseSaw && store.state.ncSetting.sawSetting.sawCutOnlyWeld
      ? sawGap
      : layoutGap
  /** 门套切割时，间隙为0 */
  const isDoorFrame =
    store.state.ncSetting.sawSetting.mentaoji_enable &&
    store.state.ncSetting.sawSetting.processType === 'doorFrame' &&
    plank.isUseSaw

  if (isDoorFrame) {
    gap = 0
  }

  const { rect: currentRect } = plank
  const { rect: neighborRect } = neighbor
  /** 判断相邻边是否对齐 */
  const isAlign =
    currentRect.width === neighborRect.width && plank.startX === neighbor.startX

  /** 判断相邻边是否存在异形 */
  const hasAbnormalEdge =
    plank.pathEdge?.includes(current) ||
    neighbor.pathEdge?.includes(neighborEdge)

  /**
   * 绿框 start 相对真实尺寸多出去的，是下料刀扩版误差 finalExtendDisMap。
   * required = 基础(+0.5) + 两侧朝对边的该误差
   */
  const extraGap =
    getFinalExtendEdge(plank, current) +
    getFinalExtendEdge(neighbor, neighborEdge)

  if (plank.isUseSaw) {
    // 相邻边有异形的情况下，取较大刀径作为间隙阈值
    if (hasAbnormalEdge) {
      return roundConflictNum(
        Math.max(Number(diameter) || 0, Number(sawDiameter) || 0) +
          gap +
          0.5 +
          extraGap
      )
    }

    // 如果没对齐且下料刀半径大于锯切刀径，则取下料刀半径作为间隙阈值
    if (
      ['top', 'bottom'].includes(direction) &&
      !isAlign &&
      diameter / 2 > sawDiameter
    ) {
      return roundConflictNum(
        (Number(diameter / 2) || 0) + gap + 0.5 + extraGap
      )
    }

    return roundConflictNum((Number(sawDiameter) || 0) + gap + extraGap)
  } else {
    return roundConflictNum((Number(diameter) || 0) + layoutGap + extraGap)
  }
}

/** 校验四周相邻小板与当前板各方向扩版 rect 的间隙是否满足 pathEdge 规则 */
function checkNeighborPlankGapByPathEdge(
  plank,
  nearestPartsMap,
  directionRectObj,
  diameter,
  sawDiameter
) {
  const directions = ['left', 'right', 'top', 'bottom']

  for (const direction of directions) {
    /** 相邻的小板 */
    const neighbor = nearestPartsMap[direction]
    if (!neighbor) continue
    /** 当前的小板的矩形区域 */
    const currentRect = directionRectObj[direction]
    /** 相邻的小板的矩形区域 */
    const neighborRect = getRealRectOnBigpart(neighbor)
    if (!currentRect || !neighborRect) continue
    /** 计算两板在指定方向上相邻边的间隙，无有效对向重叠时返回 Infinity */
    const gap = getGapBetweenDirectionRects(
      plank,
      neighbor,
      direction,
      diameter,
      sawDiameter
    )
    if (!Number.isFinite(gap)) continue

    /** 计算两板在指定方向上相邻边的间隙，无有效对向重叠时返回 Infinity */
    const requiredGap = getAdjacentEdgeRequiredGap(
      plank,
      neighbor,
      direction,
      diameter,
      sawDiameter
    )
    // console.log(gap, requiredGap, '-----')
    const decimal = getConflictCheckDecimal()
    const gapRounded = roundConflictNum(gap)
    const requiredRounded = roundConflictNum(requiredGap)
    const eps = Math.pow(10, -decimal)

    if (
      roundConflictNum(Math.abs(gapRounded - requiredRounded)) <= eps ||
      gapRounded > requiredRounded
    ) {
      continue
    } else {
      return false
    }
  }
  return true
}

/** 锯切板件：检测当前板 rect 是否与板场内其他小板 rect 重叠 */
function hasSawPlankRectOverlapWithOthers(plank, bigpart) {
  if (!plank.rect) return false
  const currentRect = getPlankRectOnBigpart(plank)
  const otherParts = bigpart.parts.filter(
    (part) =>
      !part.hasOwnProperty('blueAreaSurplus') &&
      part.partUniqueId !== plank.partUniqueId &&
      part.rect
  )
  return otherParts.some((part) => {
    return judgeRectIntersect(currentRect, getPlankRectOnBigpart(part))
  })
}

// 判断单个大板的板件冲突情况, 用于板件旋转
export function checkOneBigpart(bigpart) {
  // 记录是否产生过冲突
  let isConflict = false
  // 过滤掉带有cy字段的板件，但不影响原始数据
  const filteredParts = bigpart.parts.filter(
    (part) => !part.hasOwnProperty('blueAreaSurplus')
  )
  for (let k = 0; k < filteredParts.length; ++k) {
    let plank = filteredParts[k]
    // 判断一个小板和大板, 其他小板的冲突情况
    let flag = checkOnePlank(plank, bigpart)
    plank.plankMerge = !flag
    // 冲突
    if (!isConflict && !flag) {
      isConflict = true
    } else {
      isConflict = false
    }
  }
  return isConflict
}

// 判断单个板件是否和大板冲突, 用于板件拖动和键盘控制板件
export function checkOnePlank(plank, bigpart) {
  // 如果当前板件带有cy字段，直接返回true（不冲突）
  if (plank.hasOwnProperty('blueAreaSurplus')) {
    return true
  }

  let bigPlank = []
  // if (bigpart.bigPlank) {
  //   bigPlank = bigpart.bigPlank
  // } else {
  dealBigPlank(bigpart)
  bigPlank = bigpart.bigPlank
  // }
  // isMerge为false时, 代表板件出现冲突
  let isMerge = false
  if (!checkPlankOutlineKey(plank)) {
    dealPlankPoly(plank)
  }

  if (
    (plank.isUseSaw ||
      (plank.finalExtendDisMap &&
        Object.values(plank.finalExtendDisMap).some((value) => value))) &&
    plank.realRect
  ) {
    // 锯切板件优先：rect 与其他小板 rect 重叠则直接判定冲突
    if (plank.isUseSaw && hasSawPlankRectOverlapWithOthers(plank, bigpart)) {
      return false
    }

    const offsetX = roundConflictNum(
      (plank.rect.width - plank.realRect.width) / 2
    )
    const offsetY = roundConflictNum(
      (plank.rect.height - plank.realRect.height) / 2
    )
    const offsetRect = {
      x: roundConflictNum(plank.realRect.x + plank.startX + offsetX),
      y: roundConflictNum(plank.realRect.y + plank.startY + offsetY),
      width: roundConflictNum(plank.realRect.width),
      height: roundConflictNum(plank.realRect.height),
    }
    const directionRectObj = {
      left: { ...offsetRect },
      right: { ...offsetRect },
      top: { ...offsetRect },
      bottom: { ...offsetRect },
    }

    const stockKey = plank.stockKey || bigpart.stockKey
    const diameter = roundConflictNum(
      getPlateKnifeDiameter(stockKey, store.state.ncSetting)
    )
    const sawDiameter = roundConflictNum(getSawKnife(store.state.ncSetting))
    const RANGE = roundConflictNum(
      50 + (plank.isUseSaw ? sawDiameter : diameter)
    )
    const nearestPartsMap = getNearestPartsInRange(plank, bigpart, RANGE)

    if (plank.finalExtendDisMap) {
      const left = roundConflictNum(plank.finalExtendDisMap.left)
      const right = roundConflictNum(plank.finalExtendDisMap.right)
      const top = roundConflictNum(plank.finalExtendDisMap.top)
      const bottom = roundConflictNum(plank.finalExtendDisMap.bottom)
      if (left) {
        directionRectObj.left.width = roundConflictNum(
          directionRectObj.left.width + left
        )
        directionRectObj.left.x = roundConflictNum(
          directionRectObj.left.x - left
        )
      }
      if (right) {
        directionRectObj.right.width = roundConflictNum(
          directionRectObj.right.width + right
        )
      }
      if (top) {
        directionRectObj.top.height = roundConflictNum(
          directionRectObj.top.height + top
        )
        directionRectObj.top.y = roundConflictNum(
          directionRectObj.top.y - top
        )
      }
      if (bottom) {
        directionRectObj.bottom.height = roundConflictNum(
          directionRectObj.bottom.height + bottom
        )
      }
    }

    if (
      !checkNeighborPlankGapByPathEdge(
        plank,
        nearestPartsMap,
        directionRectObj,
        diameter,
        sawDiameter
      )
    ) {
      return false
    }
  }

  // 大板边框轮廓
  const [rawX1, rawY1, rawX2, rawY2] = getPathMinMaxPoint(
    bigPlank[0].map((it) => ({ x: it.X, y: it.Y }))
  )
  const x1 = roundConflictNum(rawX1)
  const y1 = roundConflictNum(rawY1)
  const x2 = roundConflictNum(rawX2)
  const y2 = roundConflictNum(rawY2)
  const { _plankBoundBox: currentPlankBoundBox } = plank
  // 处理处理了板件轮廓这个对象必然有值
  const currentPlankBoundBoxFirst = {
    x1: roundConflictNum(currentPlankBoundBox[0].x1),
    y1: roundConflictNum(currentPlankBoundBox[0].y1),
    x2: roundConflictNum(currentPlankBoundBox[0].x2),
    y2: roundConflictNum(currentPlankBoundBox[0].y2),
  }
  let bigPlankContainPlank = true
  // 是否是L形或异形的余料
  if (
    isLShapeSurplusBigPlank(bigpart) ||
    isSpecialShapeSurplusBigPlank(bigpart)
  ) {
    const plankPath = rectToPath(currentPlankBoundBoxFirst).map((it) => ({
      X: it.x,
      Y: it.y,
    }))
    bigPlankContainPlank = polyContain(bigPlank, [plankPath])

    // 如果判断存在冲突则在使用完整的路径进行二次判断
    if (!bigPlankContainPlank && plank.path) {
      bigPlankContainPlank = polyContain(bigPlank, [plank.polyArr[0]])
    }
  } else {
    const { rect1ContainsRect2 } = isRectangleContained(
      { x1, y1, x2, y2 },
      currentPlankBoundBoxFirst
    )
    bigPlankContainPlank = rect1ContainsRect2
  }

  // 如果大板轮廓完全包含小板则不再进行判断小板是不是在大板轮廓内
  if (bigPlankContainPlank) {
    isMerge = true
  } else {
    // 当大板不完全包含小板则判断是否存在碰撞，存在碰撞直接返回冲突状态
    const { x1: px1, y1: py1, x2: px2, y2: py2 } = currentPlankBoundBoxFirst
    const flag = judgeRectIntersect(
      { x1, y1, x2, y2 },
      { x1: px1, y1: py1, x2: px2, y2: py2 }
    )
    if (flag) return isMerge
  }
  if (!isMerge) {
    // 当逻辑走到此处说明小板已在大板外，不做后面的处理
    return isMerge
  }
  // 开启台面宽度限制时，小板不可超出台面有效宽度（xyReverse 时限制 Y）
  const plankWidth = roundConflictNum(
    Number(bigpart.plankWidth) ||
      Number(bigpart.surplusInfo?.width) ||
      Math.abs(x2 - x1)
  )
  const plankHeight = roundConflictNum(
    Number(bigpart.plankHeight) ||
      Number(bigpart.surplusInfo?.height) ||
      Number(bigpart.surplusInfo?.long) ||
      Math.abs(y2 - y1)
  )
  if (
    isBoundBoxOutsideCounter(
      currentPlankBoundBoxFirst,
      { plankWidth, plankHeight, bigpart },
      store.state.ncSetting
    )
  ) {
    return false
  }
  // 获取当前板件的轮廓
  const plank1Outline = currentPlankBoundBoxFirst
  // 过滤掉带有cy字段的板件，但不影响原始数据
  const filteredParts = bigpart.parts.filter(
    (part) => !part.hasOwnProperty('blueAreaSurplus')
  )

  for (const _plank of filteredParts) {
    // 当前循环板件如果和需要判断的板件相同则不比较
    if (_plank.index === plank.index) continue
    if (!checkPlankOutlineKey(_plank)) {
      dealPlankPoly(_plank)
    }
    const plank21Outline = {
      x1: roundConflictNum(_plank._plankBoundBox[0].x1),
      y1: roundConflictNum(_plank._plankBoundBox[0].y1),
      x2: roundConflictNum(_plank._plankBoundBox[0].x2),
      y2: roundConflictNum(_plank._plankBoundBox[0].y2),
    }
    // 预先判断两个盒子的边界情况，如边界不存在任何相交可能则不再进行下一步操作
    if (!judgeRectIntersect(plank1Outline, plank21Outline)) continue
    // 边界已出现碰撞，进行更加精细的判断板件是否相交
    isMerge = polyIntersect([plank.polyArr[0]], [_plank.polyArr[0]])
    // // 返回值为true说明板件并未出现相交的情况，跳过这次对比
    if (isMerge) continue
    // 判断两个板件是否出现互相容纳
    const { isContain } = isRectangleContained(
      currentPlankBoundBoxFirst,
      plank21Outline
    )
    // 如果两个板件只是碰撞并未出现容纳状态直接返回冲突状态
    if (!isContain) return isMerge
    // 执行到此处说明两个小板出现了碰撞且出现了容纳,则继续判断两个板件内轮廓和外轮廓的关系
    isMerge =
      judgePart1ContainPart2(plank, _plank) ||
      judgePart1ContainPart2(_plank, plank)
    // 如出现内轮廓冲突则抛出冲突状态，不在检查剩余板件
    if (!isMerge) return
  }
  return isMerge
}

export function checkPathInPlankMerge(path, bigpart) {
  /** 包装成小板数据 */
  const plank = {}
  const upperPath = toUpperPointPath(path)
  plank.polyArr = [upperPath]
  plank.path = path
  plank.index = -1
  plank._plankBoundBox = []
  plank._curveHolesPoly = []
  plank._curveHolesBoundBox = []
  const minX = Math.min(...path.map((it) => it.x))
  const minY = Math.min(...path.map((it) => it.y))
  const maxX = Math.max(...path.map((it) => it.x))
  const maxY = Math.max(...path.map((it) => it.y))
  plank._plankBoundBox.push({
    x1: minX,
    y1: minY,
    x2: maxX,
    y2: maxY,
  })
  return checkOnePlank(plank, bigpart)
}

/**
 * @description 为板件生成外/内部轮廓以及边界框,包含长圆孔(coverHoles)
 * @param {array} path 路径
 * @param {object} ncSetting NC设置
 */
function genPlankOutLineOrBoundBox(path, startX, startY, ncSetting, up = true) {
  const { decimal } = ncSetting
  // 采用什么字段作为key
  const [xField, yField] = up ? ['X', 'Y'] : ['x', 'y']
  // 板件轮廓
  let x1 = Infinity,
    y1 = Infinity,
    x2 = -Infinity,
    y2 = -Infinity

  const newPath = path.map((point) => {
    const x = toDecimal(startX + point.x, decimal)
    const y = toDecimal(startY + point.y, decimal)
    x1 = Math.min(x1, x)
    y1 = Math.min(y1, y)
    x2 = Math.max(x2, x)
    y2 = Math.max(y2, y)

    return { [xField]: x, [yField]: y }
  })
  return {
    path: newPath,
    boundBox: { x1, y1, x2, y2 },
  }
}

// 处理板件轮廓点位
export function dealPlankPoly(plank, setting = null) {
  let storeSetting = setting ? setting : store
  const { decimal } = storeSetting.state.ncSetting
  let { startX, startY, curveHoles } = plank
  let plankPoly = []
  // 板件轮廓边界框信息 信息存储在板件上
  const _plankBoundBox = []
  // 长圆孔轮廓信息 信息存储在板件上
  const _curveHolesPoly = []
  // 长圆孔轮廓边界信息 信息存储在板件上
  const _curveHolesBoundBox = []
  if (curveHoles) {
    curveHoles.forEach((curveHole) => {
      if (!compareNumbers(curveHole.deep, plank.thick)) return
      const { path = [] } = curveHole
      const { path: newPath, boundBox } = genPlankOutLineOrBoundBox(
        path,
        startX,
        startY,
        storeSetting.state.ncSetting
      )
      _curveHolesPoly.push(newPath)
      _curveHolesBoundBox.push(boundBox)
    })
  }

  let paths = plank?.unionPath ? plank.unionPath : plank.path
  // 锯切异形 startX/startY 已是绿框左上角：有 path 时必须用绿路径算包围盒，
  // 不能再用 rect（排版框），否则会变成「绿框原点 + 排版尺寸」错位导致误报冲突
  if (paths) {
    if (!Array.isArray(paths[0])) {
      paths = [paths]
    }
    let array = []
    let area = ClipperLib.JS.AreaOfPolygon(paths[0])
    // 将异形路径中外轮廓点位处理成顺时针点位
    if (area < 0) {
      paths[0].reverse()
    }
    for (let i = 0; i < paths.length; ++i) {
      const { path, boundBox } = genPlankOutLineOrBoundBox(
        paths[i],
        startX,
        startY,
        storeSetting.state.ncSetting
      )
      array.push(path)
      _plankBoundBox.push(boundBox)
    }
    plankPoly = array
  } else {
    plankPoly = [
      [
        { X: toDecimal(startX, decimal), Y: toDecimal(startY, decimal) },
        {
          X: toDecimal(startX + plank.rect.width, decimal),
          Y: toDecimal(startY, decimal),
        },
        {
          X: toDecimal(startX + plank.rect.width, decimal),

          Y: toDecimal(startY + plank.rect.height, decimal),
        },
        {
          X: toDecimal(startX, decimal),

          Y: toDecimal(startY + plank.rect.height, decimal),
        },
      ],
    ]
    _plankBoundBox.push({
      x1: startX,
      y1: startY,
      x2: toDecimal(startX + plank.rect.width, decimal),
      y2: toDecimal(startY + plank.rect.height, decimal),
    })
  }
  plank.polyArr = plankPoly
  plank._plankBoundBox = _plankBoundBox
  plank._curveHolesPoly = _curveHolesPoly
  plank._curveHolesBoundBox = _curveHolesBoundBox
}

// 处理板件轮廓点位  todo
// export function dealPlankPoly(plank, setting = null) {
//   let storeSetting = setting ? setting : store
//   const { decimal } = storeSetting.state.ncSetting
//   let { startX, startY } = plank
//   let plankPoly = []
//   if (plank.path) {
//     let array = []
//     let area = ClipperLib.JS.AreaOfPolygon(plank.path[0])
//     // 将异形路径中外轮廓点位处理成顺时针点位
//     if (area < 0) {
//       plank.path[0].reverse()
//     }

//     for (let i = 0; i < plank.path.length; ++i) {
//       let pointArr = []
//       for (let k = 0; k < plank.path[i].length; ++k) {
//         let point = JSON.parse(JSON.stringify(plank.path[i][k]))
//         let newPoint = {
//           X: toDecimal(startX + point.x, decimal),
//           Y: toDecimal(startY + point.y, decimal),
//         }
//         pointArr.push(newPoint)
//       }
//       array.push(pointArr)
//     }
//     plankPoly = array
//   } else {
//     plankPoly = [
//       [
//         { X: toDecimal(startX, decimal), Y: toDecimal(startY, decimal) },
//         {
//           X: toDecimal(startX + plank.rect.width, decimal),
//           Y: toDecimal(startY, decimal),
//         },
//         {
//           X: toDecimal(startX + plank.rect.width, decimal),

//           Y: toDecimal(startY + plank.rect.height, decimal),
//         },
//         {
//           X: toDecimal(startX, decimal),

//           Y: toDecimal(startY + plank.rect.height, decimal),
//         },
//       ],
//     ]
//   }
//   plank.polyArr = plankPoly
// }

// 处理大板外轮廓点位
export function dealBigPlank(bigpart) {
  let ncSetting = store.state.ncSetting
  const allSaw =
    bigpart.isUseSaw && bigpart.parts?.every((part) => part.isUseSaw)
  const allNoSaw =
    !bigpart.isUseSaw && bigpart.parts?.every((part) => !part.isUseSaw)
  const mixedSaw = !allSaw && !allNoSaw
  // let plankOffset = Math.abs(
  //   ncSetting.knife.diameter / 2 - ncSetting.panelSize.plankEdgeOff
  // )

  // todo 功能存在问题代码暂停执行
  // const trimSide =
  //   store.state.isHistoryStatus && !NOTROTATELGAP
  //     ? window.sessionStorage.getItem('trimSide')
  //     : ncSetting.trimSide
  const trimSide = CODE_PAUSE

  const standardPlank = store.state.selectStandardPlank
  const sawKnives = ncSetting.sawSetting?.mentaoji_saws
  if (sawKnives) {
    const hSawKnives = sawKnives
      .filter((item) => item.saw_direction == 'H')
      .map((item) => item.saw_width)
    sawKnivesDiameter = Number(Math.min(...hSawKnives))
  } else {
    // 预排版里面的 横切刀直径
    sawKnivesDiameter = Number(ncSetting.sawSetting?.horizontalWidth)
  }
  let diameter = +getPlateKnifeDiameter(bigpart.stockKey, ncSetting)
  if (mixedSaw) {
    diameter = Math.max(
      sawKnivesDiameter,
      +getPlateKnifeDiameter(bigpart.stockKey, ncSetting)
    )
  } else if (allSaw) {
    diameter = sawKnivesDiameter
  } else if (allNoSaw) {
    diameter = +getPlateKnifeDiameter(bigpart.stockKey, ncSetting)
  }
  // 处理特殊板有四边修边情况
  let plankOffsetFront
  let plankOffsetBack
  let plankOffsetLeft
  let plankOffsetRight
  let plankEdgeFront
  let plankEdgeBack
  let plankEdgeLeft
  let plankEdgeRight
  // 前,后,左,右
  const isUseSaw = bigpart.isUseSaw
  const plankMargin =
    bigpart.surplusInfo && bigpart.surplusInfo.is_plus
      ? isUseSaw
        ? bigpart.margin
        : store.state.selectStandardPlank.plankEdgeOff
      : bigpart.margin
  if (plankMargin.toString().includes(',')) {
    const edgeArr = plankMargin.split(',')
    plankOffsetFront = Number(edgeArr[0]) - diameter / 2
    plankOffsetBack = Number(edgeArr[1]) - diameter / 2
    plankOffsetLeft = Number(edgeArr[2]) - diameter / 2
    plankOffsetRight = Number(edgeArr[3]) - diameter / 2
    plankEdgeFront = Number(edgeArr[0])
    plankEdgeBack = Number(edgeArr[1])
    plankEdgeLeft = Number(edgeArr[2])
    plankEdgeRight = Number(edgeArr[3])
  } else {
    plankOffsetFront = Number(plankMargin) - diameter / 2
    plankOffsetBack = Number(plankMargin) - diameter / 2
    plankOffsetLeft = Number(plankMargin) - diameter / 2
    plankOffsetRight = Number(plankMargin) - diameter / 2
    plankEdgeFront = Number(plankMargin)
    plankEdgeBack = Number(plankMargin)
    plankEdgeLeft = Number(plankMargin)
    plankEdgeRight = Number(plankMargin)
  }
  const [minX, minY, maxX, maxY] = getPathMinMaxPoint(bigpart.path)
  let plankWidth = maxX - minX
  let plankHeight = maxY - minY
  let bigPlank = []
  // 存储板件边框减去修边值，用于计算大板剩余距离
  let bigPlankShrinkPolygon = []
  if (
    isLShapeSurplusBigPlank(bigpart) ||
    isSpecialShapeSurplusBigPlank(bigpart)
  ) {
    // L型余料现不在需要各种判断，只需要根据大板轮廓来扩张/收缩得到其他类型的数据即可
    // 还有为什么是常规矩形和矩形余料的情况下不通过 expandPath来扩张路径? 因为 L 型余料的四边用的是同一个修边值
    let path = toUpperCasePoint(bigpart.path) || []
    path = transformPathByDirection(path, 'cck', true)
    const edgePath = [
      expandPathBySurplus(plankEdgeLeft * -1, window.$copy(path)),
    ]
    // 0.01 是补偿值，因为 expandPath 的精度问题，导致最后的结果会有误差
    const expandedPaths = expandPath(diameter / 2 + 0.01, edgePath[0])

    bigPlank = [toUpperPointPath(expandedPaths[0])]
    bigPlankShrinkPolygon = expandedPaths[0]
  } else {
    bigPlank = [
      [
        { X: plankOffsetLeft, Y: plankOffsetFront },
        { X: plankWidth - plankOffsetRight, Y: plankOffsetFront },
        { X: plankWidth - plankOffsetRight, Y: plankHeight - plankOffsetBack },
        { X: plankOffsetLeft, Y: plankHeight - plankOffsetBack },
      ],
    ]
    bigPlankShrinkPolygon = [
      { x: plankEdgeLeft, y: plankEdgeFront },
      { x: plankWidth - plankEdgeRight, y: plankEdgeFront },
      { x: plankWidth - plankEdgeRight, y: plankHeight - plankEdgeBack },
      { x: plankEdgeLeft, y: plankHeight - plankEdgeBack },
    ]
  }
  bigpart.bigPlank = bigPlank
  bigpart.bigPlankShrinkPolygon = bigPlankShrinkPolygon
}

export function dealHoleSlotCloseSide(paibanData) {
  return paibanData.map((data) => {
    data.parts = dealPlankHoleSlotCSide(data.parts)
    return data
  })
}

export function dealPlankHoleSlotCSide(parts) {
  parts.forEach((part) => {
    part.holes.forEach((hole) => {
      if (
        (hole.isSide && hole.isSide == '1') ||
        (store.state.ncSetting.sideHoleDrill &&
          store.state.ncSetting.side_machine_hole_slot.HINGE &&
          hole.symbol === 'HINGE')
      ) {
        const directionArr = [
          hole.ocenter.x,
          part.rect.height - hole.ocenter.y,
          part.rect.width - hole.ocenter.x,
          hole.ocenter.y,
        ]
        const minD = Math.min(...directionArr)
        hole.cSide = `${directionArr.indexOf(minD) + 1}`
      }
    })
    part.slots.forEach((slot) => {
      if (
        (slot.isSide && slot.isSide == '1') ||
        (store.state.ncSetting.sideHoleDrill &&
          store.state.ncSetting.side_machine_hole_slot.STRENTCH &&
          ['STRENTCH', 'STRENTCHTWO', 'MIDSTRENTCH'].includes(slot.symbol))
      ) {
        const w = Math.abs(slot.pt1.x - slot.pt2.x)
        const h = Math.abs(slot.pt1.y - slot.pt2.y)
        // 横拉槽
        if (w > h) {
          const d1 = slot.pt1['y']
          const d2 = part.rect.height - slot.pt1['y']
          slot.cSide = d1 < d2 ? '4' : '2'
        } else {
          const d1 = slot.pt1['x']
          const d2 = part.rect.width - slot.pt1['x']
          slot.cSide = d1 < d2 ? '1' : '3'
        }
      }
    })
  })

  return parts
}
/**
 * 将排版接口返回数据处理成排版
 * @param { Object } preData // 预处理数据
 * @param { Object } paibanResultData // 排版接口返回数据
 * @param { Boolean } needSave // 是否需要重新保存数据
 * @param { Boolean } isHistory // 是否需要切换历史记录的状态
 * @param { Boolean | object } isPerLoad // 是否是开启预加载数据
 * @param { Object } layoutConfig // 对排版结果有影响的数据排版结果有影响的数据排版大板长宽/以及其他数据
 */
export async function paibanDataToView(
  preData,
  paibanResultData,
  needSave = true,
  isHistory = false,
  isPerLoad = false,
  layoutConfig = {}
) {
  const ncSetting = store.state.ncSetting
  const keys = Object.keys(paibanResultData)
  if (!keys.length) return
  for (let i = 0; i < keys.length; ++i) {
    for (let k = 0; k < paibanResultData[keys[i]].data[0].length; ++k) {
      let part = paibanResultData[keys[i]].data[0][k]
      if (part.rect) {
        part.rect = {
          x: part.rect.x1,
          y: part.rect.y1,
          width: part.rect.x2,
          height: part.rect.y2,
        }
      }
    }
  }
  // 彩色标签数据源判断逻辑
  // 订单 房间 柜体 任何一个数据源超过12个，则toast提示彩色标签不生效
  const judgeL = judgeSourceData(preData)
  let judgeLimit = false
  for (let key in judgeL) {
    if (judgeL[key].length > 12) {
      judgeLimit = true
    }
  }
  let colorRes = {}
  if (!judgeLimit) {
    colorRes = genColorRes(judgeL)
  }
  let finalPaibanData = await afterProcess(
    paibanResultData,
    preData,
    ncSetting,
    isPerLoad,
    colorRes,
    layoutConfig
  )
  Object.keys(finalPaibanData).forEach((key) => {
    finalPaibanData[key].data.forEach((data) => {
      Object.keys(data).forEach((dataKey) => {
        data[dataKey].parts = dealPlankHoleSlotCSide(data[dataKey].parts)
      })
    })
  })
  let finalKeys = Object.keys(finalPaibanData)
  let paibanData = []
  // 记录每一块大板的优化率(这个接口的返回值, 整麻了)
  for (let i = 0; i < finalKeys.length; ++i) {
    let plankKeys = Object.keys(finalPaibanData[finalKeys[i]].data[0])
    for (let j = 0; j < plankKeys.length; ++j) {
      let bigpart = finalPaibanData[finalKeys[i]].data[0][plankKeys[j]]

      for (let k = 0; k < finalPaibanData[finalKeys[i]].used_rate.length; ++k) {
        let rate = finalPaibanData[finalKeys[i]].used_rate[k]
        if (rate.stock_num == bigpart.stockNum) {
          // 将优化率为100%的处理一下, 不要显示百分百的优化率
          if (rate.rate == 1) {
            let height = 0
            if (
              bigpart.surplusInfo &&
              Object.keys(bigpart.surplusInfo).length > 0
            ) {
              if (
                bigpart.surplusInfo.shape &&
                Reflect.has(bigpart.surplusInfo, 'x3') &&
                bigpart.surplusInfo.shape == 'lshape'
              ) {
                height = bigpart.surplusInfo.y3
              } else {
                height = bigpart.surplusInfo.height
              }
            } else {
              height = store.state.selectStandardPlank.plankHeight
            }
            let minHeight = 9999999
            let maxHeight = 0
            bigpart.parts.forEach((plank) => {
              if (plank.startY < minHeight) {
                minHeight = plank.startY
              }
              if (plank.startY + plank.rect.height > maxHeight) {
                maxHeight = plank.startY + plank.rect.height
              }
            })
            let finalHeight = Math.abs(maxHeight - minHeight)
            // 计算优化率
            let rate = 1
            if (finalHeight > height) {
              rate = 1
            } else {
              rate = finalHeight / height
            }
            if (rate == 1) {
              rate = 0.95
            }
            bigpart.usedRate = rate
          } else {
            bigpart.usedRate = rate.rate
          }
        }
      }
      bigpart.parts.forEach((part) => {
        // 添加一个二次切割的标识
        // part.isSecondaryCutting = isLongPlateProcessing(part, ncSetting)
        const sh = part.holes.filter((hole) => isOtherSideMachineHole(hole))
        const sl = part.slots.filter((slot) => isOtherSideMachineSlot(slot))
        part.sholeInfo = generatorSideHoleSlot([
          ...part.sholes,
          ...sh.filter((h) => h.side == '1'),
        ])
        part.sholeInfoF = generatorSideHoleSlot(
          sh.filter((h) => h.side == '-1'),
          'upDownFlip'
        )
        // 开启 侧孔机加工牛角拉手 需将牛角拉手放到侧槽信息里面
        let sideMillInfo = part?.millInfo?.filter((mill) =>
          isSideMachineMillInfo(mill)
        )
        part.sslotInfo = generatorSideHoleSlot(
          [
            ...part.sslots,
            ...sl.filter((l) => l.side == '1'),
            ...(sideMillInfo
              ? sideMillInfo?.filter((mill) => mill.side == '1')
              : []),
          ],
          '',
          part
        )
        part.sslotInfoF = generatorSideHoleSlot(
          sl.filter((l) => l.side == '-1'),
          'upDownFlip',
          part
        )
      })
      // 给大板添加焊接板的属性
      bigpart.isWeldingPlank = bigpart.parts.some((part) => part.isWeldingPlank)
      /** 大板是否使用的锯切排版 */
      bigpart.isUseSaw = bigpart.parts.every((part) => part.isUseSaw)
      paibanData.push(bigpart)
    }
  }
  // 记录使用的余料参数
  if (needSave) {
    let surplusObj = setSurplusObj(paibanData)
    store.commit('setSurplusParams', surplusObj)
  }
  // 靠边槽旋转
  Object.keys(finalPaibanData).forEach((key) => {
    finalPaibanData[key].data.forEach((data) => {
      Object.keys(data).forEach((dataKey) => {
        data[dataKey].parts.forEach((part) => {
          // 对纹板件不生效靠边板槽旋转
          if (isTextureAlignmentPlank(part)) return
          // 前封边旋转高于靠边板槽
          if (!ncSetting.xyReverse && !part.isRotateFrontEdge) {
            // 将原点重置为左下角再进行判断
            let { startX, startY, rect, plankHeight, plankWidth } = part
            if (ncSetting.startPosition === '左上角') {
              startY = plankHeight - rect.height - startY
            } else if (ncSetting.startPosition === '右上角') {
              startY = plankHeight - rect.height - startY
              startX = plankWidth - rect.width - startX
            } else if (ncSetting.startPosition === '右下角') {
              startX = plankWidth - rect.width - startX
            }

            if (
              judgeSlotIsRotate(
                part,
                ncSetting,
                startX,
                startY,
                part.plankWidth,
                part.plankHeight,
                data[dataKey].margin
              )
            ) {
              rotate180Part(part, 'dealPaibanData-rotate180')
            }
          }
        })
      })
    })
  })
  paibanData = viewDataToNCData(paibanData, 'toView')
  // [锯切异形] 绿路径归一化到局部 min=0。start 保持 changePositionCutOrigin 的 view 锚点，
  // 不再加/减锯片半径，否则贴边板件会从上、右两侧探出大板。
  paibanData.forEach((item) => {
    item.parts.forEach((part) => {
      if (!part.__sawLayout || !part.path?.[0]?.length) return
      const xs = part.path[0].map((p) => p.x)
      const ys = part.path[0].map((p) => p.y)
      const gminX = Math.min(...xs)
      const gminY = Math.min(...ys)
      part.path.forEach((pathPts) => {
        pathPts.forEach((p) => {
          p.x -= gminX
          p.y -= gminY
        })
      })
      part.startX += gminX
      part.startY += gminY
      // 焊接板 rect 与绿路径外接矩形对齐，避免仍用排版框宽高
      if (part.isWeldingPlank && part.rect) {
        const { width, height } = getWHByPath(part.path[0])
        part.rect.width = width
        part.rect.height = height
      }
    })
  })
  applyLastCutPoint(paibanData, ncSetting.movePlankSetting)
  //  第一次生成大板外轮廓数据时，不进行L形余料缺口的旋转。也就是下方checkPlank会一层层调dealBigPlank(生成大板外轮廓的方法)，为了避免一层层传参，设了这个全局变量
  NOTROTATELGAP = true
  store.state.ncSetting.drawPlankWidth = ncSetting.xyReverse
    ? store.state.selectStandardPlank.plankHeight
    : store.state.selectStandardPlank.plankWidth
  store.state.ncSetting.drawPlankHeight = ncSetting.xyReverse
    ? store.state.selectStandardPlank.plankWidth
    : store.state.selectStandardPlank.plankHeight
  store.state.ncSetting.drawPlankEdgeOff =
    store.state.selectStandardPlank.plankEdgeOff
  // 判断孔槽冲突
  checkAllPlankHoleSlot(paibanData)
  // 判断板件冲突
  checkPlank(paibanData)
  // 弃用旧的L形余料缺口旋转逻辑
  // handleLShapePart(paibanData, ncSetting)
  if (needSave) {
    if (ncSetting.sideHoleVerticalEnable) {
      store.commit('setPaibanData', dealHoleSlotCloseSide(paibanData))
    } else {
      store.commit('setPaibanData', paibanData)
    }
  }
  // 如果是历史记录重新进行了排版, 则可以允许二次保存, 取消vuex中记录的"是否为历史记录"的状态
  if (isHistory) {
    window.sessionStorage.removeItem('isHistory')
    store.commit('changeHistoryStatus', false)
    store.commit('setIsLockedRePaiban', false)
  }
  // 处理完排版数据后 排版页点击板件等时 旋转L形余料缺口 具体逻辑见dealBigPlank
  NOTROTATELGAP = false
  // 这里拿到的数据才是对startX，startY处理完的数据
  // 在小板上增加一个排版页对比的原始数据
  paibanData.forEach((item) => {
    item.parts.forEach((part) => {
      part.oriMarkBoards = {
        startX: part.startX,
        startY: part.startY,
        cutOrigin: part.cutOrigin,
        priority: part.priority,
      }
    })
  })
  return paibanData
}

/**
 * 处理L形余料大板缺口旋转后小板的位置
 * @param {*} paibanData
 * @param {Object} ncSetting
 *
 * 高光板只生效修边为右上，左下的缺口旋转
 */
export function handleLShapePart(paibanData, ncSetting) {
  if (!CODE_PAUSE) {
    return
  }
  paibanData.forEach((bigpart) => {
    if (bigpart.surplusInfo && Object.keys(bigpart.surplusInfo).length > 0) {
      let surplus = bigpart.surplusInfo
      if (surplus.shape && surplus.shape == 'lshape') {
        let newWidth = surplus.width
        let newHeight = surplus.height
        bigpart.surplusInfo.gapDir = 'topRight'
        if (bigpart.bigPlank && NOTROTATELGAP) {
          if (
            ncSetting.trimSide === 'topRight' &&
            !ncSetting.xyReverse &&
            !bigpart.parts[0].is_high_gloss_plank
          ) {
            bigpart.bigPlank[0] = bigpart.bigPlank[0].map((point) => {
              point.Y = newHeight - point.Y
              return point
            })
            bigpart.bigPlankShrinkPolygon = bigpart.bigPlankShrinkPolygon.map(
              (point) => {
                point.y = newHeight - point.y
                return point
              }
            )
            bigpart.surplusInfo.gapDir = 'bottomRight'
          } else if (
            ncSetting.trimSide === 'bottomLeft' &&
            !ncSetting.xyReverse &&
            !bigpart.parts[0].is_high_gloss_plank
          ) {
            bigpart.bigPlank[0] = bigpart.bigPlank[0].map((point) => {
              point.X = newWidth - point.X
              return point
            })
            bigpart.bigPlankShrinkPolygon = bigpart.bigPlankShrinkPolygon.map(
              (point) => {
                point.x = newWidth - point.x
                return point
              }
            )
            bigpart.surplusInfo.gapDir = 'topLeft'
          } else if (ncSetting.trimSide === 'topLeft' && !ncSetting.xyReverse) {
            bigpart.bigPlank[0] = bigpart.bigPlank[0].map((point) => {
              point.X = newWidth - point.X
              point.Y = newHeight - point.Y
              return point
            })
            bigpart.bigPlankShrinkPolygon = bigpart.bigPlankShrinkPolygon.map(
              (point) => {
                point.x = newWidth - point.x
                point.y = newHeight - point.y
                return point
              }
            )
            bigpart.surplusInfo.gapDir = 'bottomLeft'
          }
        }
        bigpart.parts.forEach((e) => {
          if (
            ncSetting.trimSide === 'topRight' &&
            !ncSetting.xyReverse &&
            !bigpart.parts[0].is_high_gloss_plank
          ) {
            e.startY = toDecimal(
              newHeight - e.startY - e.rect.height,
              ncSetting.decimal
            )
            e.cutOrigin = e.cutOrigin.includes('Top')
              ? e.cutOrigin.replace('Top', 'Bottom')
              : e.cutOrigin.replace('Bottom', 'Top')
          } else if (
            ncSetting.trimSide === 'bottomLeft' &&
            !ncSetting.xyReverse &&
            !bigpart.parts[0].is_high_gloss_plank
          ) {
            e.startX = toDecimal(
              newWidth - e.startX - e.rect.width,
              ncSetting.decimal
            )
            e.cutOrigin = e.cutOrigin.includes('left')
              ? e.cutOrigin.replace('left', 'right')
              : e.cutOrigin.replace('right', 'left')
          } else if (ncSetting.trimSide === 'topLeft' && !ncSetting.xyReverse) {
            e.startX = toDecimal(
              newWidth - e.startX - e.rect.width,
              ncSetting.decimal
            )
            e.startY = toDecimal(
              newHeight - e.startY - e.rect.height,
              ncSetting.decimal
            )
            e.cutOrigin = e.cutOrigin.includes('left')
              ? e.cutOrigin.replace('left', 'right')
              : e.cutOrigin.replace('right', 'left')
            e.cutOrigin = e.cutOrigin.includes('Top')
              ? e.cutOrigin.replace('Top', 'Bottom')
              : e.cutOrigin.replace('Bottom', 'Top')
          }
          if (
            ncSetting.trimSide === 'topRight' &&
            !ncSetting.xyReverse &&
            !bigpart.parts[0].is_high_gloss_plank
          ) {
            if (e.path) {
              e.path = e.path.map((pathItem) => {
                pathItem = pathItem.map((point) => {
                  point.y = toDecimal(
                    e.rect.height - point.y,
                    ncSetting.decimal
                  )
                  return point
                })
                return pathItem
              })
            }

            if (e.holes && e.holes.length) {
              e.holes = e.holes.map((point) => {
                point.center.y = toDecimal(
                  e.rect.height - point.center.y,
                  ncSetting.decimal
                )
                point.ocenter.y = toDecimal(
                  e.oRect.height - point.ocenter.y,
                  ncSetting.decimal
                )
                return point
              })
            }
            if (e.slots && e.slots.length) {
              e.slots = e.slots.map((point) => {
                if (point.pt1.y !== point.pt2.y) {
                  point.pt1.y = toDecimal(
                    e.rect.height - point.pt1.y,
                    ncSetting.decimal
                  )
                  point.pt2.y = toDecimal(
                    e.rect.height - point.pt2.y,
                    ncSetting.decimal
                  )
                  point.opt1.y = toDecimal(
                    e.oRect.height - point.opt1.y,
                    ncSetting.decimal
                  )
                  point.opt2.y = toDecimal(
                    e.oRect.height - point.opt2.y,
                    ncSetting.decimal
                  )
                } else {
                  point.pt1.x = toDecimal(
                    e.rect.width - point.pt1.x,
                    ncSetting.decimal
                  )
                  point.pt2.x = toDecimal(
                    e.rect.width - point.pt2.x,
                    ncSetting.decimal
                  )
                  point.opt1.x = toDecimal(
                    e.oRect.width - point.opt1.x,
                    ncSetting.decimal
                  )
                  point.opt2.x = toDecimal(
                    e.oRect.width - point.opt2.x,
                    ncSetting.decimal
                  )
                }
                return point
              })
            }
            if (e.millInfo && e.millInfo.length) {
              e.millInfo = e.millInfo.map((millInfoItem) => {
                millInfoItem.shape = millInfoItem.shape.map((point) => {
                  point.y = toDecimal(
                    e.rect.height - point.y,
                    ncSetting.decimal
                  )
                  return point
                })
                return millInfoItem
              })
            }
            if (e.curveHoles && e.curveHoles.length) {
              e.curveHoles = e.curveHoles.map((curveHItem) => {
                curveHItem.path = curveHItem.path.map((point) => {
                  point.y = toDecimal(
                    e.rect.height - point.y,
                    ncSetting.decimal
                  )
                  return point
                })
                return curveHItem
              })
            }
          } else if (
            ncSetting.trimSide === 'bottomLeft' &&
            !ncSetting.xyReverse &&
            !bigpart.parts[0].is_high_gloss_plank
          ) {
            if (e.path) {
              e.path = e.path.map((pathItem) => {
                pathItem = pathItem.map((point) => {
                  point.x = toDecimal(e.rect.width - point.x, ncSetting.decimal)
                  return point
                })
                return pathItem
              })
            }

            if (e.holes && e.holes.length) {
              e.holes = e.holes.map((point) => {
                point.center.x = toDecimal(
                  e.rect.width - point.center.x,
                  ncSetting.decimal
                )
                point.ocenter.x = toDecimal(
                  e.oRect.width - point.ocenter.x,
                  ncSetting.decimal
                )
                return point
              })
            }
            if (e.slots && e.slots.length) {
              e.slots = e.slots.map((point) => {
                point.pt1.x = toDecimal(
                  e.rect.width - point.pt1.x,
                  ncSetting.decimal
                )
                point.pt2.x = toDecimal(
                  e.rect.width - point.pt2.x,
                  ncSetting.decimal
                )
                point.opt1.x = toDecimal(
                  e.oRect.width - point.opt1.x,
                  ncSetting.decimal
                )
                point.opt2.x = toDecimal(
                  e.oRect.width - point.opt2.x,
                  ncSetting.decimal
                )
                return point
              })
            }
            if (e.millInfo && e.millInfo.length) {
              e.millInfo = e.millInfo.map((millInfoItem) => {
                millInfoItem.shape = millInfoItem.shape.map((point) => {
                  point.x = toDecimal(e.rect.width - point.x, ncSetting.decimal)
                  return point
                })
                return millInfoItem
              })
            }
            if (e.curveHoles && e.curveHoles.length) {
              e.curveHoles = e.curveHoles.map((curveHItem) => {
                curveHItem.path = curveHItem.path.map((point) => {
                  point.x = toDecimal(e.rect.width - point.x, ncSetting.decimal)
                  return point
                })
                return curveHItem
              })
            }
          } else if (ncSetting.trimSide === 'topLeft' && !ncSetting.xyReverse) {
            if (e.path) {
              e.path = e.path.map((pathItem) => {
                pathItem = pathItem.map((point) => {
                  point.y = toDecimal(
                    e.rect.height - point.y,
                    ncSetting.decimal
                  )
                  point.x = toDecimal(e.rect.width - point.x, ncSetting.decimal)
                  return point
                })
                return pathItem
              })
            }

            if (e.holes && e.holes.length) {
              e.holes = e.holes.map((point) => {
                point.center.y = toDecimal(
                  e.rect.height - point.center.y,
                  ncSetting.decimal
                )
                point.center.x = toDecimal(
                  e.rect.width - point.center.x,
                  ncSetting.decimal
                )
                point.ocenter.y = toDecimal(
                  e.oRect.height - point.ocenter.y,
                  ncSetting.decimal
                )
                point.ocenter.x = toDecimal(
                  e.oRect.width - point.ocenter.x,
                  ncSetting.decimal
                )
                return point
              })
            }
            if (e.slots && e.slots.length) {
              e.slots = e.slots.map((point) => {
                point.pt1.y = toDecimal(
                  e.rect.height - point.pt1.y,
                  ncSetting.decimal
                )
                point.pt2.y = toDecimal(
                  e.rect.height - point.pt2.y,
                  ncSetting.decimal
                )
                point.pt1.x = toDecimal(
                  e.rect.width - point.pt1.x,
                  ncSetting.decimal
                )
                point.pt2.x = toDecimal(
                  e.rect.width - point.pt2.x,
                  ncSetting.decimal
                )
                point.opt1.y = toDecimal(
                  e.oRect.height - point.opt1.y,
                  ncSetting.decimal
                )
                point.opt2.y = toDecimal(
                  e.oRect.height - point.opt2.y,
                  ncSetting.decimal
                )
                point.opt1.x = toDecimal(
                  e.oRect.width - point.opt1.x,
                  ncSetting.decimal
                )
                point.opt2.x = toDecimal(
                  e.oRect.width - point.opt2.x,
                  ncSetting.decimal
                )
                return point
              })
            }
            if (e.millInfo && e.millInfo.length) {
              e.millInfo = e.millInfo.map((millInfoItem) => {
                millInfoItem.shape = millInfoItem.shape.map((point) => {
                  point.y = toDecimal(
                    e.rect.height - point.y,
                    ncSetting.decimal
                  )
                  point.x = toDecimal(e.rect.width - point.x, ncSetting.decimal)
                  return point
                })
                return millInfoItem
              })
            }
            if (e.curveHoles && e.curveHoles.length) {
              e.curveHoles = e.curveHoles.map((curveHItem) => {
                curveHItem.path = curveHItem.path.map((point) => {
                  point.y = toDecimal(
                    e.rect.height - point.y,
                    ncSetting.decimal
                  )
                  point.x = toDecimal(e.rect.width - point.x, ncSetting.decimal)
                  return point
                })
                return curveHItem
              })
            }
          }
          if (e.polyArr) {
            dealPlankPoly(e)
          }
        })
      }
    }
  })
}

/**
 * 将多个排版方案处理成每一个单独的方案
 * @param {Object} paibanResult 排版接口返回数据
 */
export function dealAlignedPlan(paibanResult) {
  try {
    const stockKeys = Object.keys(paibanResult)
    if (!stockKeys.length) throw new Error('paibanResult no data')
    // 分解虚拟组合板
    for (const key of stockKeys) {
      const cutItem = paibanResult[key]
      if (cutItem.data) {
        cutItem.data = cutItem.data.map((planData) =>
          decompositePaibanResult(planData)
        )
      }
    }
    // 获取所有方案中排版结果最多的一种材质
    // 以方案数最多的材质为主，按 layoutRank 对齐组合其余材质
    let maxPlanNum = 0
    let mainKey = stockKeys[0]

    Object.entries(paibanResult).forEach(([key, it]) => {
      if (it.data.length > maxPlanNum) {
        maxPlanNum = it.data.length
        mainKey = key
      }
    })
    const mainLayoutRank = paibanResult[mainKey].layoutRank
    const finalResult = []
    for (let index = 0; index < maxPlanNum; index++) {
      const newPlan = {}
      // 主材质当前方案的 rank，其他材质按相同 rank 组合
      const targetRank = mainLayoutRank ? mainLayoutRank[index] : undefined
      stockKeys.forEach((key) => {
        const cutItem = paibanResult[key]
        const {
          data,
          rollCount,
          used_rate,
          stockCount,
          layoutRank,
          deepSearchIdx,
        } = cutItem
        let useIdx = index
        if (key === mainKey) {
          useIdx = index
        } else if (layoutRank && targetRank !== undefined) {
          // 取相同 rank 的方案；没有则取最低等级 rank=1
          useIdx = layoutRank.indexOf(targetRank)
          if (useIdx === -1) {
            useIdx = layoutRank.indexOf(1)
            if (useIdx === -1) useIdx = 0
          }
        } else {
          // 无 layoutRank 时回退为按 index，超出则取最后一个
          const cutMaxLen = data.length - 1
          if (index > cutMaxLen) useIdx = cutMaxLen
        }
        newPlan[key] = {
          data: [data[useIdx]],
          rollCount: [rollCount[useIdx]],
          used_rate: used_rate[useIdx],
          layoutRank: layoutRank ? layoutRank[useIdx] : undefined,
          isDeepSearch: deepSearchIdx
            ? deepSearchIdx.includes(useIdx)
            : undefined,
        }
        if (stockCount) {
          newPlan[key].stockCount = [stockCount[useIdx]]
        } else {
          newPlan[key].stockCount = used_rate.length
        }
      })
      // dealAlignedPlanArea(stockKeys, newPlan, store.state.ncSetting)
      finalResult.push(newPlan)
    }
    return finalResult
  } catch (error) {
    console.error(error)
  }
}

/**
 *
 * @param {*} paibanResult 排版结果
 * @param {*} options 选项
 * @param {*} options.minWidth 最小宽度
 * @param {*} options.minHeight 最小高度
 * @param {*} options.knives 刀具
 * @param {*} options.type 类型
 * @param {*} options.scattered_layout 分散布局
 * 将排版结果中的每个材质的排版结果进行处理，处理成每个材质的排版结果
 */
export function dealPlanksForMatCode(paibanResult, options) {
  const { minWidth, minHeight, knives, type, scattered_layout } = options
  const resultKeys = Object.keys(paibanResult)
  const resultPlansObj = {}
  for (const key of resultKeys) {
    const resultItem = paibanResult[key]
    let resultPlans = dealAlignedPlan({ [key]: resultItem })
    resultPlans.forEach((plan) => {
      checkPlanks(plan, minWidth, minHeight, knives)
    })

    if (resultPlans && resultPlans.length) {
      sortPlans(resultPlans, type, scattered_layout)
      const newList = resultPlans.filter((plan) => !plan.isDeepSearch)
      const bestDeepSearchPlan = resultPlans.find((plan) => plan.isDeepSearch)
      if (newList && bestDeepSearchPlan) {
        newList.splice(1, 0, bestDeepSearchPlan)
      }
      resultPlans = newList
    }

    // 包装 specialId，与更多结果 tab 内方案 id 保持一致
    resultPlansObj[key] = (resultPlans || []).map((plan, idx) => ({
      specialId: `${key}__${idx}`,
      data: plan,
      isGreatPlan: plan.isGreatPlan,
      isDeepSearch: plan.isDeepSearch,
    }))
  }
  return resultPlansObj
}

function dealAlignedPlanArea(stockKeys, paibanData, ncSetting) {
  const { plankHeight, plankWidth } = store.state.selectStandardPlank
  stockKeys.forEach((key) => {
    const cutItem = paibanData[key]
    // 将data数据进行分离
    const separateData = separatePlank(cutItem.data[0])
    separateData.forEach((parts, key) => {
      let specialShape = null
      let area = 0
      // 按照板件进行计算优化率
      parts.forEach((it) => {
        // 特殊板件 余料板件/超大板
        if ((it.surplusInfo || it.otherPlate) && !specialShape) {
          specialShape = it.surplusInfo || it.otherPlate
        }
        // 计算小板面积总和
        area += it.rect.x2 * it.rect.y2
      })
      const plankArea = specialShape
        ? specialShape.width * specialShape.height
        : plankWidth * plankHeight
      // 通过板号找到优化率内对应的板件
      const cutUsedRate = Array.isArray(cutItem.used_rate)
        ? cutItem.used_rate.find((it) => it.stock_num == key)
        : cutItem.used_rate
      cutUsedRate.rate = area / plankArea
    })
  })
}
function separatePlank(partData) {
  if (!partData.length) return
  const partMap = new Map()
  // 将data中的板件数据分离成对应每一个板子的数据
  partData.forEach((part) => {
    if (!partMap.has(part.stockNum)) {
      partMap.set(part.stockNum, [part])
    } else {
      const d = partMap.get(part.stockNum)
      d.push(part)
    }
  })
  return partMap
}

export function checkPointInPart(pt, polygonArr) {
  if (!polygonArr?.length) return
  // true表示孔在板件内 false则相反
  let flag = true
  for (let i = 0; i < polygonArr.length; i++) {
    const polygon = polygonArr[i]
    const isOut = window.ClipperLib.Clipper.PointInPolygon(pt, polygon)
    // 判断孔是否在板外
    if (!i && !isOut) {
      flag = false
      break
    }
    // 判断孔是否在异形轮廓内
    if (i && isOut) {
      flag = false
      break
    }
  }
  return flag
}

/**
 * 处理layoutStart函数所返回的数据用于排版
 * @param {object} val layoutStart函数返回数据
 * @param {Array} needBaseMaterials 可使用的原片数据
 * @param {object} state 偏好设置
 * @param {object} ncSetting nc设置
 * @param {object} store vuex
 * @param {boolean} onlyLayoutTooBig 是否开启特殊大板只排超尺小板
 */
export function dealLayoutResultData(
  val,
  needBaseMaterials,
  state,
  ncSetting,
  store,
  isNewLayout = false,
  onlyLayoutTooBig = false
) {
  const isPreLayout = store.state.ncSetting.isPreLayout
  const result = val.layout
  if (!result) return
  const preData = val.layout.layout_data
  const layoutParam = result.data.layoutRectMap
  const keys = Object.keys(layoutParam)
  for (let i = 0; i < keys.length; ++i) {
    for (let k = 0; k < layoutParam[keys[i]].length; ++k) {
      let part = layoutParam[keys[i]][k]
      // 对纹虚拟板的的数据处理已经在LayoutFuncs.js中处理了，这里找不到对纹虚拟板会意外的删除掉对纹的cutCurve
      if (isVirtualCompositePlank(part)) continue
      const plank = preData.find(
        (e) =>
          (e.ggid && part.ggid && e.ggid === part.ggid) ||
          e.partUniqueId === part.partUniqueId
      )
      if (state?.isSpecialShape && plank?.path) {
        let paths = plank.path
        if (plank.slots?.length) {
          let slots = plank.slots
          paths = dealUnionPathSlots(paths, slots, ncSetting)
        }
        part.cutCurve = [...paths]
        let curvePathList = plank.curveHoles
          ?.filter((it) => compareNumbers(it.deep, plank.thick))
          .map((curve) => curve.path)
        if (curvePathList && curvePathList.length && !!curvePathList[0]) {
          part.cutCurve.push(...curvePathList)
        }
      } else {
        delete part.cutCurve
      }
    }
  }

  result.data.layoutConfig.stationWidth = ncSetting.counter_width
  result.data.layoutConfig.stationLimitable = ncSetting.counter_limit_able
  result.data.layoutConfig.customPlankOrder = state.customPlankOrder
  if (!state.customPlankOrder) {
    if (needBaseMaterials.length) {
      store.commit('setSpecialPlankParams', needBaseMaterials)
      let outSizeMap = {}
      needBaseMaterials.forEach((item) => {
        if (item.isPicked) {
          let key = `${item.color}:${item.matCode}:${item.thick}`
          outSizeMap[key] = {
            width: item.width,
            height: item.height,
            trim_edge: item.trim_edge,
          }
        }
      })
      result.data.layoutConfig.outSizeMap = outSizeMap
      result.data.layoutConfig.otherPlateSize = needBaseMaterials
      // 只要开启了特殊大板上只排超尺小板，那么这个outSizeMap字段的值就不需要了
      if (onlyLayoutTooBig) {
        result.data.layoutConfig.outSizeMap = {}
        // 对用到的所有特殊大板进行分组
        const newGroup = needBaseMaterials.reduce((acc, cur) => {
          // 这里不用cur中的symbol的原因就是因为这里的symbol可能是重复的：：：false/true，即使他们的颜色、材质、厚度不一样
          const symbol = `${cur.color}:${cur.matCode}:${cur.thick}`
          if (!acc[symbol]) {
            acc[symbol] = []
          }
          acc[symbol].push(cur)
          return acc
        }, {})
        // 获取到每一类板件中可以排下所有超尺小板的长边最小的特殊大板
        const otherPlateSize = Object.keys(newGroup).map((k) => {
          newGroup[k].sort((a, b) => {
            const aMax = Math.max(a.width, a.height)
            const bMax = Math.max(b.width, b.height)
            return bMax - aMax
          })
          return newGroup[k][0]
        })
        result.data.layoutConfig.otherPlateSize = otherPlateSize
        // 判断使用的特殊大板是不是默认勾选的，如果是，就需要给outSizeMap赋值
        const pickedPlate = otherPlateSize.find((plate) => plate.isPicked)
        if (pickedPlate) {
          result.data.layoutConfig.outSizeMap = outSizeMap
        }
      }
    }
  } else {
    onlyLayoutTooBig = false
    // 自定义大板有标准大板 不处理outSizeMap
    result.data.layoutConfig.customPlankOrder = state.customPlankOrder
    const standardPlank = state.plankOrderList.find(
      (item) => item.plankType == '标准大板'
    )
    if (standardPlank) {
      result.data.layoutConfig.order = standardPlank.plankOrder
      result.data.layoutConfig.amount = Number(standardPlank.amount)
    } else {
      result.data.layoutConfig.amount = 0
      result.data.layoutConfig.order = -1
    }
    const plateList = state.plankOrderList.filter(
      (item) => item.plankType != '标准大板' && item.amount != '0'
    )
    if (plateList.length) {
      result.data.layoutConfig.otherPlateSize = plateList.map((item) => ({
        color: item.texture,
        height: Number(item.plankSize.split('x')[1]),
        matCode: item.isHighPlank.includes('非')
          ? item.matCode
          : `高光_${item.matCode}`,
        symbol: `${item.matCode}:${item.thick}:${item.thick}`,
        thick: item.thick,
        trim_edge: item.plankEdgeOff,
        width: Number(item.plankSize.split('x')[0]),
        order: item.plankOrder,
        amount: Number(item.amount),
        brandName: item.brandName || '',
        supplierName: item.supplierName || '',
        colorId: item.colorId || '',
      }))
    }
  }
  const safe_length = isPreLayout
    ? store.state.preLayoutSetting.setting_value.movePlankSetting.safe_length
    : ncSetting.movePlankSetting.safe_length ?? [] // 不需要默认值，算法那边给定了默认值
  result.data.layoutConfig.sameWidthPlank =
    ncSetting.sawSetting.mentaoji_enable &&
    ncSetting.sawSetting.sameWidthPlank &&
    ncSetting.sawSetting.sawToLayout &&
    ncSetting.sawSetting.processType === 'weldingPlank'
  result.data.layoutConfig.sawToLayout =
    ncSetting.sawSetting.mentaoji_enable &&
    ncSetting.sawSetting.sawToLayout &&
    ncSetting.sawSetting.processType === 'weldingPlank'
  result.data.layoutConfig.processType = ncSetting.sawSetting.processType
  // TODO:焊接板才使用锯片加工
  result.data.layoutConfig.sawCutOnlyWeld =
    ncSetting.sawSetting.sawCutOnlyWeld &&
    ncSetting.sawSetting.processType === 'weldingPlank'
  result.data.layoutConfig.surplus_position = ncSetting.surplusPosition
  result.data.layoutConfig.trim_side = ncSetting.trimSide
  result.data.layoutConfig.xyReverse = ncSetting.xyReverse ? 1 : 0
  result.data.layoutConfig.sortByHeight = ncSetting.sawSetting.sortByHeight
  result.data.layoutConfig.is_new_layout = isNewLayout
  result.data.layoutConfig.new_cut_sequence = !!ncSetting.movePlankSetting
    ?.strong_suction_zones.length
    ? ncSetting.movePlankSetting.newCutSequence
    : false
  result.data.layoutConfig.strong_suction_zones = ncSetting.movePlankSetting
    ? ncSetting.movePlankSetting.strong_suction_zones
    : [5]
  if (Array.isArray(safe_length) && safe_length.length === 2) {
    result.data.layoutConfig.safe_length = safe_length
  }
  result.data.layoutConfig.scattered_layout =
    (isPreLayout
      ? store.state.preLayoutSetting.setting_value.movePlankSetting
          .scattered_layout
      : ncSetting.movePlankSetting.scattered_layout) ?? false

  result.data.layoutConfig.surplus_no_roll = store.state.isSurplusNoRoll
  result.data.layoutConfig.nesting_version = state.isSpecialShape
    ? state.nesting_version ??
      store.state.preferencesSetting.setting?.nesting_version
    : undefined //异形嵌套方式 普通/高级
  result.data.layoutConfig.onlyLayoutTooBig = onlyLayoutTooBig
  result.data.layoutConfig.margin = store.state.selectStandardPlank.plankEdgeOff
  // 混排的方案中特殊大板的颜色的映射
  result.data.layoutConfig.colorMap = Object.keys(
    store.state.materialListStore.colorMap
  ).length
    ? store.state.materialListStore.colorMap
    : null
  result.data.layoutConfig.isSurNotLayoutMat =
    store.state.preferencesSetting.setting.isSurNotLayout &&
    store.state.preferencesSetting.setting.isSurNotLayoutMat
  if (
    ncSetting.sawSetting.mentaoji_enable &&
    ncSetting.sawSetting.sawToLayout &&
    ncSetting.sawSetting.processType === 'weldingPlank'
  ) {
    result.data.layoutConfig.minSurplusWidthDiff =
      ncSetting.sawSetting.minSurplusWidthDiff
  }
  result.data.layoutConfig.stacking_method =
    store.state?.preferencesSetting?.setting?.stacking_method ?? 'short'
  return {
    result,
    preData,
  }
}

/**
 * 生成排版所需的所有余料数据
 * @param {object} allSurplusList 所有的余料板件数据
 * @returns
 */
export function genSurplusParams(allSurplusList, way = '') {
  /** 当前排版使用的方案 */
  let paibanWay = [way]
  if (!way) {
    paibanWay = store.state.activePaibanWay
  }

  const ncSetting = store.state.ncSetting
  /** 台面宽度 */
  const stationWidth = ncSetting.counter_width
  /** 是否生效台面宽度 */
  const stationLimitable = ncSetting.counter_limit_able
  const surplusObj = {}
  const selectedSurplusArr = []
  for (let i = 0; i < allSurplusList.length; ++i) {
    if (allSurplusList[i].isSelected) {
      selectedSurplusArr.push(allSurplusList[i])
    }
  }

  let surplusLen = selectedSurplusArr.length
  if (surplusLen > 500) {
    selectedSurplusArr.slice(0, 500)
    surplusLen = 500
  }
  let perNum = Math.floor(500 / surplusLen)
  let lastNum = perNum
  for (let i = 0; i < surplusLen; ++i) {
    let surplus = selectedSurplusArr[i]
    let title = `${surplus.color}:${surplus.type}:${surplus.thick}`
    let obj = {
      id: surplus.id,
      width: Number(surplus.width),
      height: Number(surplus.long),
      area: Number(surplus.area),
      ggid: surplus.ggid,
      branch_name: surplus.branch_name,
      // branch_no: surplus.branch_no,
      branch_no: '001',
      from_address: surplus.from_address,
      from_order_num: surplus.from_order_num,
      plankNum: surplus.plankNum,
      surplus_trim_edge: surplus.surplus_trim_edge,
      trimming_method: surplus.trimming_method,
      colorId: Number(surplus.color_id) || '',
      brandName: surplus.brand_name || '',
      supplierName: surplus.supplier_name || '',
      type: surplus.type,
      texDir:
        surplus.texDir == 'notcare' ? 'notcare' : surplus.texDir ?? 'normal',
      highlight_surface: surplus.highlight_surface,
      is_high_gloss_plank: surplus.is_high_gloss_plank,
    }
    if (surplus.isWeldingPlank) {
      obj.isWeldingPlank = surplus.isWeldingPlank
    }

    if (stationLimitable) {
      surplus.stationLimitable = true
      if (!surplus.shape) {
        surplus.path = [
          { x: 0, y: 0 },
          { x: Number(surplus.width), y: 0 },
          { x: Number(surplus.width), y: Number(surplus.long) },
          { x: 0, y: Number(surplus.long) },
          { x: 0, y: 0 },
        ]
      }
    }

    if (surplus.shape == 1 || surplus.shape == 'lshape') {
      let lObj = {}
      if (Reflect.has(surplus, 'x3')) {
        lObj = {
          x3: Number(surplus.min_width),
          y3: Number(surplus.long),
          x4: Number(surplus.min_width),
          y4: Number(surplus.min_long),
          x5: Number(surplus.width),
          y5: Number(surplus.min_long),
          shape: 'lshape',
        }
        surplus.path = [
          { x: 0, y: 0 },
          { x: lObj.x3, y: lObj.y3 },
          { x: lObj.x4, y: lObj.y4 },
          { x: lObj.x5, y: lObj.y5 },
          { x: Number(surplus.width), y: Number(surplus.long) },
          { x: 0, y: Number(surplus.long) },
          { x: 0, y: 0 },
        ]
      } else if (surplus.path && !surplus.path.length) {
        const min_width = surplus.min_width
        const min_long = surplus.min_long
        const width = surplus.width
        const long = surplus.long
        const path = [
          { x: 0, y: 0 },
          { x: min_width, y: 0 },
          { x: min_width, y: long - min_long },
          { x: width, y: long - min_long },
          { x: width, y: long },
          { x: 0, y: long },
          { x: 0, y: 0 },
        ]
        surplus.path = path
      }

      if (surplus.path && surplus.path.length) {
        dealSurplusPathByTrimSide(surplus, ncSetting)
        // 是否是锯切排版余料
        const isUseSawPaiban = judgeSawPaibanSurplus(surplus, ncSetting)
        // 处理为实际生产路径(缺口朝向右上角)
        surplus.path = dealPathToBasePoint(
          flipPath(
            isUseSawPaiban
              ? dealLshapePathForReal(flipPath(surplus.path), surplus)
              : flipPath(surplus.path)
          )
        )
        const isOverStation = surplus.width > stationWidth
        obj.texDir = surplus.texDir
        obj.highlight_surface = surplus.highlight_surface
        obj.oriInfo = window.$copy(surplus)
        const flipPathSurplus = window.$copy(surplus)
        flipPathSurplus.path = dealPathToBasePoint(
          flipPath(flipPathSurplus.path)
        )
        const pathResult =
          isOverStation && stationLimitable
            ? dealSurplusStationWidth(flipPathSurplus, ncSetting)
            : dealPathToBasePoint(flipPath(surplus.path))
        const isPathArr = Array.isArray(pathResult[0])
        const isPathArrLength = pathResult.length > 1
        // 如果路径是数组，则不进行排版
        let newPath = []
        if (!isPathArr) {
          newPath = pathResult
        } else if (!isPathArrLength) {
          newPath = pathResult[0]
        } else {
          continue
        }
        // 把左上角原点处理到左下角进行排版
        lObj.path = dealPathToBasePoint(newPath, false, true)

        // 处理为实际生产路径(缺口朝向右上角)
        // lObj.path = dealLshapePathForReal(lObj.path)
        // 处理为缺口右上的 L 型余料
        if (paibanWay[0].includes('v2')) {
          // lObj.shape = 'specialShape'
          lObj.shape = 'specialShape'
        } else {
          lObj.shape = [6, 7].includes(lObj.path.length)
            ? 'lshape'
            : 'specialShape'
          if (lObj.shape == 'lshape') {
            const rects = dealLShapeToRects(lObj.path)
            lObj.rects = rects
          }
        }
        const rectSize = getWHByPath(lObj.path)
        lObj.height = rectSize.height
        lObj.width = rectSize.width
        if (isOverStation && stationLimitable && paibanWay[0].includes('v2')) {
          lObj.shape = 'specialShape'
          lObj.width = stationWidth
          lObj.height = rectSize.height
        }
      }
      obj = Object.assign(obj, lObj)
    } else if (surplus.shape == 2 && surplus.path && surplus.path.length) {
      // 异形余料处理
      dealSurplusPathByTrimSide(surplus, ncSetting)
      const isOverStation = surplus.width > stationWidth
      obj.texDir = surplus.texDir
      obj.highlight_surface = surplus.highlight_surface
      obj.oriInfo = window.$copy(surplus)

      const flipPathSurplus = window.$copy(surplus)
      flipPathSurplus.path = dealPathToBasePoint(flipPath(flipPathSurplus.path))
      const pathResult =
        isOverStation && stationLimitable
          ? dealSurplusStationWidth(flipPathSurplus, ncSetting)
          : dealPathToBasePoint(flipPath(surplus.path))

      const isPathArr = Array.isArray(pathResult[0])
      const isPathArrLength = pathResult.length > 1
      // 如果路径是数组，则不进行排版
      let newPath = []
      if (!isPathArr) {
        newPath = pathResult
      } else if (!isPathArrLength) {
        newPath = pathResult[0]
      } else {
        continue
      }
      // 把左上角原点处理到左下角进行排版
      obj.path = dealPathToBasePoint(newPath, false, true)
      // 处理为实际生产路径(缺口朝向右上角)
      // obj.path = dealLshapePathForReal(obj.path)
      const rectSize = getWHByPath(obj.path)
      obj.height = rectSize.height
      obj.width = rectSize.width
      if (isOverStation && stationLimitable) {
        obj.width = stationWidth
        obj.height = rectSize.height
      }
      // 处理为缺口右上的 L 型余料
      obj.shape = 'specialShape'
    } else {
      surplus.path = [
        { x: 0, y: 0 },
        { x: surplus.width, y: 0 },
        { x: surplus.width, y: surplus.long },
        { x: 0, y: surplus.long },
        { x: 0, y: 0 },
      ]
      if (
        !judgeSawPaibanSurplus(surplus, ncSetting) &&
        surplus.texDir &&
        surplus.texDir == 'reverse'
      ) {
        rotateSurplus(surplus, 90)
        obj.width = surplus.width
        obj.height = surplus.long
        obj.texDir = 'normal'
      }
      const isOverStation = surplus.width > stationWidth
      obj.oriInfo = window.$copy(surplus)
      if (surplus.path && surplus.path.length) {
        const flipPathSurplus = window.$copy(surplus)
        flipPathSurplus.path = dealPathToBasePoint(
          flipPath(flipPathSurplus.path)
        )
        const pathResult =
          isOverStation && stationLimitable
            ? dealSurplusStationWidth(flipPathSurplus, ncSetting)
            : dealPathToBasePoint(flipPath(surplus.path))
        const isPathArr = Array.isArray(pathResult[0])
        const isPathArrLength = pathResult.length > 1
        // 如果路径是数组，则不进行排版
        let newPath = []
        if (!isPathArr) {
          newPath = pathResult
        } else if (!isPathArrLength) {
          newPath = pathResult[0]
        } else {
          continue
        }
        // 把左上角原点处理到左下角进行排版
        obj.path = dealPathToBasePoint(newPath, false, true)
        const rectSize = getWHByPath(obj.path)
        obj.height = rectSize.height
        obj.width = rectSize.width
        if (isOverStation && stationLimitable) {
          obj.width = stationWidth
          obj.height = rectSize.height
        }
      }
      if (stationLimitable && paibanWay[0].includes('v2')) {
        obj.shape = 'specialShape'
      }
    }
    let amount = Number(surplus.amount)
    if (amount < perNum) {
      lastNum = amount
    } else {
      lastNum = perNum
    }
    if (Number(surplus.showAmount) < lastNum) {
      lastNum = Number(surplus.showAmount)
    }
    let surplusArr = Array(lastNum).fill(obj)
    if (Object.keys(surplusObj).length == 0) {
      surplusObj[title] = surplusArr
    } else {
      let flag = true
      for (let key in surplusObj) {
        if (key == title) {
          flag = false
          surplusObj[key] = [...surplusObj[key], ...surplusArr]
        }
      }
      if (flag) {
        surplusObj[title] = surplusArr
      }
    }
  }
  store.commit('setSurplusObj', surplusObj)
  return surplusObj
}

/**
 * 生成排版接口所需参数
 * @param {*} store
 * @param {*} surplusObj 被处理后的余料数据
 * @param {*} result layoutStart函数返回的数据
 * @returns
 */
export function genPaibanRequestParams(store, surplusObj, result, seed) {
  const { orderInfo, ncSetting, userInfo, preferencesSetting } = store.state
  const defaultMargin = result.data?.layoutConfig?.margin
  const sawSetting = ncSetting.sawSetting || {}

  // TODO wc 锯切排版是否使用锯片排版间隙
  // if (sawSetting.mentaoji_enable && sawSetting.sawToLayout) {
  //   if (
  //     ['paiban', 'paiban_roll'].includes(preferencesSetting.setting?.paibanWay)
  //   ) {
  //     result.data.layoutConfig.gap = sawSetting.sawBoardGap ?? 0
  //   }
  // }
  // 计算每个余料项的修边值
  const getTrimEdge = (item) => {
    // 如果是L形余料、异形余料，不支持四边修边，仅支持标准板修边
    if ([1, 2, 'lshape', 'specialShape'].includes(item.shape))
      return defaultMargin
    // 如果选择直切 或者未使用锯切刀 或者未启用厚度排版 返回标准板修边值
    if (
      !['paiban', 'paiban_roll'].includes(
        preferencesSetting.setting?.paibanWay
      ) ||
      !sawSetting.mentaoji_enable ||
      !sawSetting.sawToLayout ||
      sawSetting.processType !== 'weldingPlank'
    )
      return defaultMargin
    if (item.trimming_method === 'follow') return defaultMargin
    return item.surplus_trim_edge ?? defaultMargin
  }

  for (const [, items] of Object.entries(surplusObj)) {
    for (const item of items) {
      item.surplus_trim_edge = getTrimEdge(item).toString()
      item.test = '测试数据测试数据测试数据'
    }
  }

  return {
    data: {
      count_list: [1],
      cutDirection: ncSetting.cutDirection ?? '逆时针',
      id: orderInfo.order_codes,
      layout_data: JSON.stringify(result.data),
      oids: orderInfo.order_ids,
      surplus: JSON.stringify(surplusObj),
      uid: userInfo.id,
      seed: seed,
    },
    status: 1,
  }
}

/**
 * 根据材质获取当前需要使用的刀径
 * @param {*} stockKey 颜色:材质:厚度
 * @param {*} ncSetting
 */
export function getPlateKnifeDiameter(stockKey, ncSetting) {
  const plate_knife_map = ncSetting.plate_knife_map ?? {}
  let diameter = ncSetting?.knife?.diameter ?? 3
  if (!stockKey) {
    Notification.error({
      title: '错误',
      message: '无法获取板件材质厚度,刀具应用错误,请勿使用此次结果',
    })
    if (ncSetting?.glass_setting) diameter = 0
    return diameter
  }
  if (ncSetting.laser_enable) {
    // 说明开启了激光一体机 不需要匹配不同材质下料刀
    if (ncSetting?.glass_setting) diameter = 0
    return diameter
  }
  stockKey = stockKey.split(':').filter((it) => it)
  let keys = Object.keys(plate_knife_map)
  let priority = 0
  for (const k of keys) {
    const current = plate_knife_map[k]
    const matchObj = matchOriginalPlankknife(
      current,
      {
        matCode: stockKey[1],
        thick: stockKey[2],
      },
      priority
    )
    if (matchObj.result) {
      priority = matchObj.priority
      diameter = matchObj.diameter
    }
    //   let [matCode, thick, is_highlight] = k.split(':').filter((it) => it)
    // // 原片管理选择了高光板需要手动添加 高光_ 字符
    // if (current.is_highlight) {
    //   matCode = '高光_' + matCode
    // }
    // if (
    //   matCode === stockKey[1] &&
    //   thick * 1 === stockKey[2] * 1 &&
    //   is_highlight === stockKey[3]
    // ) {
    //   diameter = current.diameter
    //   break
    // }
  }
  if (ncSetting?.glass_setting) diameter = 0
  return diameter
}

export async function dealLayoutDataToMaterial(isGetLayoutData) {
  let plankList = []
  Vue.prototype.$getByToken(
    '/production/trial_room',
    { is_get_layout_data: isGetLayoutData },
    (res) => {
      if (res.status === 1) {
        if (isGetLayoutData) {
          plankList = res.data.result_data.flat(2)
          store.commit('clearPaibanData')
          store.commit('setPreLayoutData', dealPreLayoutDataLabelID(plankList))
          store.commit('setIsTrialProduct', true)
          store.commit('setFilterMaterialList', null)
          store.commit('setFilterObject', null)
          store.commit('setIsShowSample', false)
          const route = router.currentRoute
          if (route.path !== '/materialList') {
            router.push('/materialList')
            return
          }

          EventBus.$emit(EventBusKey.REFRESH_MATERIAL_LIST)
        }
        store.commit('setTrailProductState', res.data.state)
        return true
      } else {
        Message.error({
          center: true,
          message: res.msg,
        })
        return false
      }
    }
  )
}

export function dealPreLayoutDataLabelID(preLayoutData) {
  // TODO  preLayoutData的labelID的生成  王超
  return preLayoutData
}

export function dealPaibanDataLabelID(paibanData) {
  paibanData.forEach((data) => {
    data.parts.forEach((part, index) => {
      const preData = store.state.prePaibanData.find(
        (p) => p.partUniqueId == part.partUniqueId
      )
      part.labelId = part.labelId
        ? part.labelId
        : preData
        ? dealNumber(index + preData.labelIndexRangeArr[0])
        : ''
    })
  })
  return paibanData
}

export function dealPlankListLabelID(plankList) {
  let maxIndex = 1
  if (plankList) {
    return plankList.map((plank) => {
      return {
        ...plank,
        parts: plank.parts.map((part) => {
          let minIndex = maxIndex
          maxIndex += Number(part.amount) ? Number(part.amount) : 1
          // store.commit('setPlankLableId', minIndex)
          return {
            ...part,
            labelId: dealNumber(minIndex),
            labelIndexRangeArr: [minIndex, maxIndex],
          }
        }),
      }
    })
  } else return []
}
// 需要发送的余料参数
export function setSurplusObj(paibanData, selectedPaibanWay = '') {
  const surplusObj = {}
  const ncSetting = store.state.ncSetting
  const stationLimitable = ncSetting.counter_limit_able
  const stationWidth = ncSetting.counter_width
  for (let i = 0; i < paibanData.length; ++i) {
    const plank = paibanData[i]
    const surplusInfo = deepCopy(plank.surplusInfo)
    if (!surplusInfo) continue

    if (!surplusInfo.shape) {
      surplusInfo.path = [
        { x: 0, y: 0 },
        { x: Number(surplusInfo.width), y: 0 },
        {
          x: Number(surplusInfo.width),
          y: Number(surplusInfo.long ?? surplusInfo.height),
        },
        { x: 0, y: Number(surplusInfo.long ?? surplusInfo.height) },
        { x: 0, y: 0 },
      ]
      if (stationLimitable) {
        surplusInfo.stationLimitable = true
        if (selectedPaibanWay.includes('v2')) {
          surplusInfo.shape = 'specialShape'
        }
      }
    }
    if (
      surplusInfo &&
      !surplusInfo.isNotSurplus &&
      (surplusInfo.shape == 2 ||
        surplusInfo.shape == 'specialShape' ||
        (surplusInfo.path && surplusInfo.path.length) ||
        stationLimitable)
    ) {
      // 异形余料处理
      dealSurplusPathByTrimSide(surplusInfo, ncSetting)
      /** 是否使用锯切排版 */
      const isUseSawPaiban = judgeSawPaibanSurplus(surplusInfo, ncSetting)
      // 处理为实际生产路径(缺口朝向右上角)
      surplusInfo.path = dealPathToBasePoint(
        flipPath(
          isUseSawPaiban
            ? dealLshapePathForReal(flipPath(surplusInfo.path), surplusInfo)
            : flipPath(surplusInfo.path)
        )
      )
      const isOverStation = surplusInfo.width > stationWidth
      surplusInfo.oriInfo = window.$copy(surplusInfo)
      const flipPathSurplus = window.$copy(surplusInfo)
      flipPathSurplus.path = dealPathToBasePoint(flipPath(flipPathSurplus.path))
      const pathResult =
        isOverStation && stationLimitable
          ? dealSurplusStationWidth(flipPathSurplus, ncSetting)
          : dealPathToBasePoint(flipPath(surplusInfo.path))

      const isPathArr = Array.isArray(pathResult[0])
      const isPathArrLength = pathResult.length > 1
      // 如果路径是数组，则不进行排版
      let newPath = []
      if (!isPathArr) {
        newPath = pathResult
      } else if (!isPathArrLength) {
        newPath = pathResult[0]
      } else {
        continue
      }
      // 把左上角原点处理到左下角进行排版
      surplusInfo.path = dealPathToBasePoint(newPath, false, true)
      // 处理为实际生产路径(缺口朝向右上角)
      // obj.path = dealLshapePathForReal(obj.path)
      if (isOverStation && stationLimitable) {
        surplusInfo.width = stationWidth
        surplusInfo.height = getWHByPath(surplusInfo.path).height
        surplusInfo.shape = 'specialShape'
      }
    }
    if (selectedPaibanWay) {
      if (surplusInfo.path) {
        const isOverStation = surplusInfo.width > stationWidth
        if ([6, 7].includes(surplusInfo.path.length)) {
          if (['paiban', 'paiban_roll'].includes(selectedPaibanWay)) {
            surplusInfo.shape = 'lshape'
            const rects = dealLShapeToRects(surplusInfo.path)
            surplusInfo.rects = rects
            // const res = dealLshapeTurnPoints(surplusInfo.path)
            // Object.assign(surplusInfo, res)
            // Reflect.deleteProperty(surplusInfo, 'path')
          } else {
            surplusInfo.shape = 'specialShape'
          }
        } else {
          if (!surplusInfo.isNotSurplus) {
            if (selectedPaibanWay.includes('v2')) {
              surplusInfo.shape = 'specialShape'
            } else {
              surplusInfo.shape = 'normal'
            }
          }
        }
        if (
          isOverStation &&
          stationLimitable &&
          selectedPaibanWay.includes('v2')
        ) {
          surplusInfo.shape = 'specialShape'
          surplusInfo.width = stationWidth
          surplusInfo.height = getWHByPath(surplusInfo.path).height
        }
      }
    }
    if (
      surplusInfo &&
      Object.keys(surplusInfo).length > 0 &&
      !surplusInfo.isNotSurplus
    ) {
      if (plank.isWeldingPlank) {
        surplusInfo.isWeldingPlank = plank.isWeldingPlank
      }
      let title = `${surplusInfo?.origin_color || plank.texture}:${
        plank.matCode
      }:${plank.thick}`
      if (surplusObj[title]) {
        surplusObj[title].push(surplusInfo)
      } else {
        surplusObj[title] = [surplusInfo]
      }
    }
  }
  return surplusObj
}

// 获取新的NC设置
export async function fetchNewNCSetting() {
  if (store.state.ncSetting) {
    let ncParams = {
      setting_id: store.state.ncSetting.process_setting_id,
    }
    if (window.sessionStorage.getItem('thinkerx_material')) {
      ncParams.production_from = 'guimen'
    }
    const nc = ncParams.setting_id
      ? await fetchGetProductionNcSetting(ncParams)
      : {
          data: dealPreLayoutSetting(
            (await getPrelayoutSetting()).data.setting_value
          ),
        }
    let standardPlank =
      JSON.stringify(store.state.selectStandardPlank) != '{}'
        ? store.state.selectStandardPlank
        : nc.data.panelSize
    nc.data.drawPlankWidth = nc.data.xyReverse
      ? standardPlank.plankHeight
      : standardPlank.plankWidth
    nc.data.drawPlankHeight = nc.data.xyReverse
      ? standardPlank.plankWidth
      : standardPlank.plankHeight
    nc.data.drawPlankEdgeOff = standardPlank.plankEdgeOff
    let ncSetting = Object.assign(nc.data, {
      process_setting_id: store.state.ncSetting.process_setting_id,
      process_setting_name: store.state.ncSetting.process_setting_name,
    })
    store.commit('setNcSetting', ncSetting)
    store.commit('setMergeFolderSetting', null)
    return ncSetting
  }
}
// 检查大板修边是否改变
export function checkPlankEdgeHasChanged(baseMaterialData) {
  return new Promise(async (resolve) => {
    // 历史记录 大板都没有margin-修边值时，不进行检测
    if (
      store.state.isHistoryStatus &&
      store.state.paibanData.every((item) => !item.hasOwnProperty('margin'))
    ) {
      resolve(true)
      return
    }
    let hasChangedPlankEdgeOff = false
    let defaultPlankList
    if (Array.isArray(baseMaterialData.defaultPlankInfo)) {
      defaultPlankList = baseMaterialData.defaultPlankInfo
    } else {
      defaultPlankList = [baseMaterialData.defaultPlankInfo]
    }
    // 新增了余料修边之后，余料修边可以不用标准板的修边，所以还需要排除余料板，找到标准板
    let standardPlank = store.state.paibanData.find(
      (item) => !item.otherPlate && !item.surplusInfo
    )
    let specialPlank = store.state.paibanData.filter(
      (item) => item.otherPlate && Object.keys(item.otherPlate).length
    )
    if (
      standardPlank &&
      Object.hasOwnProperty.call(standardPlank, 'standardPlankId')
    ) {
      defaultPlankList.forEach((item) => {
        if (
          item?.standard_plank_id == standardPlank?.standardPlankId &&
          item?.plankEdgeOff != standardPlank?.margin
        ) {
          hasChangedPlankEdgeOff = true
        }
      })
    }
    if (
      specialPlank &&
      specialPlank.length &&
      baseMaterialData.specialPlankInfo &&
      baseMaterialData.specialPlankInfo.length
    ) {
      specialPlank.forEach((item) => {
        baseMaterialData.specialPlankInfo.forEach((specialItem) => {
          const itemIsBrand = isBrandRecord(item.otherPlate)
          const specialItemIsBrand = isBrandRecord(specialItem)
          // 品牌大板与普通特殊大板互不比对
          if (itemIsBrand !== specialItemIsBrand) return
          if (itemIsBrand) {
            // 品牌大板无 id，按 color_id 匹配；双方都无 color_id 时跳过，避免误匹配
            const itemColorId = getBrandIdentity(item.otherPlate).colorId
            const specialColorId = getBrandIdentity(specialItem).colorId
            if (!itemColorId || !specialColorId) return
            if (
              itemColorId == specialColorId &&
              item.otherPlate?.trim_edge !=
                fourTrimEdge(specialItem?.trim_edge, store.state.ncSetting) &&
              item.plankWidth === specialItem?.width &&
              item.plankHeight === specialItem?.height &&
              item.thick === specialItem?.thick
            ) {
              hasChangedPlankEdgeOff = true
            }
            return
          }
          // 普通特殊大板按 id 匹配：自定义排序后的特殊大板无 id，跳过避免 undefined == undefined 误匹配
          if (!item.otherPlate?.id || !specialItem?.id) return
          if (
            item.otherPlate?.id == specialItem?.id &&
            item.otherPlate?.trim_edge !=
              fourTrimEdge(specialItem?.trim_edge, store.state.ncSetting)
          ) {
            hasChangedPlankEdgeOff = true
          }
        })
      })
    }
    if (hasChangedPlankEdgeOff) {
      store.state.isDownloadingNc = false
      // '系统检测到存在大板的修边被修改，请重新排版确保生产准确'
      const dom = translate('common.edgeCheck')
      const confirm = Vue.prototype.$antdConfirm({
        // '温馨提示'
        title: translate('common.warmTip'),
        content: dom,
        // '我知道了'
        okText: translate('common.iKnow'),
        cancelText: '',
        centered: true,
        closable: true,
        cancelButtonProps: {
          style: { display: 'none' },
        },
        onOk: () => {
          if (confirm) confirm.destroy()
          return
        },
        onCancel: () => {
          if (confirm) confirm.destroy()
          return
        },
      })
      resolve(false)
    } else {
      resolve(true)
    }
  })
}

export function checkDesMaterialNoCut() {
  return new Promise(async (resolve) => {
    if (!store.state.ncSetting.process_setting_id) {
      resolve(true)
      return
    }
    let oriLine = store.state.proLineList.find(
      (item) => item.id === store.state.ncSetting.process_setting_id
    ).data
    if (store.state.isHistoryStatus) {
      if (
        store.state.historyOrder.plank_info.is_des_material_no_cut === undefined
      ) {
        resolve(true)
        return
      }
      oriLine = {
        is_des_material_no_cut:
          store.state.historyOrder.plank_info.is_des_material_no_cut,
        material_keywords_list:
          store.state.historyOrder.plank_info.material_keywords_list,
      }
    }
    Vue.prototype.$getByToken('/get_production_line_setting', '', (res) => {
      if (res.status == 1) {
        const currentLine = res.data.find(
          (item) => item.id === store.state.ncSetting.process_setting_id
        ).data
        if (
          oriLine.is_des_material_no_cut !==
            currentLine.is_des_material_no_cut ||
          JSON.stringify(oriLine.material_keywords_list) !==
            JSON.stringify(currentLine.material_keywords_list)
        ) {
          store.state.isDownloadingNc = false
          const dom = Vue.prototype.$translateLang(
            '系统检测到指定小板材质不下料的设置被修改，请重新排版确保生产准确'
          )

          const confirm = Vue.prototype.$antdConfirm({
            // '温馨提示'
            title: translate('common.warmTip'),
            content: dom,
            // '我知道了'
            okText: translate('common.iKnow'),
            cancelText: '',
            centered: true,
            closable: true,
            cancelButtonProps: {
              style: { display: 'none' },
            },
            onOk: () => {
              if (confirm) confirm.destroy()
              return
            },
            onCancel: () => {
              if (confirm) confirm.destroy()
              return
            },
          })
          resolve(false)
        } else {
          resolve(true)
        }
      } else {
        resolve(true)
      }
    })
  })
}

/** 去除板子的异形数据 */
export function dealAllParts(allparts, ncSetting) {
  const newParts = allparts.map((part) => {
    const stockKey = `${part.texture}:${part.matCode}:${part.thick}`
    const knifeDiameter = +getPlateKnifeDiameter(stockKey, ncSetting)
    const newPart = { ...part, plankKnife: knifeDiameter }
    // if (Reflect.has(part, 'curveHoles')) {
    //   Object.assign(newPart, { curveHoles: [] })
    // }
    // if (Reflect.has(part, 'path')) {
    //   Object.assign(newPart, { path: [] })
    // }
    return newPart
  })
  return newParts
}

/** 对比补充异形数据 */
export function compShapeData(allParts, oriAllParts) {
  const newParts = oriAllParts.map((part) => {
    const tempPart = allParts.find((tp) => tp.partUniqueId == part.partUniqueId)
    if (tempPart) {
      Reflect.deleteProperty(tempPart, 'curveHoles')
      Reflect.deleteProperty(tempPart, 'path')
      return Object.assign(part, tempPart)
    } else {
      return part
    }
  })
  return newParts
}

/**
 * @description 对异形或者 L 型余料进行扩张/收缩操作，因为余料缺口处不处理
 * @param {*} offset
 * @param {*} path
 * @returns
 */
export function expandPathBySurplus(offset, path) {
  if (offset === 0) return path
  // 函数内部统一采用逆时针位置，避免出现一些意外的情况
  path = transformPathByDirection(path, 'cck', true)
  // 对原始路径进行扩张/收缩操作
  const expandPathArr = transformPathByDirection(
    expandPath(offset, window.$copy(path))[0],
    'cck'
  )
  /** 在二维数组中获取长度最大的哪一个子数组 */
  const getMaxLengthByArr = (arr) => {
    const lens = arr.map((v) => v.length)
    return arr[lens.indexOf(Math.max(...lens))]
  }
  /** 处理扩张值为负数的情况 */
  const dealNegative = (path, expandPathArr) => {
    // 扩张值为负值，逻辑为： 使用未内缩前的原始路径以及原始路径的外接矩形来求差，得到原始路径的缺口部分，然后再使用已经内缩的路径的外接矩形和原始路径的缺口部分来求差，就可以得到缺口处未内缩的路径
    const [minX, minY, maxX, maxY] = getPathMinMaxPoint(toLowerCasePoint(path))
    const cutPath = transformPathByDirection(
      [
        { X: minX, Y: minY },
        { X: maxX, Y: minY },
        { X: maxX, Y: maxY },
        { X: minX, Y: maxY },
      ],
      'cck',
      true
    )
    // 原始路径和原始路径的外接矩形求差，得到原始路径的缺口部分
    const gapPath = clipperDifference([cutPath], [path]).map((v) =>
      transformPathByDirection(v, 'cck', true)
    )
    const expandPathRect = getPathMinMaxPoint(expandPathArr)
    const cutPath2 = transformPathByDirection(
      [
        { X: expandPathRect[0], Y: expandPathRect[1] },
        { X: expandPathRect[2], Y: expandPathRect[1] },
        { X: expandPathRect[2], Y: expandPathRect[3] },
        { X: expandPathRect[0], Y: expandPathRect[3] },
      ],
      'cck',
      true
    )
    return clipperDifference([cutPath2], gapPath)
  }
  /** 处理扩张值为正数的情况 */
  const dealPositive = (path, expandPathArr) => {
    // 扩张值为正值，逻辑为： 使用已经扩张后的路径以及扩张路径的外接矩形求差，得到扩张后路径的缺口部分，然后再将缺口部分扩张一个之前扩张的值，然后再将缺口部分和扩张后路径的外接矩形求差，就能得到缺口处未扩张的路径
    const [minX, minY, maxX, maxY] = getPathMinMaxPoint(expandPathArr)
    const cutPath = transformPathByDirection(
      [
        { X: minX, Y: minY },
        { X: maxX, Y: minY },
        { X: maxX, Y: maxY },
        { X: minX, Y: maxY },
      ],
      'cck',
      true
    )
    // 扩张后的外接矩形和扩张后的图形来求差
    const gapPath = clipperDifference(
      [cutPath],
      [toUpperCasePoint(expandPathArr)]
    ).map((v) => transformPathByDirection(v, 'cck', true))
    // 将缺口处扩张，再来和扩张后的外接矩形求差得到缺口处未扩张的路径
    const nGapPath = gapPath.map((v) =>
      transformPathByDirection(
        toUpperCasePoint(
          getMaxLengthByArr(expandPath(offset, window.$copy(v)))
        ),
        'cck',
        true
      )
    )
    const result = clipperDifference([cutPath], nGapPath)
    return result
  }
  const result =
    offset < 0
      ? dealNegative(path, expandPathArr)
      : dealPositive(path, expandPathArr)
  return getMaxLengthByArr(result)
}

/**
 * @description 处理 L 型余料路径为矩形
 * @param {*} path 路径数组
 * @returns 返回矩形数组
 */
export function dealLShapeToRects(path) {
  // const rects = []
  const xArr = path.map((point) => point.x)
  const yArr = path.map((point) => point.y)
  const minX = Math.min(...xArr)
  const minY = Math.min(...yArr)
  const maxX = Math.max(...xArr)
  const maxY = Math.max(...yArr)
  const mx = xArr.find((x) => x > minX && x < maxX)
  const my = yArr.find((y) => y > minY && y < maxY)
  const midX = mx ? mx : maxX
  const midY = my ? my : maxY
  const rects = [
    [{ x: 0, y: 0, width: 100, height: 100 }, {}],
    [{}, {}],
  ]
  // 先检查 L 型的缺口朝向
  /** 缺口朝向 */
  const gapDir = getLShapeGapDir(path)
  if (gapDir === 'topLeft') {
    // 横向拆分两个矩形
    rects[0] = [
      { x: midX, y: midY, width: maxX - midX, height: maxY - midY },
      { x: minX, y: minY, width: maxX - minX, height: midY - minY },
    ]
    // 纵向拆分两个矩形
    rects[1] = [
      { x: minX, y: minY, width: midX - minX, height: midY - minY },
      { x: midX, y: minY, width: maxX - midX, height: maxY - minY },
    ]
  } else if (gapDir === 'bottomLeft') {
    rects[0] = [
      { x: minX, y: midY, width: maxX - minX, height: maxY - midY },
      { x: midX, y: minY, width: maxX - midX, height: midY - minY },
    ]
    rects[1] = [
      { x: minX, y: midY, width: midX - minX, height: maxY - midY },
      { x: midX, y: minY, width: maxX - midX, height: maxY - minY },
    ]
  } else if (gapDir === 'bottomRight') {
    rects[0] = [
      { x: minX, y: midY, width: maxX - minX, height: maxY - midY },
      { x: minX, y: minY, width: midX - minX, height: midY - minY },
    ]
    rects[1] = [
      { x: minX, y: minY, width: midX - minX, height: maxY - minY },
      { x: midX, y: midY, width: maxX - midX, height: maxY - midY },
    ]
  } else {
    // 横向拆分两个矩形
    rects[0] = [
      { x: minX, y: minY, width: maxX - minX, height: midY - minY },
      { x: minX, y: midY, width: midX - minX, height: maxY - midY },
    ]
    // 纵向拆分两个矩形
    rects[1] = [
      { x: minX, y: minY, width: midX - minX, height: maxY - minY },
      { x: midX, y: minY, width: maxX - midX, height: midY - minY },
    ]
  }
  return rects
}

/**
 * @description 获取 L 型余料路径的缺口朝向
 * @param {*} path 路径数组
 * @returns 返回缺口朝向字符串，topLeft、topRight、bottomLeft、bottomRight
 */
export function getLShapeGapDir(path) {
  const xArr = path.map((point) => point.x)
  const yArr = path.map((point) => point.y)
  const minX = Math.min(...xArr)
  const minY = Math.min(...yArr)
  const maxX = Math.max(...xArr)
  const maxY = Math.max(...yArr)

  /** 外接矩形的 4 个顶点坐标 */
  const rectPoints = [
    { x: minX, y: minY, name: 'bottomLeft' }, // 左下
    { x: maxX, y: minY, name: 'bottomRight' }, // 右下
    { x: maxX, y: maxY, name: 'topRight' }, // 右上
    { x: minX, y: maxY, name: 'topLeft' }, // 左上
  ]

  /** 判断 path 中缺少哪个顶点 */
  for (const rectPoint of rectPoints) {
    // 检查 path 中是否存在与该顶点匹配的点（允许浮点数误差）
    const exists = path.some(
      (point) =>
        compareNumbers(point.x, rectPoint.x, '=', 0.1) &&
        compareNumbers(point.y, rectPoint.y, '=', 0.1)
    )
    // 如果不存在，则说明缺少该顶点
    if (!exists) {
      return rectPoint.name
    }
  }

  // 如果所有顶点都存在，返回 null 或抛出错误（L 型应该缺少一个顶点）
  return null
}

/**
 * @description 处理 L 型余料路径为实际生产路径(缺口朝向右上角)
 * @param {*} path 路径数组
 * @returns 处理后的路径数组
 */
export function dealLshapePathForReal(path, surplus) {
  const highGlossSideMap = {
    2: 1,
    1: 2,
  }
  /** 返回结果路径 */
  let resPath = JSON.parse(JSON.stringify(path))
  /** 得到 L 型余料路径的缺口朝向 */
  const gapDir = getLShapeGapDir(path)
  if (gapDir === 'topLeft') {
    // 如果是缺左上角 path 进行左右翻转
    resPath = rolloverPath(resPath)
    surplus.highlight_surface = highGlossSideMap[surplus.highlight_surface]
  } else if (gapDir === 'bottomLeft') {
    // 如果是缺左下角 path 进行180度旋转
    resPath = rotatePath(resPath, 180)
  } else if (gapDir === 'bottomRight') {
    // 如果是缺右下角 path 进行上下翻转
    resPath = flipPath(resPath)
    surplus.highlight_surface = highGlossSideMap[surplus.highlight_surface]
  }

  // 最后全部路径处理到原点
  resPath = dealPathToBasePoint(resPath)
  surplus.path = dealPathToBasePoint(flipPath(resPath))
  return resPath
}

/** 旋转余料，改变余料的 path、纹理 */
export function rotateSurplus(surplus, angle) {
  const { path } = surplus
  surplus.path = dealPathToBasePoint(rotatePath(path, angle))
  // 计算是否 180 度的倍数
  const is180Multiple = angle % 180 === 0
  if (!is180Multiple) {
    const width = window.$copy(surplus.width)
    surplus.width = window.$copy(surplus.height ?? surplus.long)
    surplus.height = width
    surplus.long = width
    if (surplus.texDir === 'reverse') {
      surplus.texDir = 'normal'
    } else if (surplus.texDir === 'normal') {
      surplus.texDir = 'reverse'
    }
    surplus.rotateDeg = angle
  }
}

export function judgeSawPaibanSurplus(surplus, ncSetting) {
  const oriInfo = surplus.oriInfo
  const paibanWay = store.state.activePaibanWay[0]
  const matCode = oriInfo ? oriInfo.type : surplus.type
  const isWildingMatCode = matCode.includes('焊接')
  const sawToLayout =
    ncSetting.sawSetting.mentaoji_enable &&
    ncSetting.sawSetting.sawToLayout &&
    ncSetting.sawSetting.processType === 'weldingPlank'

  // 焊接板才使用锯片加工
  const sawCutOnlyWeld =
    ncSetting.sawSetting.sawCutOnlyWeld &&
    ncSetting.sawSetting.processType === 'weldingPlank'

  if (
    !paibanWay.includes('v2') ||
    (sawToLayout && sawCutOnlyWeld && isWildingMatCode)
  ) {
    return true
  }
  return false
}

/**
 * @description 根据生产线 NC 设置的大板修边方向处理路径
 * @param {*} surplus 路径数组
 * @param {*} ncSetting 生产线 NC 设置
 * @returns 处理后的路径数组
 */
export function dealSurplusPathByTrimSide(surplus, ncSetting) {
  if (judgeSawPaibanSurplus(surplus, ncSetting)) {
    return
  }
  /** 旋转 90 度角方向 */
  const rotateCornerDir = (dir) => {
    switch (dir) {
      case 'topRight':
        return 'bottomRight'
      case 'bottomLeft':
        return 'topLeft'
      case 'bottomRight':
        return 'bottomLeft'
      case 'topLeft':
        return 'topRight'
    }
  }
  /** 翻面 后角边方向 */
  const rolloverCornerDir = (dir) => {
    switch (dir) {
      case 'topRight':
        return 'topLeft'
      case 'bottomLeft':
        return 'bottomRight'
      case 'bottomRight':
        return 'bottomLeft'
      case 'topLeft':
        return 'topRight'
    }
  }
  const { width, height, long } = surplus
  if (Reflect.has(surplus, 'x3')) {
    surplus.path = [
      { x: 0, y: 0 },
      { x: surplus.x3, y: surplus.y3 },
      { x: surplus.x4, y: surplus.y4 },
      { x: surplus.x5, y: surplus.y5 },
      { x: width, y: height ?? long },
      { x: 0, y: height ?? long },
    ]
  }

  /** 生产线 NC 设置 */
  const { trimSide, highgloss_direction, counter_width, counter_limit_able } =
    ncSetting

  if (surplus.texDir && surplus.texDir == 'reverse') {
    rotateSurplus(surplus, 90)
  }
  const { shape, is_high_gloss_plank, highlight_surface } = surplus

  /** 转为可用高光面数据 */
  const highGlossSideMap = {
    front: 1,
    back: 2,
  }

  /** 高光面翻面处理 */
  const rollOverMap = {
    1: 2,
    2: 1,
  }

  // 如果是有高光板，并且高光板方向与设置的高光面方向不一致，则进行翻面处理
  if (
    is_high_gloss_plank &&
    highlight_surface &&
    highGlossSideMap[highgloss_direction] !== highlight_surface
  ) {
    surplus.path = dealPathToBasePoint(rolloverPath(surplus.path))
    surplus.highlight_surface = rollOverMap[surplus.highlight_surface]
  }

  /** 余料形状 */
  const surplusShape = [1, 'lshape'].includes(shape)
    ? 'lshape'
    : [2, 'specialShape'].includes(shape) ||
      (surplus.path && surplus.path.length > 7)
    ? 'specialShape'
    : 'rect'

  if (
    surplusShape === 'rect' ||
    !shape ||
    (surplus.path && surplus.path.length < 6)
  )
    return

  const { cornerSegments } = getPathCornerEdge(surplus.path)

  /** 计算线段长度 */
  const calcSegmentLength = (segment) => {
    if (segment.type === 'horizontal')
      return Math.abs(segment.start.x - segment.end.x)
    if (segment.type === 'vertical')
      return Math.abs(segment.start.y - segment.end.y)
  }
  /** 左上角 */
  const topLeftCorner = cornerSegments.topLeft.map((segment) =>
    calcSegmentLength(segment)
  )
  /** 右上角 */
  const topRightCorner = cornerSegments.topRight.map((segment) =>
    calcSegmentLength(segment)
  )
  /** 左下角 */
  const bottomLeftCorner = cornerSegments.bottomLeft.map((segment) =>
    calcSegmentLength(segment)
  )
  /** 右下角 */
  const bottomRightCorner = cornerSegments.bottomRight.map((segment) =>
    calcSegmentLength(segment)
  )

  /** 各角边的长度对象 */
  const segmentObj = {
    topLeft: {
      min: Math.min(...(topLeftCorner.length > 0 ? topLeftCorner : [0])),
      max: Math.max(...(topLeftCorner.length > 0 ? topLeftCorner : [0])),
    },
    topRight: {
      min: Math.min(...(topRightCorner.length > 0 ? topRightCorner : [0])),
      max: Math.max(...(topRightCorner.length > 0 ? topRightCorner : [0])),
    },
    bottomLeft: {
      min: Math.min(...(bottomLeftCorner.length > 0 ? bottomLeftCorner : [0])),
      max: Math.max(...(bottomLeftCorner.length > 0 ? bottomLeftCorner : [0])),
    },
    bottomRight: {
      min: Math.min(
        ...(bottomRightCorner.length > 0 ? bottomRightCorner : [0])
      ),
      max: Math.max(
        ...(bottomRightCorner.length > 0 ? bottomRightCorner : [0])
      ),
    },
  }

  // 对角边进行排序，min 最大的排在前面，在相同的 min 中，取较大的 max 值的排在前面，都相同就任意一个角边
  const sortedCorner = Object.keys(segmentObj).sort((a, b) => {
    if (segmentObj[a].min > segmentObj[b].min) {
      return -1
    } else if (segmentObj[a].min < segmentObj[b].min) {
      return 1
    } else {
      if (segmentObj[a].max > segmentObj[b].max) {
        return -1
      } else if (segmentObj[a].max < segmentObj[b].max) {
        return 1
      } else {
        return 0
      }
    }
  })

  /** 最好的角边：min 是最大的，如果有相同的 min，则取较大的 max 的，都相同就任意一个角边 */
  let bestCorner = sortedCorner[0]

  /** 修边方向 */
  const trimSideArr = ['topRight', 'bottomLeft', 'bottomRight', 'topLeft']
  /** 定位方向 */
  const positionDirArr = ['topLeft', 'bottomRight', 'bottomLeft', 'topRight']

  // 针对每个角边处理
  /** 记录处理了几个角边 */
  let hasGetBestCorner = false
  // 修边方向和定位方向一一对应
  // 遍历修边方向得到对应的定位气缸方向，通过不断的旋转、翻转尝试使得最优的角边方向与定位方向一致，得到最终的余料处理结果
  for (let idx = 0; idx < trimSideArr.length; idx++) {
    if (hasGetBestCorner) break
    /** 修边方向项 */
    const trimSideItem = trimSideArr[idx]
    // 通过修边方向来确定定位气缸方向
    if (trimSideItem == trimSide) {
      /** 定位气缸方向 */
      const positionDir = positionDirArr[idx]

      for (let id = 0; id < sortedCorner.length; id++) {
        /** 当前角边 */
        bestCorner = sortedCorner[id]
        if (
          segmentObj[bestCorner].min == 0 ||
          segmentObj[bestCorner].max == 0
        ) {
          continue
        } else {
          /** 是否翻过面处理 */
          let hasRollOver = false
          /** 记录旋转了几次90度 */
          let hasRotateNum = 0

          while (positionDir !== bestCorner) {
            // 无纹理的90度转 有纹理的只能旋转 180 度
            if (!hasRollOver) {
              if (['reverse', 'normal'].includes(surplus.texDir)) {
                rotateSurplus(surplus, 180)
                hasRotateNum += 2
                bestCorner = rotateCornerDir(rotateCornerDir(bestCorner))
              } else {
                rotateSurplus(surplus, 90)
                hasRotateNum++
                bestCorner = rotateCornerDir(bestCorner)
              }
              // 如果转了一圈还是没有找到，则进行翻面处理
              if (hasRotateNum == 4) {
                hasRollOver = true
                hasRotateNum = 0
              }
            } else {
              if (is_high_gloss_plank && highlight_surface) {
                hasGetBestCorner = false
                break
              } else {
                if (hasRotateNum == 0) {
                  surplus.path = rolloverPath(surplus.path)
                  bestCorner = rolloverCornerDir(bestCorner)
                }
                if (counter_limit_able) {
                  if (
                    positionDir == bestCorner &&
                    surplus.width <= counter_width
                  ) {
                    hasGetBestCorner = true
                    break
                  }
                } else {
                  if (positionDir == bestCorner) {
                    hasGetBestCorner = true
                    break
                  }
                }
                if (['reverse', 'normal'].includes(surplus.texDir)) {
                  rotateSurplus(surplus, 180)
                  hasRotateNum += 2
                  bestCorner = rotateCornerDir(rotateCornerDir(bestCorner))
                } else {
                  rotateSurplus(surplus, 90)
                  hasRotateNum++
                  bestCorner = rotateCornerDir(bestCorner)
                }
                if (hasRotateNum == 4) {
                  hasRollOver = false
                  hasRotateNum = 0
                  hasGetBestCorner = false
                  break
                }
              }
            }
          }
          if (positionDir == bestCorner) {
            hasGetBestCorner = true
            // 无纹理的才考虑是否超出工位宽度
            if (
              !['reverse', 'normal'].includes(surplus.texDir) &&
              counter_limit_able &&
              surplus.width > counter_width &&
              !surplus.shape
            ) {
              const overSize = surplus.width - counter_width
              rotateSurplus(surplus, 90)
              const newOverSize = surplus.width - counter_width
              if (newOverSize > overSize) {
                rotateSurplus(surplus, 90)
              }
            }
          }
        }

        if (!hasGetBestCorner) {
          continue
        } else {
          break
        }
      }
    }
  }
}

/**
 * @description 获取路径的外接矩形上的角边
 * @param {Array} path 多边形点位数组，格式为 [{x, y}, ...]
 * @returns {Object} 返回外接矩形转角处的线段情况
 * { boundingRect, edgesOnBoundary, cornerSegments: { topLeft, topRight, bottomRight, bottomLeft } }
 * - boundingRect: 外接矩形
 * - edgesOnBoundary: 在外接矩形边界上的线段
 * - cornerSegments: 角边线段(两条线段组成一个角边)
 * - topLeft: 左上角边线段数组
 * - topRight: 右上角边线段数组
 * - bottomRight: 右下角边线段数组
 * - bottomLeft: 左下角边线段数组
 */
export function getPathCornerEdge(path) {
  const isClosed = checkPathIsClosed(path)
  if (isClosed) {
    path.pop()
  }
  if (!path || path.length < 4) {
    return {
      boundingRect: null,
      edgesOnBoundary: [],
      cornerSegments: {
        topLeft: [],
        topRight: [],
        bottomRight: [],
        bottomLeft: [],
      },
    }
  }

  // 计算外接矩形
  const [minX, minY, maxX, maxY] = getPathMinMaxPoint(path)
  const boundingRect = { minX, minY, maxX, maxY }

  // 定义四个角点
  const corners = {
    topLeft: { x: minX, y: minY },
    topRight: { x: maxX, y: minY },
    bottomRight: { x: maxX, y: maxY },
    bottomLeft: { x: minX, y: maxY },
  }

  /** 精度阈值 */
  const epsilon = 0.001

  /** 判断点是否在边界上 */
  function isPointOnBoundary(point) {
    return (
      Math.abs(point.x - minX) < epsilon ||
      Math.abs(point.x - maxX) < epsilon ||
      Math.abs(point.y - minY) < epsilon ||
      Math.abs(point.y - maxY) < epsilon
    )
  }

  /** 判断线段是否在外接矩形边界上 */
  function isSegmentOnBoundary(p1, p2) {
    /** 判断是否为水平线段 */
    const isHorizontal = Math.abs(p1.y - p2.y) < epsilon
    /** 判断是否为垂直线段 */
    const isVertical = Math.abs(p1.x - p2.x) < epsilon

    if (!isHorizontal && !isVertical) {
      return false // 不是横竖线段
    }

    // 水平线段：检查是否在顶边或底边上
    if (isHorizontal) {
      const y = p1.y
      return (
        (Math.abs(y - minY) < epsilon || Math.abs(y - maxY) < epsilon) &&
        isPointOnBoundary(p1) &&
        isPointOnBoundary(p2)
      )
    }

    // 垂直线段：检查是否在左边或右边上
    if (isVertical) {
      const x = p1.x
      return (
        (Math.abs(x - minX) < epsilon || Math.abs(x - maxX) < epsilon) &&
        isPointOnBoundary(p1) &&
        isPointOnBoundary(p2)
      )
    }

    return false
  }

  // 判断线段是否经过某个角点
  function segmentPassesCorner(p1, p2, corner) {
    const dist1 = Math.sqrt(
      Math.pow(p1.x - corner.x, 2) + Math.pow(p1.y - corner.y, 2)
    )
    const dist2 = Math.sqrt(
      Math.pow(p2.x - corner.x, 2) + Math.pow(p2.y - corner.y, 2)
    )
    return dist1 < epsilon || dist2 < epsilon
  }

  /** 在外接矩形边界上的线段 */
  const edgesOnBoundary = []
  /** 角边线段 */
  const cornerSegments = {
    bottomLeft: [],
    bottomRight: [],
    topRight: [],
    topLeft: [],
  }

  // 遍历路径的每条边
  for (let i = 0; i < path.length; i++) {
    const p1 = path[i]
    const p2 = path[(i + 1) % path.length] // 闭合路径

    // 在外接矩形上就存起来
    if (isSegmentOnBoundary(p1, p2)) {
      edgesOnBoundary.push({
        start: p1,
        end: p2,
        index: i,
      })

      // 检查每条边界线段是否经过四个角点
      Object.keys(corners).forEach((cornerKey) => {
        // 如果经历角点就存起来
        if (segmentPassesCorner(p1, p2, corners[cornerKey])) {
          const isHorizontal = Math.abs(p1.y - p2.y) < epsilon
          // 存起来
          cornerSegments[cornerKey].push({
            start: p1,
            end: p2,
            index: i,
            type: isHorizontal ? 'horizontal' : 'vertical',
          })
        }
      })
    }
  }

  return {
    boundingRect,
    edgesOnBoundary,
    cornerSegments,
  }
}

/**
 * @description 余料宽度超出工位宽度时，按工位宽沿 X 裁切 path
 * 开启 counter_limit_able 且 surplus.width > counter_width 时，用 Clipper 取与工位矩形的交集；
 * 起点在右侧则保留右侧条带，否则保留左侧。未超宽或未开启限制时返回原 path。
 * @param {*} surplus 余料（会写回 surplus.width = stationWidth）
 * @param {*} ncSetting 含 counter_width / startPosition / counter_limit_able
 * @returns {Array|Array[]} 单段 path，或裁切后的多段 path 数组
 */
export function dealSurplusStationWidth(surplus, ncSetting) {
  const { width } = surplus
  const path = surplus.path
  const { counter_width, startPosition, counter_limit_able } = ncSetting
  /** 工位宽度上限 */
  const stationWidth = counter_width

  // 未开启工位宽限制：不裁切，原样返回
  if (!counter_limit_able) {
    return path
  }

  // 已开启限制但未超宽：无需处理（调用方通常已判断超宽，此处兜底）
  if (width <= stationWidth) {
    return path
  }

  const isRight = startPosition.includes('右')
  // 超宽：宽度收束到工位宽，按定位起点左右裁切，可能得到多段轮廓
  return getPathBySplitXWithClipper(
    path,
    isRight ? width - stationWidth : stationWidth,
    isRight
  )
}

/**
 * @description 处理 L 型余料转角处的点位，使其符合实际生产路径(缺口朝向右上角)
 * @param {*} path 处理 L 型余料转角处的点位，使其符合实际生产路径(缺口朝向右上角)
 * @returns
 */
export function dealLshapeTurnPoints(path) {
  const {
    longestHorizontalEdge,
    longestVerticalEdge,
    secondLongestHorizontalEdge,
    secondLongestVerticalEdge,
  } = getEdgeLengthsFromLShape(path)
  const maxX = toDecimal(longestHorizontalEdge.size, 2)
  const maxY = toDecimal(longestVerticalEdge.size, 2)
  const midX = toDecimal(secondLongestHorizontalEdge.size, 2)
  const midY = toDecimal(secondLongestVerticalEdge.size, 2)

  return {
    x3: midX,
    y3: maxY,
    x4: midX,
    y4: midY,
    x5: maxX,
    y5: midY,
  }
}
